import { jsxs as n, jsx as t } from "react/jsx-runtime";
function c({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm0 16h14V5H5v14Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M15 12h2v5h-5v-2h3v-3ZM12 9H9v3H7V7h5v2Z" })
      ]
    }
  );
}
function o({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 5h14c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2Zm0 12h14V7H5v10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function d({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 19a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14Zm0-2h-9V7h9v10ZM8 7H5v10h3V7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function v({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 19a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14Zm0-2h-3V7h3v10ZM14 7H5v10h9V7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function a({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 19a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16Zm0-2h-7V7h7v10ZM11 7H4v10h7V7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function u({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5Z"
        }
      )
    }
  );
}
function w({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10Zm-2 0V7h-3v10h3Zm-5 0V7h-4v10h4ZM8 7v10H5V7h3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function s({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m18.25 7.6-5.5-3.18a1.49 1.49 0 0 0-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3ZM7 14.96v-4.62l4 2.32v4.61l-4-2.31Zm5-4.03L8 8.61l4-2.31 4 2.31-4 2.32Zm1 6.34v-4.61l4-2.32v4.62l-4 2.31ZM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3V2Zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3V2ZM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3v2Zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3v2Z"
        }
      )
    }
  );
}
function g({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11.532 8.174c.185-.236.74-.23.937.01.086.105.333.699.55 1.319l.393 1.128 1.096.37c1.315.444 1.645.718 1.433 1.19-.111.246-.458.43-1.368.73l-1.218.402-.395 1.228c-.235.73-.5 1.284-.651 1.366-.373.202-.761.025-.925-.42-.079-.216-.284-.792-.456-1.282l-.313-.892-1.104-.372c-.607-.205-1.216-.497-1.353-.65-.418-.467-.012-.88 1.268-1.286.596-.19 1.138-.413 1.204-.497.065-.085.264-.607.44-1.16.177-.552.385-1.084.462-1.184Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13.853 2c.68 0 1.336.482 1.442 1.232l.272 1.842c.272.134.534.283.786.446l1.808-.707.016-.005.015-.006c.589-.209 1.37-.033 1.756.63L21.8 8.547l.006.01.007.012a1.446 1.446 0 0 1-.375 1.858l-.003.003-1.509 1.147c.009.137.016.278.016.424 0 .146-.007.287-.016.423l1.509 1.148.003.003c.587.451.717 1.246.375 1.858l-.007.011-.006.011-1.85 3.113h-.002a1.457 1.457 0 0 1-1.779.622l-.008-.003-1.812-.709c-.249.16-.51.31-.782.446l-.27 1.825.001.001c-.098.76-.759 1.25-1.445 1.251h-3.701c-.687 0-1.348-.49-1.446-1.251l-.27-1.824a7.776 7.776 0 0 1-.785-.445l-1.808.706-.015.006-.015.006c-.59.209-1.372.033-1.758-.632l-1.85-3.112-.007-.01-.064-.13a1.442 1.442 0 0 1 .433-1.74l.003-.003 1.507-1.147a6.487 6.487 0 0 1 0-.849L2.57 10.43l-.003-.003a1.436 1.436 0 0 1-.428-1.755l.067-.125h-.002l1.85-3.113a1.455 1.455 0 0 1 1.657-.663l.124.04.008.003 1.812.708c.248-.16.509-.31.782-.445l.272-1.844C8.815 2.482 9.471 2 10.152 2h3.7Zm-3.6 4.479-.536.213c-.47.188-.916.448-1.345.761l-.442.322-2.388-.932-1.364 2.296 1.555 1.183.46.35-.074.573a5.971 5.971 0 0 0-.056.755c0 .237.022.488.056.755l.075.573-.461.35-1.555 1.182 1.364 2.296 2.395-.934.445.333c.416.31.858.562 1.335.753l.535.213.365 2.479h2.77l.365-2.479.535-.213c.47-.188.916-.448 1.345-.761l.442-.322 2.387.931 1.364-2.296-2.013-1.532.073-.573c.034-.268.057-.51.057-.755 0-.246-.023-.487-.057-.755l-.073-.573.46-.35 1.553-1.183-1.364-2.296-2.393.935-.446-.333a5.811 5.811 0 0 0-1.335-.753l-.535-.213L13.387 4h-2.77l-.365 2.479Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function p({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14.69 2.21 4.33 11.49c-.64.58-.28 1.65.58 1.73L13 14l-4.85 6.76c-.22.31-.19.74.08 1.01.3.3.77.31 1.08.02l10.36-9.28c.64-.58.28-1.65-.58-1.73L11 10l4.85-6.76c.22-.31.19-.74-.08-1.01a.77.77 0 0 0-1.08-.02Z"
        }
      )
    }
  );
}
function f({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z" })
    }
  );
}
function m({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm11 1h4v-2h-4V7h-2v4H7v2h4v4h2v-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Z({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2a9.98 9.98 0 0 1 4 .825v2.25a8.446 8.446 0 0 0-1.887-.788A7.715 7.715 0 0 0 12 4c-2.217 0-4.104.779-5.662 2.337C4.779 7.896 4 9.783 4 12s.78 4.104 2.338 5.663C7.896 19.221 9.783 20 12 20s4.104-.779 5.663-2.337C19.221 16.104 20 14.217 20 12c0-.533-.054-1.05-.163-1.55A9.37 9.37 0 0 0 19.4 9h2.15c.15.483.263.97.338 1.462.075.492.112 1.005.112 1.538a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm3.5-11c.433 0 .792-.142 1.075-.425.283-.283.425-.642.425-1.075 0-.433-.142-.792-.425-1.075C16.292 8.142 15.933 8 15.5 8c-.433 0-.792.142-1.075.425-.283.283-.425.642-.425 1.075 0 .433.142.792.425 1.075.283.283.642.425 1.075.425Zm-7 0c.433 0 .792-.142 1.075-.425.283-.283.425-.642.425-1.075 0-.433-.142-.792-.425-1.075C9.292 8.142 8.933 8 8.5 8c-.433 0-.792.142-1.075.425C7.142 8.708 7 9.067 7 9.5c0 .433.142.792.425 1.075.283.283.642.425 1.075.425Zm3.5 6.5c1.183 0 2.229-.325 3.137-.975A5.473 5.473 0 0 0 17.1 14H6.9a5.473 5.473 0 0 0 1.963 2.525c.908.65 1.954.975 3.137.975ZM20 7V5h-2V3h2V1h2v2h2v2h-2v2h-2Z"
        }
      )
    }
  );
}
function x({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3Zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3Zm-8 4-3 4h12l-4-5-3 4-2-3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function C({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 17H7c-1.383 0-2.563-.488-3.538-1.463C2.487 14.563 2 13.383 2 12s.487-2.563 1.462-3.537C4.438 7.488 5.617 7 7 7h4v2H7c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 4 12c0 .833.292 1.542.875 2.125A2.893 2.893 0 0 0 7 15h4v2Zm-3-4v-2h8v2H8Zm14-1h-2c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 17 9h-4V7h4c1.383 0 2.563.487 3.538 1.463C21.512 9.438 22 10.617 22 12Zm-5 8v-3h-3v-2h3v-3h2v3h3v2h-3v3h-2Z"
        }
      )
    }
  );
}
function y({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4Zm2 2v2h3v3h2v-3h3v-2h-3V7h-2v3h-3ZM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4Z"
        }
      )
    }
  );
}
function A({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function M({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 9h2V7h4V5h-4V3h-2v6ZM7 9v2H3v2h4v2h2V9H7Zm6 10v2h-2v-6h2v2h8v2h-8ZM3 19v-2h6v2H3Zm18-8v2H11v-2h10Zm-8-6H3v1.99h10V5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function H({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m8.353 19.722 3.745-6.538 3.745 6.538a3.277 3.277 0 0 0 4.498 1.205 3.33 3.33 0 0 0 1.213-4.528L15.01 4.977a3.318 3.318 0 0 0-.275-.436 3.277 3.277 0 0 0-2.724-1.326 3.276 3.276 0 0 0-2.537 1.309c-.109.144-.206.297-.29.455L2.893 15.963a3.325 3.325 0 0 0-.74 2.097c0 1.835 1.477 3.323 3.298 3.323.187 0 .37-.016.548-.046a3.273 3.273 0 0 0 2.355-1.615Z"
        }
      )
    }
  );
}
function V({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#CDCFD4",
            d: "M9.25 4.866a3.277 3.277 0 0 1 4.497-1.205A3.33 3.33 0 0 1 14.96 8.19L8.353 19.722a3.277 3.277 0 0 1-4.498 1.205A3.33 3.33 0 0 1 2.642 16.4L9.25 4.866Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9.236 8.19A3.33 3.33 0 0 1 10.45 3.66a3.277 3.277 0 0 1 4.498 1.205L21.554 16.4a3.33 3.33 0 0 1-1.213 4.528 3.277 3.277 0 0 1-4.498-1.205L9.236 8.189Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#9A9FA8",
            d: "M8.747 18.06c0 1.835-1.476 3.323-3.297 3.323-1.821 0-3.297-1.488-3.297-3.323s1.476-3.323 3.297-3.323c1.82 0 3.297 1.488 3.297 3.323Z"
          }
        )
      ]
    }
  );
}
function B({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#FABC04",
            d: "M9.25 4.866a3.277 3.277 0 0 1 4.497-1.205A3.33 3.33 0 0 1 14.96 8.19L8.353 19.722a3.277 3.277 0 0 1-4.498 1.205 3.33 3.33 0 0 1-1.213-4.528L9.25 4.866Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#34A852",
            d: "M8.747 18.06c0 1.835-1.476 3.323-3.297 3.323-1.821 0-3.297-1.488-3.297-3.323s1.476-3.323 3.297-3.323c1.82 0 3.297 1.488 3.297 3.323Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#3C8BD9",
            d: "M9.236 8.19A3.33 3.33 0 0 1 10.45 3.66a3.277 3.277 0 0 1 4.498 1.205L21.554 16.4a3.33 3.33 0 0 1-1.213 4.528 3.277 3.277 0 0 1-4.498-1.205L9.236 8.189Z"
          }
        )
      ]
    }
  );
}
function I({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 13h3l-4 4-4-4h3V3h2v10Zm-9 8v-2h16v2H4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function L({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16 5h-3V1h-2v4H8l4 4 4-4ZM8 19h3v4h2v-4h3l-4-4-4 4Zm-4-6v-2h16v2H4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function R({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 20H3V4h2v16Zm6-7v3l-4-4 4-4v3h10v2H11Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function S({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13 11V8l4 4-4 4v-3H3v-2h10Zm8 9h-2V4h2v16Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function F({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5V3h16v2H4Zm7 6H8l4-4 4 4h-3v10h-2V11Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function T({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 8v3H1v2h4v3l4-4-4-4Zm14 8v-3h4v-2h-4V8l-4 4 4 4Zm-6 4h-2V4h2v16Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function k({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 18c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 1 16c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 3 14h.263a.64.64 0 0 1 .237.05L8.05 9.5A.641.641 0 0 1 8 9.262V9c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 10 7c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413 0 .033-.017.2-.05.5l2.55 2.55a.642.642 0 0 1 .238-.05h.524c.075 0 .155.017.238.05l3.55-3.55a.642.642 0 0 1-.05-.238V8c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 21 6c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.412A1.927 1.927 0 0 1 21 10h-.262a.641.641 0 0 1-.238-.05l-3.55 3.55c.033.083.05.163.05.238V14c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 15 16c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 13 14v-.262c0-.075.017-.155.05-.238l-2.55-2.55a.642.642 0 0 1-.238.05H10c-.033 0-.2-.017-.5-.05L4.95 15.5c.033.083.05.163.05.238V16c0 .55-.196 1.021-.588 1.413A1.925 1.925 0 0 1 3 18Z"
        }
      )
    }
  );
}
function D({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M3 3h2v16h16v2H3V3Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M7 5c6.627 0 12 5.373 12 12h-2c0-5.523-4.477-10-10-10V5Z"
          }
        )
      ]
    }
  );
}
function O({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6ZM3 12a5.99 5.99 0 0 1 4-5.65V4.26C3.55 5.15 1 8.27 1 12c0 3.73 2.55 6.85 6 7.74v-2.09A5.99 5.99 0 0 1 3 12Z"
        }
      )
    }
  );
}
function b({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6Zm12 0h-7.5l2-2H18v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function P({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22v-6c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 6 14h12c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6H4Zm2-4h12v-2H6v2Zm6-4L7 7c0-1.383.487-2.563 1.463-3.538C9.438 2.487 10.617 2 12 2s2.563.487 3.537 1.462C16.512 4.438 17 5.617 17 7l-5 7Zm0-2.8L15 7c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 4c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 7l3 4.2Z"
        }
      )
    }
  );
}
function U({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27ZM12 17.5 6.5 12H10v-2h4v2h3.5L12 17.5ZM5.12 5l.81-1h12l.94 1H5.12Z"
        }
      )
    }
  );
}
function E({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2Z"
        }
      )
    }
  );
}
function G({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.5 5.43 15.06 4 7 12l8.06 8 1.44-1.43L9.882 12 16.5 5.43Z"
        }
      )
    }
  );
}
function W({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8Z"
        }
      )
    }
  );
}
function N({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M20 5.41 18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41Z" })
    }
  );
}
function j({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M5.41 4 4 5.41 15.59 17H9v2h10V9h-2v6.59L5.41 4Z" })
    }
  );
}
function X({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41Z" })
    }
  );
}
function K({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z"
        }
      )
    }
  );
}
function Q({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5.43 8.94 4 17 12l-8.06 8-1.44-1.43L14.118 12 7.5 5.43Z"
        }
      )
    }
  );
}
function Y({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41Z"
        }
      )
    }
  );
}
function J({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41Z" })
    }
  );
}
function q({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8Z"
        }
      )
    }
  );
}
function _({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M15 5v2H8.41L20 18.59 18.59 20 7 8.41V15H5V5h10Z" })
    }
  );
}
function $({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9Z" })
    }
  );
}
function z({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41Z"
        }
      )
    }
  );
}
function l1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m19.93 8.21-3.6 1.68L14 7.7V6.3l2.33-2.19 3.6 1.68c.38.18.82.01 1-.36.18-.38.01-.82-.36-1L16.65 2.6a.993.993 0 0 0-1.13.2l-1.74 1.6A.975.975 0 0 0 13 4c-.55 0-1 .45-1 1v1H8.82C8.34 4.65 6.98 3.73 5.4 4.07c-1.16.25-2.15 1.25-2.36 2.43-.22 1.32.46 2.47 1.48 3.08L7.08 18H4v3h13v-3h-3.62L8.41 8.77c.17-.24.31-.49.41-.77H12v1c0 .55.45 1 1 1 .32 0 .6-.16.78-.4l1.74 1.6c.3.3.75.38 1.13.2l3.92-1.83c.38-.18.54-.62.36-1a.753.753 0 0 0-1-.36ZM6 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z"
        }
      )
    }
  );
}
function t1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5Zm4 2v5h2V9h3V7H5Zm14 10h-5v-2h3v-3h2v5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function e1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 12h-2v3h-3v2h5v-5ZM7 9h3V7H5v5h2V9Zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16.01H3V4.99h18v14.02Z"
        }
      )
    }
  );
}
function r1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5Z"
        }
      )
    }
  );
}
function i1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM10.5 3h3v12h-3V3Z" })
    }
  );
}
function n1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11 1.05v2.01c-1.73.19-3.31.88-4.61 1.92L4.97 3.56C6.64 2.17 8.71 1.25 11 1.05ZM13 1.05c2.29.21 4.36 1.12 6.03 2.51l-1.42 1.42A8.928 8.928 0 0 0 13 3.06V1.05ZM4.98 6.39 3.56 4.97C2.17 6.64 1.26 8.71 1.05 11h2.01c.19-1.73.88-3.31 1.92-4.61ZM22.95 11h-2.01a8.928 8.928 0 0 0-1.92-4.61l1.42-1.42c1.39 1.67 2.3 3.74 2.51 6.03ZM7 12l3.44 1.56L12 17l1.56-3.44L17 12l-3.44-1.56L12 7l-1.56 3.44L7 12Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M4.54 17A8.96 8.96 0 0 0 12 21c3.92 0 7.25-2.52 8.48-6.01l1.96.45C21 19.83 16.87 23 12 23c-3.73 0-7.01-1.86-9-4.7V21H1v-6h6v2H4.54Z"
          }
        )
      ]
    }
  );
}
function h1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.5 16.5v-9l7 4.5-7 4.5ZM12 23c-1.8 0-3.488-.413-5.063-1.238A11.054 11.054 0 0 1 3 18.3V21H1v-6h6v2H4.55a9.115 9.115 0 0 0 3.237 2.938A8.713 8.713 0 0 0 12 21a8.83 8.83 0 0 0 5.212-1.65c1.559-1.1 2.655-2.558 3.288-4.375l1.95.45c-.75 2.267-2.083 4.096-4 5.488C16.533 22.303 14.383 23 12 23ZM1.05 11c.117-1.117.383-2.188.8-3.213.417-1.024.992-1.97 1.725-2.837L5 6.375a9.907 9.907 0 0 0-1.3 2.188A8.142 8.142 0 0 0 3.075 11H1.05ZM6.4 4.975 4.975 3.55a11.225 11.225 0 0 1 2.85-1.737A10.172 10.172 0 0 1 11 1.05v2a8.001 8.001 0 0 0-2.425.625 10.02 10.02 0 0 0-2.175 1.3Zm11.225 0a9.907 9.907 0 0 0-2.188-1.3A8.142 8.142 0 0 0 13 3.05v-2c1.117.1 2.188.358 3.212.775 1.026.417 1.971.992 2.838 1.725l-1.425 1.425ZM20.95 11a8.142 8.142 0 0 0-.625-2.438 9.907 9.907 0 0 0-1.3-2.187L20.45 4.95a10.485 10.485 0 0 1 1.725 2.837c.417 1.026.675 2.096.775 3.213h-2Z"
        }
      )
    }
  );
}
function c1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.56 8.94 7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12ZM5.21 10 10 5.21 14.79 10H5.21ZM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5ZM2 20h20v4H2v-4Z"
        }
      )
    }
  );
}
function o1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 20c-1.517 0-2.813-.525-3.888-1.575C1.537 17.375 1 16.092 1 14.575c0-1.3.392-2.458 1.175-3.475S3.983 9.433 5.25 9.15c.417-1.533 1.25-2.775 2.5-3.725C9 4.475 10.417 4 12 4c1.95 0 3.604.68 4.962 2.037C18.322 7.396 19 9.05 19 11c1.15.133 2.104.63 2.863 1.488A4.407 4.407 0 0 1 23 15.5c0 1.25-.438 2.313-1.313 3.188S19.75 20 18.5 20H13c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 11 18v-5.15L9.4 14.4 8 13l4-4 4 4-1.4 1.4-1.6-1.55V18h5.5c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-1.383-.488-2.563-1.463-3.537C14.563 6.487 13.383 6 12 6s-2.563.487-3.537 1.463C7.488 8.437 7 9.617 7 11h-.5c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 3 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0 0 6.5 18H9v2H6.5Z"
        }
      )
    }
  );
}
function d1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 10h3v10H6V10Zm0-5h3v4H6V5Zm10 11h3v4h-3v-4Zm0-3h3v2h-3v-2Zm-5 0h3v7h-3v-7Zm0-4h3v3h-3V9Z"
        }
      )
    }
  );
}
function v1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8 19c-1.95 0-3.604-.68-4.962-2.038C1.679 15.604 1 13.95 1 12c0-1.95.68-3.604 2.038-4.963C4.396 5.679 6.05 5 8 5c.367 0 .73.03 1.088.088.358.058.72.154 1.087.287-.85.683-1.508 1.6-1.975 2.75-.467 1.15-.7 2.442-.7 3.875 0 1.433.233 2.725.7 3.875.467 1.15 1.125 2.067 1.975 2.75-.367.133-.729.23-1.087.288A6.804 6.804 0 0 1 8 19Zm4-1.25c-.833 0-1.542-.558-2.125-1.675S9 13.6 9 12s.292-2.958.875-4.075S11.167 6.25 12 6.25s1.542.558 2.125 1.675S15 10.4 15 12s-.292 2.958-.875 4.075S12.833 17.75 12 17.75ZM16 19a7.19 7.19 0 0 1-1.125-.087 6.781 6.781 0 0 1-1.075-.263c.283-.2.558-.458.825-.775.267-.317.492-.625.675-.925.117.017.23.03.338.038.108.008.229.012.362.012 1.383 0 2.563-.488 3.538-1.463C20.513 14.562 21 13.383 21 12s-.487-2.563-1.462-3.538C18.563 7.487 17.383 7 16 7c-.133 0-.254.004-.362.012a5.464 5.464 0 0 0-.338.038 7.594 7.594 0 0 0-.675-.925 4.44 4.44 0 0 0-.825-.775c.35-.117.708-.204 1.075-.262A7.11 7.11 0 0 1 16 5c1.933 0 3.583.683 4.95 2.05C22.317 8.417 23 10.067 23 12c0 1.933-.683 3.583-2.05 4.95C19.583 18.317 17.933 19 16 19Z"
        }
      )
    }
  );
}
function a1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5ZM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5ZM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5Zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5Zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5Zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5ZM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5ZM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5Zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Z"
        }
      )
    }
  );
}
function u1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M1 6.001a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6.001ZM17 6.001a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V6.001ZM9 6.001a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V6.001Z"
        }
      )
    }
  );
}
function w1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42ZM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3Zm0 9h3.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H10v3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function s1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2Z" })
    }
  );
}
function g1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2Zm0 15-5-2.18L7 18V5h10v13Z"
        }
      )
    }
  );
}
function p1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h-2v2h2V7Zm0 4h-2v2h2v-2Zm4 0h-2v2h2v-2ZM3 3v18h18V3H3Zm16 16H5V5h14v14Zm-6-4h-2v2h2v-2Zm-4-4H7v2h2v-2Z"
        }
      )
    }
  );
}
function f1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 11H7v2h2v-2Zm4 4h-2v2h2v-2ZM9 3H7v2h2V3Zm4 8h-2v2h2v-2ZM5 3H3v2h2V3Zm8 4h-2v2h2V7Zm4 4h-2v2h2v-2Zm-4-8h-2v2h2V3Zm4 0h-2v2h2V3Zm2 10h2v-2h-2v2Zm0 4h2v-2h-2v2ZM5 7H3v2h2V7Zm14-4v2h2V3h-2Zm0 6h2V7h-2v2ZM5 11H3v2h2v-2ZM3 21h18v-2H3v2Zm2-6H3v2h2v-2Z"
        }
      )
    }
  );
}
function m1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 24H2v-4h20v4ZM13.06 5.19l3.75 3.75L7.75 18H4v-3.75l9.06-9.06Zm4.82 2.68-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34c.39.39.39 1.02 0 1.41l-1.83 1.83Z"
        }
      )
    }
  );
}
function Z1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 21h2v-2h-2v2Zm0-4h2v-2h-2v2Zm0-12h2V3h-2v2Zm0 4h2V7h-2v2Zm0 4h2v-2h-2v2Zm-4 8h2v-2H7v2ZM7 5h2V3H7v2Zm0 8h2v-2H7v2Zm-4 8h2V3H3v18ZM19 9h2V7h-2v2Zm-4 12h2v-2h-2v2Zm4-4h2v-2h-2v2Zm0-14v2h2V3h-2Zm0 10h2v-2h-2v2Zm0 8h2v-2h-2v2Zm-4-8h2v-2h-2v2Zm0-8h2V3h-2v2Z"
        }
      )
    }
  );
}
function x1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 19h2v2h-2v-2Zm0-2h2v-2h-2v2ZM3 13h2v-2H3v2Zm0 4h2v-2H3v2Zm0-8h2V7H3v2Zm0-4h2V3H3v2Zm4 0h2V3H7v2Zm8 16h2v-2h-2v2Zm-4 0h2v-2h-2v2Zm4 0h2v-2h-2v2Zm-8 0h2v-2H7v2Zm-4 0h2v-2H3v2ZM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8Z"
        }
      )
    }
  );
}
function C1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M5 3v2c0 7.732 6.268 14 14 14h2v2h-2C10.163 21 3 13.837 3 5V3h2Z"
        }
      )
    }
  );
}
function y1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 19h2c7.732 0 14-6.268 14-14V3h2v2c0 8.837-7.163 16-16 16H3v-2Z"
        }
      )
    }
  );
}
function A1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17 5h-3V3h3a4 4 0 0 1 4 4v3h-2V7a2 2 0 0 0-2-2ZM10 3v2H7a2 2 0 0 0-2 2v3H3V7a4 4 0 0 1 4-4h3ZM19 14v3a2 2 0 0 1-2 2h-3v2h3a4 4 0 0 0 4-4v-3h-2ZM10 21v-2H7a2 2 0 0 1-2-2v-3H3v3a4 4 0 0 0 4 4h3Z"
        }
      )
    }
  );
}
function M1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M21 5h-2C11.268 5 5 11.268 5 19v2H3v-2c0-8.837 7.163-16 16-16h2v2Z"
        }
      )
    }
  );
}
function H1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 21v-2c0-7.732-6.268-14-14-14H3V3h2c8.837 0 16 7.163 16 16v2h-2Z"
        }
      )
    }
  );
}
function V1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7 21h2v-2H7v2ZM3 5h2V3H3v2Zm4 0h2V3H7v2Zm0 8h2v-2H7v2Zm-4 8h2v-2H3v2Zm8 0h2v-2h-2v2Zm-8-8h2v-2H3v2Zm0 4h2v-2H3v2Zm0-8h2V7H3v2Zm8 8h2v-2h-2v2Zm4-4h2v-2h-2v2Zm4-10v18h2V3h-2Zm-4 18h2v-2h-2v2Zm0-16h2V3h-2v2Zm-4 8h2v-2h-2v2Zm0-8h2V3h-2v2Zm0 4h2V7h-2v2Z"
        }
      )
    }
  );
}
function B1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7 21h2v-2H7v2Zm0-8h2v-2H7v2Zm4 0h2v-2h-2v2Zm0 8h2v-2h-2v2Zm-8-4h2v-2H3v2Zm0 4h2v-2H3v2Zm0-8h2v-2H3v2Zm0-4h2V7H3v2Zm8 8h2v-2h-2v2Zm8-8h2V7h-2v2Zm0 4h2v-2h-2v2ZM3 3v2h18V3H3Zm16 14h2v-2h-2v2Zm-4 4h2v-2h-2v2ZM11 9h2V7h-2v2Zm8 12h2v-2h-2v2Zm-4-8h2v-2h-2v2Z"
        }
      )
    }
  );
}
function I1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 5h16v2H4V5ZM4 9h16v3H4V9ZM20 14H4v5h16v-5Z" })
    }
  );
}
function L1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20.43 15.43c.219.307.175.702-.088.921-.308.22-.747.176-.966-.088l-1.537-1.975-1.493 1.931c-.22.308-.658.308-.966.088-.307-.22-.35-.614-.131-.922l1.756-2.283-1.756-2.283c-.22-.307-.132-.746.131-.965.308-.22.747-.132.966.131l1.493 1.976 1.537-1.888c.22-.307.614-.351.965-.132.308.22.308.659.088.966l-1.712 2.24 1.712 2.282Zm-7.991-.264c-1.141 0-2.063-.878-2.063-2.02 0-1.097.922-2.02 2.063-2.02 1.142 0 2.063.923 2.063 2.02-.043 1.142-.965 2.02-2.063 2.02Zm-6.059 0c-1.141 0-2.063-.878-2.063-2.02 0-1.097.922-2.02 2.063-2.02 1.142 0 2.064.923 2.064 2.02 0 1.142-.922 2.02-2.064 2.02ZM12.44 9.81a3.4 3.4 0 0 0-2.985 1.756C8.883 10.512 7.74 9.81 6.424 9.81c-.79 0-1.492.263-2.063.658v-2.81A.675.675 0 0 0 3.702 7C3.307 7 3 7.307 3 7.659v5.531a3.364 3.364 0 0 0 3.38 3.293 3.456 3.456 0 0 0 3.03-1.8c.57 1.054 1.712 1.8 2.985 1.8 1.888 0 3.425-1.493 3.425-3.38.043-1.8-1.493-3.293-3.381-3.293Z"
        }
      )
    }
  );
}
function R1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20.43 15.43c.219.307.175.702-.088.921-.308.22-.747.176-.966-.088l-1.537-1.975-1.493 1.931c-.22.308-.658.308-.966.088-.307-.22-.35-.614-.131-.922l1.756-2.283-1.756-2.283c-.22-.307-.132-.746.131-.965.308-.22.747-.132.966.131l1.493 1.976 1.537-1.888c.22-.307.614-.351.965-.132.308.22.308.659.088.966l-1.712 2.24 1.712 2.282Zm-7.991-.264c-1.141 0-2.063-.878-2.063-2.02 0-1.097.922-2.02 2.063-2.02 1.142 0 2.063.923 2.063 2.02-.043 1.142-.965 2.02-2.063 2.02Zm-6.059 0c-1.141 0-2.063-.878-2.063-2.02 0-1.097.922-2.02 2.063-2.02 1.142 0 2.064.923 2.064 2.02 0 1.142-.922 2.02-2.064 2.02ZM12.44 9.81a3.4 3.4 0 0 0-2.985 1.756C8.883 10.512 7.74 9.81 6.424 9.81c-.79 0-1.492.263-2.063.658v-2.81A.675.675 0 0 0 3.702 7C3.307 7 3 7.307 3 7.659v5.531a3.364 3.364 0 0 0 3.38 3.293 3.456 3.456 0 0 0 3.03-1.8c.57 1.054 1.712 1.8 2.985 1.8 1.888 0 3.425-1.493 3.425-3.38.043-1.8-1.493-3.293-3.381-3.293Z"
        }
      )
    }
  );
}
function S1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#0071F7",
          d: "M20.43 15.43c.219.307.175.702-.088.921-.308.22-.747.176-.966-.088l-1.537-1.975-1.493 1.931c-.22.308-.658.308-.966.088-.307-.22-.35-.614-.131-.922l1.756-2.283-1.756-2.283c-.22-.307-.132-.746.131-.965.308-.22.747-.132.966.131l1.493 1.976 1.537-1.888c.22-.307.614-.351.965-.132.308.22.308.659.088.966l-1.712 2.24 1.712 2.282Zm-7.991-.264c-1.141 0-2.063-.878-2.063-2.02 0-1.097.922-2.02 2.063-2.02 1.142 0 2.063.923 2.063 2.02-.043 1.142-.965 2.02-2.063 2.02Zm-6.059 0c-1.141 0-2.063-.878-2.063-2.02 0-1.097.922-2.02 2.063-2.02 1.142 0 2.064.923 2.064 2.02 0 1.142-.922 2.02-2.064 2.02ZM12.44 9.81a3.4 3.4 0 0 0-2.985 1.756C8.883 10.512 7.74 9.81 6.424 9.81c-.79 0-1.492.263-2.063.658v-2.81A.675.675 0 0 0 3.702 7C3.307 7 3 7.307 3 7.659v5.531a3.364 3.364 0 0 0 3.38 3.293 3.456 3.456 0 0 0 3.03-1.8c.57 1.054 1.712 1.8 2.985 1.8 1.888 0 3.425-1.493 3.425-3.38.043-1.8-1.493-3.293-3.381-3.293Z"
        }
      )
    }
  );
}
function F1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m17.07 3.98 4.96 11.97c.42 1.01-.07 2.18-1.09 2.6l-7.36 3.05a1.998 1.998 0 0 1-2.6-1.08L6.02 8.55a1.999 1.999 0 0 1 1.08-2.6l7.37-3.05c.26-.11.53-.15.79-.15.77.02 1.5.48 1.81 1.23ZM3.87 20.21l-1.34-.56a2.019 2.019 0 0 1-1.09-2.61l2.43-5.86v9.03ZM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm0 13c-1.1 0-2-.9-2-2v-6.34l3.45 8.34H7.88Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function T1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m15.484 12.189-.013.108-.034.095-.828 1.436-.969 1.674-.075.125-.095.104-.105.096-.108.074-.139.065-.123.043-.153.035-.139.013H9.107l-.076-.013-.076-.018-.063-.047-.06-.044-.048-.047-.031-.078-.03-.079v-.169l.045-.09 1.783-3.127.079-.109.092-.108.107-.091.123-.091.121-.06.14-.049.139-.03h3.829l.056.03.078.03.048.044.06.065.03.06.018.079.013.074Zm0-1.262-.013-.108-.034-.096-1.797-3.122-.075-.108-.095-.109-.105-.095-.108-.078-.139-.061-.123-.048-.153-.03-.139-.013H9.107l-.076.013-.076.017-.063.03-.06.044-.048.065-.031.078-.03.06v.187l.045.091.938 1.64.845 1.487.079.108.092.109.107.09.123.079.121.06.14.048.139.03.152.014H15.1l.08-.013.057-.018.078-.03.108-.109.03-.06.018-.074.013-.078ZM21 12.176l-.013.108-.048.095-.82 1.44-.97 1.674-.079.126-.09.108-.11.091-.108.078-.143.065-.134.044-.139.034-.156.013H14.59l-.079-.013-.077-.017-.063-.048-.06-.043-.045-.048-.048-.078-.015-.078-.016-.078.015-.095.048-.091.943-1.644.85-1.487.073-.109.096-.108.108-.091.121-.091.126-.06.139-.049.139-.03h3.846l.06.03.079.03.047.044.044.065.048.06.017.079.013.074Zm-6.812 4.757.016.095.047.095.818 1.44.975 1.687.073.126.096.09.108.096.121.095.126.061.139.044.139.03h3.846l.06-.03.079-.03.048-.048.043-.061.048-.06.017-.079.013-.078-.013-.108-.048-.078-.94-1.657-.85-1.474-.079-.122-.09-.108-.11-.096-.108-.073-.143-.061-.134-.048-.139-.034-.156-.013h-3.599l-.079.013-.076.017-.064.048-.06.043-.045.065-.048.06-.015.079-.016.074ZM8.349 7.913l1.793 3.135.064.122.045.143.031.156v.273l-.031.143-.045.135-.064.125-.866 1.466-.943 1.64-.061.073-.092.06-.061.035-.077.013h-.079l-.076-.013-.064-.017-.077-.043-.044-.048-.048-.06-1.793-3.136-.077-.143-.047-.134-.014-.14-.015-.138.015-.152.03-.143.047-.121.06-.126.975-1.687.835-1.418.061-.095.076-.061.08-.03.076-.018h.08l.06.018.077.03.06.035.064.06.045.061Zm-3.246-4.87-.077.065-.063.079-.835 1.435-.975 1.67-.06.138-.048.122-.029.143L3 6.833l.016.152.03.139.046.139.061.143 1.794 3.118.047.078.061.043.063.048.064.017.076.013h.077l.076-.013.077-.03.08-.061.06-.078.943-1.64.867-1.465.063-.143.045-.121.031-.14v-.294l-.031-.139L7.5 6.46l-.063-.138L5.644 3.2l-.045-.074-.126-.096-.077-.013L5.336 3h-.078l-.076.017-.08.026Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function k1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m21 12.176-.013.108-.048.095-.82 1.44-.97 1.674-.079.126-.09.108-.11.091-.108.078-.143.065-.134.044-.139.034-.156.013H14.59l-.079-.013-.077-.017-.063-.048-.06-.043-.045-.048-.048-.078-.015-.078-.016-.078.015-.095.048-.091.943-1.644.85-1.487.073-.109.096-.108.108-.091.121-.091.126-.06.139-.049.139-.03h3.846l.06.03.079.03.047.044.044.065.048.06.017.079.013.074Zm-6.812 4.757.016.095.047.095.818 1.44.975 1.687.073.126.096.09.108.096.121.095.126.061.139.044.139.03h3.846l.06-.03.079-.03.048-.048.043-.061.048-.06.017-.079.013-.078-.013-.108-.048-.078-.94-1.657-.85-1.474-.079-.122-.09-.108-.11-.096-.108-.073-.143-.061-.134-.048-.139-.034-.156-.013h-3.599l-.079.013-.076.017-.064.048-.06.043-.045.065-.048.06-.015.079-.016.074Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#9A9FA8",
            fillRule: "evenodd",
            d: "m8.349 7.913 1.793 3.135.064.122.045.143.031.156v.273l-.031.143-.045.135-.064.125-.866 1.466-.943 1.64-.061.073-.092.06-.061.035-.077.013h-.079l-.076-.013-.064-.017-.077-.043-.044-.048-.048-.06-1.793-3.136-.077-.143-.047-.134-.014-.14-.015-.138.015-.152.03-.143.047-.121.06-.126.975-1.687.835-1.418.061-.095.076-.061.08-.03.076-.018h.08l.06.018.077.03.06.035.064.06.045.061Zm-3.246-4.87-.077.065-.063.079-.835 1.435-.975 1.67-.06.138-.048.122-.029.143L3 6.833l.016.152.03.139.046.139.061.143 1.794 3.118.047.078.061.043.063.048.064.017.076.013h.077l.076-.013.077-.03.08-.061.06-.078.943-1.64.867-1.465.063-.143.045-.121.031-.14v-.294l-.031-.139L7.5 6.46l-.063-.138L5.644 3.2l-.045-.074-.126-.096-.077-.013L5.336 3h-.078l-.076.017-.08.026Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#CDCFD4",
            fillRule: "evenodd",
            d: "m15.484 12.189-.013.108-.034.095-.828 1.436-.969 1.674-.075.125-.095.104-.105.096-.108.074-.139.065-.123.043-.153.035-.139.013H9.107l-.076-.013-.076-.018-.063-.047-.06-.044-.048-.047-.031-.078-.03-.079v-.169l.045-.09 1.783-3.127.079-.109.092-.108.107-.091.123-.091.121-.06.14-.049.139-.03h3.829l.056.03.078.03.048.044.06.065.03.06.018.079.013.074Zm0-1.262-.013-.108-.034-.096-1.797-3.122-.075-.108-.095-.109-.105-.095-.108-.078-.139-.061-.123-.048-.153-.03-.139-.013H9.107l-.076.013-.076.017-.063.03-.06.044-.048.065-.031.078-.03.06v.187l.045.091.938 1.64.845 1.487.079.108.092.109.107.09.123.079.121.06.14.048.139.03.152.014H15.1l.08-.013.057-.018.078-.03.108-.109.03-.06.018-.074.013-.078Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function D1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#94C039",
            fillRule: "evenodd",
            d: "m15.484 12.189-.013.108-.034.095-.828 1.436-.969 1.674-.075.125-.095.104-.105.096-.108.074-.139.065-.123.043-.153.035-.139.013H9.107l-.076-.013-.076-.018-.063-.047-.06-.044-.048-.047-.031-.078-.03-.079v-.169l.045-.09 1.783-3.127.079-.109.092-.108.107-.091.123-.091.121-.06.14-.049.139-.03h3.829l.056.03.078.03.048.044.06.065.03.06.018.079.013.074Zm0-1.262-.013-.108-.034-.096-1.797-3.122-.075-.108-.095-.109-.105-.095-.108-.078-.139-.061-.123-.048-.153-.03-.139-.013H9.107l-.076.013-.076.017-.063.03-.06.044-.048.065-.031.078-.03.06v.187l.045.091.938 1.64.845 1.487.079.108.092.109.107.09.123.079.121.06.14.048.139.03.152.014H15.1l.08-.013.057-.018.078-.03.108-.109.03-.06.018-.074.013-.078Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#D4247B",
            fillRule: "evenodd",
            d: "m21 12.176-.013.108-.048.095-.82 1.44-.97 1.674-.079.126-.09.108-.11.091-.108.078-.143.065-.134.044-.139.034-.156.013H14.59l-.079-.013-.077-.017-.063-.048-.06-.043-.045-.048-.048-.078-.015-.078-.016-.078.015-.095.048-.091.943-1.644.85-1.487.073-.109.096-.108.108-.091.121-.091.126-.06.139-.049.139-.03h3.846l.06.03.079.03.047.044.044.065.048.06.017.079.013.074Zm-6.812 4.757.016.095.047.095.818 1.44.975 1.687.073.126.096.09.108.096.121.095.126.061.139.044.139.03h3.846l.06-.03.079-.03.048-.048.043-.061.048-.06.017-.079.013-.078-.013-.108-.048-.078-.94-1.657-.85-1.474-.079-.122-.09-.108-.11-.096-.108-.073-.143-.061-.134-.048-.139-.034-.156-.013h-3.599l-.079.013-.076.017-.064.048-.06.043-.045.065-.048.06-.015.079-.016.074Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#069BB3",
            fillRule: "evenodd",
            d: "m8.349 7.913 1.793 3.135.064.122.045.143.031.156v.273l-.031.143-.045.135-.064.125-.866 1.466-.943 1.64-.061.073-.092.06-.061.035-.077.013h-.079l-.076-.013-.064-.017-.077-.043-.044-.048-.048-.06-1.793-3.136-.077-.143-.047-.134-.014-.14-.015-.138.015-.152.03-.143.047-.121.06-.126.975-1.687.835-1.418.061-.095.076-.061.08-.03.076-.018h.08l.06.018.077.03.06.035.064.06.045.061Zm-3.246-4.87-.077.065-.063.079-.835 1.435-.975 1.67-.06.138-.048.122-.029.143L3 6.833l.016.152.03.139.046.139.061.143 1.794 3.118.047.078.061.043.063.048.064.017.076.013h.077l.076-.013.077-.03.08-.061.06-.078.943-1.64.867-1.465.063-.143.045-.121.031-.14v-.294l-.031-.139L7.5 6.46l-.063-.138L5.644 3.2l-.045-.074-.126-.096-.077-.013L5.336 3h-.078l-.076.017-.08.026Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function O1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#120087",
            d: "M15.684 12.037v-.374c.404-.054.8-.087 1.186-.157.247-.045.494-.123.725-.218.654-.263 1.058-.757 1.194-1.44.16-.802.168-1.608-.042-2.402-.078-.3-.222-.58-.35-.896.05.037.091.065.124.098.877.876 1.758 1.749 2.635 2.629.494.498.74 1.127.786 1.81a9.23 9.23 0 0 1-.041 1.72c-.095.801-.613 1.27-1.375 1.484-.099.029-.198.05-.296.078-.194.05-.227.149-.083.293.239.246.486.485.729.728.136.135.272.271.407.403.387.378.655.83.68 1.37.033.724.074 1.46-.025 2.171-.181 1.28-1.013 2.037-2.219 2.407a5.957 5.957 0 0 1-1.766.255c-3.112 0-6.229 0-9.341.004a.485.485 0 0 1-.379-.152c-.906-.913-1.82-1.827-2.734-2.736-.049-.05-.09-.098-.18-.193h9.234c.687 0 1.37-.053 2.033-.251 1.507-.453 2.293-1.452 2.334-3.023.017-.593 0-1.193-.086-1.782-.115-.773-.605-1.304-1.35-1.534-.474-.144-.976-.202-1.466-.288-.103-.02-.206-.004-.334-.004ZM2.012 2h9.741c.74 0 1.474.07 2.149.39.354.17.712.375.992.643.89.843 1.746 1.727 2.614 2.595.03.029.054.062.1.115-.059-.008-.091 0-.116-.016-.881-.502-1.845-.646-2.833-.646-3.12-.004-6.245 0-9.365 0-.062 0-.12.008-.202.012v13.583c-.09-.074-.14-.11-.185-.156-.93-.93-1.857-1.851-2.78-2.785a.488.488 0 0 1-.123-.3C2 11.033 2 6.632 2 2.23c0-.065.008-.135.012-.23Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#120087",
            d: "M9.727 13.341h1.692c.59.004 1.178.004 1.767.017.16.004.325.04.481.09.35.111.556.366.585.72.029.374.037.753-.008 1.127-.058.469-.38.72-.902.77-.28.024-.56.032-.84.032-.848.004-1.7-.004-2.548.008-.181 0-.23-.053-.23-.234.008-.831.003-1.666.003-2.53ZM9.727 10.51V9.409c0-.431.009-.863-.004-1.295-.004-.173.054-.222.223-.218.955.008 1.906 0 2.86.008.24 0 .483.02.713.07.486.103.716.374.75.872.016.267.016.535-.005.802-.033.424-.271.704-.687.79-.28.057-.569.082-.857.086-.955.008-1.906.004-2.86.004a.69.69 0 0 0-.133-.016Z"
          }
        )
      ]
    }
  );
}
function b1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M15.684 12.037v-.374c.404-.054.8-.087 1.186-.157.247-.045.494-.123.725-.218.654-.263 1.058-.757 1.194-1.44.16-.802.168-1.608-.042-2.402-.078-.3-.222-.58-.35-.896.05.037.091.065.124.098.877.876 1.758 1.749 2.635 2.629.494.498.74 1.127.786 1.81a9.23 9.23 0 0 1-.041 1.72c-.095.801-.613 1.27-1.375 1.484-.099.029-.198.05-.296.078-.194.05-.227.149-.083.293.239.246.486.485.729.728.136.135.272.271.407.403.387.378.655.83.68 1.37.033.724.074 1.46-.025 2.171-.181 1.28-1.013 2.037-2.219 2.407a5.957 5.957 0 0 1-1.766.255c-3.112 0-6.229 0-9.341.004a.485.485 0 0 1-.379-.152c-.906-.913-1.82-1.827-2.734-2.736-.049-.05-.09-.098-.18-.193h9.234c.687 0 1.37-.053 2.033-.251 1.507-.453 2.293-1.452 2.334-3.023.017-.593 0-1.193-.086-1.782-.115-.773-.605-1.304-1.35-1.534-.474-.144-.976-.202-1.466-.288-.103-.02-.206-.004-.334-.004ZM2.012 2h9.741c.74 0 1.474.07 2.149.39.354.17.712.375.992.643.89.843 1.746 1.727 2.614 2.595.03.029.054.062.1.115-.059-.008-.091 0-.116-.016-.881-.502-1.845-.646-2.833-.646-3.12-.004-6.245 0-9.365 0-.062 0-.12.008-.202.012v13.583c-.09-.074-.14-.11-.185-.156-.93-.93-1.857-1.851-2.78-2.785a.488.488 0 0 1-.123-.3C2 11.033 2 6.632 2 2.23c0-.065.008-.135.012-.23Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9.727 13.341h1.692c.59.004 1.178.004 1.767.017.16.004.325.04.481.09.35.111.556.366.585.72.029.374.037.753-.008 1.127-.058.469-.38.72-.902.77-.28.024-.56.032-.84.032-.848.004-1.7-.004-2.548.008-.181 0-.23-.053-.23-.234.008-.831.003-1.666.003-2.53ZM9.727 10.51V9.409c0-.431.009-.863-.004-1.295-.004-.173.054-.222.223-.218.955.008 1.906 0 2.86.008.24 0 .483.02.713.07.486.103.716.374.75.872.016.267.016.535-.005.802-.033.424-.271.704-.687.79-.28.057-.569.082-.857.086-.955.008-1.906.004-2.86.004a.69.69 0 0 0-.133-.016Z"
          }
        )
      ]
    }
  );
}
function P1({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M15.684 12.037v-.374c.404-.054.8-.087 1.186-.157.247-.045.494-.123.725-.218.654-.263 1.058-.757 1.194-1.44.16-.802.168-1.608-.042-2.402-.078-.3-.222-.58-.35-.896.05.037.091.065.124.098.877.876 1.758 1.749 2.635 2.629.494.498.74 1.127.786 1.81a9.23 9.23 0 0 1-.041 1.72c-.095.801-.613 1.27-1.375 1.484-.099.029-.198.05-.296.078-.194.05-.227.149-.083.293.239.246.486.485.729.728.136.135.272.271.407.403.387.378.655.83.68 1.37.033.724.074 1.46-.025 2.171-.181 1.28-1.013 2.037-2.219 2.407a5.957 5.957 0 0 1-1.766.255c-3.112 0-6.229 0-9.341.004a.485.485 0 0 1-.379-.152c-.906-.913-1.82-1.827-2.734-2.736-.049-.05-.09-.098-.18-.193h9.234c.687 0 1.37-.053 2.033-.251 1.507-.453 2.293-1.452 2.334-3.023.017-.593 0-1.193-.086-1.782-.115-.773-.605-1.304-1.35-1.534-.474-.144-.976-.202-1.466-.288-.103-.02-.206-.004-.334-.004ZM2.012 2h9.741c.74 0 1.474.07 2.149.39.354.17.712.375.992.643.89.843 1.746 1.727 2.614 2.595.03.029.054.062.1.115-.059-.008-.091 0-.116-.016-.881-.502-1.845-.646-2.833-.646-3.12-.004-6.245 0-9.365 0-.062 0-.12.008-.202.012v13.583c-.09-.074-.14-.11-.185-.156-.93-.93-1.857-1.851-2.78-2.785a.488.488 0 0 1-.123-.3C2 11.033 2 6.632 2 2.23c0-.065.008-.135.012-.23Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9.727 13.341h1.692c.59.004 1.178.004 1.767.017.16.004.325.04.481.09.35.111.556.366.585.72.029.374.037.753-.008 1.127-.058.469-.38.72-.902.77-.28.024-.56.032-.84.032-.848.004-1.7-.004-2.548.008-.181 0-.23-.053-.23-.234.008-.831.003-1.666.003-2.53ZM9.727 10.51V9.409c0-.431.009-.863-.004-1.295-.004-.173.054-.222.223-.218.955.008 1.906 0 2.86.008.24 0 .483.02.713.07.486.103.716.374.75.872.016.267.016.535-.005.802-.033.424-.271.704-.687.79-.28.057-.569.082-.857.086-.955.008-1.906.004-2.86.004a.69.69 0 0 0-.133-.016Z"
          }
        )
      ]
    }
  );
}
function U1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M5 21c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 19h2v2Zm-2-4v-2h2v2H3Zm0-4v-2h2v2H3Zm0-4V7h2v2H3Zm4 12v-2h2v2H7Zm2-4c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 7 15V5c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 9 3h10c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v10c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 19 17H9Zm0-2h10V5H9v10Zm2 6v-2h2v2h-2Zm4 0v-2h2v2h-2Z"
        }
      )
    }
  );
}
function E1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 21c-.75 0-1.492-.183-2.225-.55C3.042 20.083 2.45 19.6 2 19c.433 0 .875-.17 1.325-.512C3.775 18.146 4 17.65 4 17c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 14c.833 0 1.542.292 2.125.875S10 16.167 10 17c0 1.1-.392 2.042-1.175 2.825C8.042 20.608 7.1 21 6 21Zm0-2c.55 0 1.02-.196 1.412-.587C7.804 18.02 8 17.55 8 17a.967.967 0 0 0-.287-.712A.967.967 0 0 0 7 16a.967.967 0 0 0-.713.288A.967.967 0 0 0 6 17c0 .383-.046.733-.138 1.05a4.73 4.73 0 0 1-.362.9.67.67 0 0 0 .25.05H6Zm5.75-4L9 12.25l8.95-8.95a.977.977 0 0 1 .688-.288.93.93 0 0 1 .712.288l1.35 1.35c.2.2.3.433.3.7 0 .267-.1.5-.3.7L11.75 15Z"
        }
      )
    }
  );
}
function G1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3.775 20.45C4.508 20.817 5.25 21 6 21c1.1 0 2.042-.392 2.825-1.175C9.608 19.042 10 18.1 10 17c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 7 14c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 4 17c0 .65-.225 1.146-.675 1.488-.45.341-.892.512-1.325.512.45.6 1.042 1.083 1.775 1.45Zm3.637-2.037A1.926 1.926 0 0 1 6 19h-.25a.67.67 0 0 1-.25-.05c.15-.283.27-.583.362-.9.092-.317.138-.667.138-1.05 0-.283.096-.52.287-.712A.967.967 0 0 1 7 16c.283 0 .52.096.713.288.191.191.287.429.287.712 0 .55-.196 1.02-.588 1.413Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9 12.25 11.75 15l8.95-8.95c.2-.2.3-.433.3-.7 0-.267-.1-.5-.3-.7L19.35 3.3a.93.93 0 0 0-.713-.288.977.977 0 0 0-.687.288L9 12.25ZM17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"
          }
        )
      ]
    }
  );
}
function W1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3.775 20.45C4.508 20.817 5.25 21 6 21c1.1 0 2.042-.392 2.825-1.175C9.608 19.042 10 18.1 10 17c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 7 14c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 4 17c0 .65-.225 1.146-.675 1.488-.45.341-.892.512-1.325.512.45.6 1.042 1.083 1.775 1.45Zm3.637-2.037A1.926 1.926 0 0 1 6 19h-.25a.67.67 0 0 1-.25-.05c.15-.283.27-.583.362-.9.092-.317.138-.667.138-1.05 0-.283.096-.52.287-.712A.967.967 0 0 1 7 16c.283 0 .52.096.713.288.191.191.287.429.287.712 0 .55-.196 1.02-.588 1.413Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9 12.25 11.75 15l8.95-8.95c.2-.2.3-.433.3-.7 0-.267-.1-.5-.3-.7L19.35 3.3a.93.93 0 0 0-.713-.288.977.977 0 0 0-.687.288L9 12.25ZM22 17v2h-8v-2h8Z"
          }
        )
      ]
    }
  );
}
function N1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 3V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2V1h-6v2H7ZM5 3H3v2h2V3Zm2 2v2H5v10h2v2h10v-2h2V7h-2V5H7Zm12 0h2V3h-2v2Zm0 16h2v-2h-2v2ZM5 21v-2H3v2h2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function j1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 7h10v14H2V3h10v4ZM4 19h2v-2H4v2Zm2-4H4v-2h2v2Zm-2-4h2V9H4v2Zm2-4H4V5h2v2Zm2 12h2v-2H8v2Zm2-4H8v-2h2v2Zm-2-4h2V9H8v2Zm2-4H8V5h2v2Zm10 12V9h-8v2h2v2h-2v2h2v2h-2v2h8Zm-2-8h-2v2h2v-2Zm-2 4h2v2h-2v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function X1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4Zm14 5H6v2h12v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function K1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.71 5a4.28 4.28 0 0 0-3.225 1.462l-5.75 5.744-1.646-1.646a1.696 1.696 0 0 1-.433-1.155 1.73 1.73 0 0 1 1.74-1.73c.42-.004.828.15 1.142.432.102.09.393.391.393.391l1.821-1.82-.526-.527a4.25 4.25 0 0 0-2.935-1.15A4.287 4.287 0 0 0 3 9.284a4.32 4.32 0 0 0 1.055 2.833l3.692 3.708 7.716-7.715c.315-.285.725-.44 1.149-.435A1.73 1.73 0 0 1 18.34 9.42c.004.422-.15.83-.433 1.145L12.78 15.69a1.077 1.077 0 0 1-.782.322 1.06 1.06 0 0 1-.77-.335l-.386-.381-1.812 1.812.37.365a3.646 3.646 0 0 0 2.605 1.097h.003a3.605 3.605 0 0 0 2.59-1.094l5.345-5.356A4.296 4.296 0 0 0 16.71 5Z"
        }
      )
    }
  );
}
function Q1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.71 5a4.28 4.28 0 0 0-3.225 1.462l-5.75 5.744-1.646-1.646a1.696 1.696 0 0 1-.433-1.155 1.73 1.73 0 0 1 1.74-1.73c.42-.004.828.15 1.142.432.102.09.393.391.393.391l1.821-1.82-.526-.527a4.25 4.25 0 0 0-2.935-1.15A4.287 4.287 0 0 0 3 9.284a4.32 4.32 0 0 0 1.055 2.833l3.692 3.708 7.716-7.715c.315-.285.725-.44 1.149-.435A1.73 1.73 0 0 1 18.34 9.42c.004.422-.15.83-.433 1.145L12.78 15.69a1.077 1.077 0 0 1-.782.322 1.06 1.06 0 0 1-.77-.335l-.386-.381-1.812 1.812.37.365a3.646 3.646 0 0 0 2.605 1.097h.003a3.605 3.605 0 0 0 2.59-1.094l5.345-5.356A4.296 4.296 0 0 0 16.71 5Z"
        }
      )
    }
  );
}
function Y1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#0AF",
          d: "M16.71 5a4.28 4.28 0 0 0-3.225 1.462l-5.75 5.744-1.646-1.646a1.696 1.696 0 0 1-.433-1.155 1.73 1.73 0 0 1 1.74-1.73c.42-.004.828.15 1.142.432.102.09.393.391.393.391l1.821-1.82-.526-.527a4.25 4.25 0 0 0-2.935-1.15A4.287 4.287 0 0 0 3 9.284a4.32 4.32 0 0 0 1.055 2.833l3.692 3.708 7.716-7.715c.315-.285.725-.44 1.149-.435A1.73 1.73 0 0 1 18.34 9.42c.004.422-.15.83-.433 1.145L12.78 15.69a1.077 1.077 0 0 1-.782.322 1.06 1.06 0 0 1-.77-.335l-.386-.381-1.812 1.812.37.365a3.646 3.646 0 0 0 2.605 1.097h.003a3.605 3.605 0 0 0 2.59-1.094l5.345-5.356A4.296 4.296 0 0 0 16.71 5Z"
        }
      )
    }
  );
}
function J1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M15.2 12a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.17 4 9 2h6l1.83 2H20c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3.17ZM7 12c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function q1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16 6h4c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2Zm-6 0h4V4h-4v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function _1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
        }
      )
    }
  );
}
function $1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M8 12h8v2H8v-2ZM14 16H8v2h6v-2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 16V10h12v10H6Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function z1({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M8 13h8v2H8v-2ZM14 16H8v2h6v-2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 0h12v5H6V4Zm0 7v9h12v-9H6Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function l2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m7 10 5 5 5-5H7Z" })
    }
  );
}
function t2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m14 7-5 5 5 5V7Z" })
    }
  );
}
function e2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m10 17 5-5-5-5v10Z" })
    }
  );
}
function r2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m7 14 5-5 5 5H7Z" })
    }
  );
}
function i2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 19h10V4H7v15Zm-5-2h4V6H2v11Zm16 0V6h4v11h-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function n2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.006 22c-.551 0-1.022-.196-1.414-.587A1.925 1.925 0 0 1 6.004 20c0-.55.196-1.02.588-1.413A1.928 1.928 0 0 1 8.006 18c.55 0 1.021.196 1.413.587.392.392.588.863.588 1.413s-.196 1.02-.588 1.413A1.928 1.928 0 0 1 8.006 22Zm10.009 0c-.55 0-1.022-.196-1.414-.587A1.925 1.925 0 0 1 16.013 20c0-.55.196-1.02.588-1.413A1.928 1.928 0 0 1 18.015 18c.55 0 1.022.196 1.414.587.392.392.588.863.588 1.413s-.196 1.02-.588 1.413a1.928 1.928 0 0 1-1.414.587ZM7.155 6l2.402 5h7.007l2.752-5H7.155Zm-.951-2h14.764c.383 0 .675.17.875.513.2.341.209.687.025 1.037l-3.553 6.4c-.183.333-.43.592-.738.775a1.948 1.948 0 0 1-1.014.275H9.108l-1.101 2h12.01v2H8.007c-.751 0-1.318-.33-1.702-.988-.384-.658-.4-1.312-.05-1.962l1.351-2.45L4.002 4H2V2h3.253l.95 2Z"
        }
      )
    }
  );
}
function h2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m7 14 5 5 5-5H7ZM17 10l-5-5-5 5h10Z" })
    }
  );
}
function c2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 3v9c0 .55-.45 1-1 1H6l-4 4V3c0-.55.45-1 1-1h13c.55 0 1 .45 1 1Zm2 3h2c.55 0 1 .45 1 1v15l-4-4H7c-.55 0-1-.45-1-1v-2h13V6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function o2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17Z"
        }
      )
    }
  );
}
function d2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2Zm-1.4 14.6 7.05-7.05-1.4-1.4-5.65 5.65-2.85-2.85-1.4 1.4 4.25 4.25Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function v2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "m7 12.5 3.47 3.5L17 9.41 15.6 8l-5.13 5.17-2.07-2.08L7 12.5Z"
          }
        )
      ]
    }
  );
}
function a2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 2a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function u2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5ZM4 14h12v2H4v-2ZM14 18H4v2h10v-2Z"
        }
      )
    }
  );
}
function w2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2Zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59Z"
        }
      )
    }
  );
}
function s2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3.27 5 2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5ZM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6Z"
        }
      )
    }
  );
}
function g2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m11.4 16 2.6-2.6 2.6 2.6 1.4-1.4-2.6-2.6L18 9.4 16.6 8 14 10.6 11.4 8 10 9.4l2.6 2.6-2.6 2.6 1.4 1.4ZM3 12l4.35-6.15c.183-.267.42-.475.713-.625A2.02 2.02 0 0 1 9 5h10c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v10c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 19H9a2.02 2.02 0 0 1-.938-.225 1.911 1.911 0 0 1-.712-.625L3 12Z"
        }
      )
    }
  );
}
function p2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm7 18H5V4h2v3h10V4h2v16Z"
        }
      )
    }
  );
}
function f2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M5 20c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 18V6c0-.55.196-1.02.587-1.412A1.927 1.927 0 0 1 5 4h14c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 19 20H5Zm0-2h14V6H5v12Zm2-3h3a.968.968 0 0 0 .713-.288A.967.967 0 0 0 11 14v-1H9.5v.5h-2v-3h2v.5H11v-1a.97.97 0 0 0-.287-.713A.97.97 0 0 0 10 9H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 10v4c0 .283.096.52.287.712.192.192.43.288.713.288Zm7 0h3c.283 0 .52-.096.712-.288A.965.965 0 0 0 18 14v-1h-1.5v.5h-2v-3h2v.5H18v-1a.968.968 0 0 0-.288-.713A.967.967 0 0 0 17 9h-3a.967.967 0 0 0-.712.287A.968.968 0 0 0 13 10v4c0 .283.096.52.288.712A.965.965 0 0 0 14 15Z"
        }
      )
    }
  );
}
function m2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 20c-1.517 0-2.813-.525-3.888-1.575C1.537 17.375 1 16.092 1 14.575c0-1.3.392-2.458 1.175-3.475S3.983 9.433 5.25 9.15c.417-1.533 1.25-2.775 2.5-3.725C9 4.475 10.417 4 12 4c1.95 0 3.604.68 4.962 2.037C18.322 7.396 19 9.05 19 11c1.15.133 2.104.63 2.863 1.488A4.407 4.407 0 0 1 23 15.5c0 1.25-.438 2.313-1.313 3.188S19.75 20 18.5 20h-12Zm0-2h12c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-1.383-.488-2.563-1.463-3.537C14.563 6.487 13.383 6 12 6s-2.563.487-3.537 1.463C7.488 8.437 7 9.617 7 11h-.5c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 3 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0 0 6.5 18Z"
        }
      )
    }
  );
}
function Z2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.35 17 16 11.35 14.55 9.9l-4.225 4.225-2.1-2.1L6.8 13.45 10.35 17ZM6.5 20c-1.517 0-2.813-.525-3.888-1.575C1.537 17.375 1 16.092 1 14.575c0-1.3.392-2.458 1.175-3.475S3.983 9.433 5.25 9.15c.417-1.533 1.25-2.775 2.5-3.725C9 4.475 10.417 4 12 4c1.95 0 3.604.68 4.962 2.037C18.322 7.396 19 9.05 19 11c1.15.133 2.104.63 2.863 1.488A4.407 4.407 0 0 1 23 15.5c0 1.25-.438 2.313-1.313 3.188S19.75 20 18.5 20h-12Zm0-2h12c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-1.383-.488-2.563-1.463-3.537C14.563 6.487 13.383 6 12 6s-2.563.487-3.537 1.463C7.488 8.437 7 9.617 7 11h-.5c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 3 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0 0 6.5 18Z"
        }
      )
    }
  );
}
function x2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4Zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4Z"
        }
      )
    }
  );
}
function C2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 19H3V5h5v14Zm6.5 0H10v-6h4.5v6Zm2 0H21v-6h-4.5v6ZM10 11V5h11v6H10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function y2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2Zm-11-4 2.03 2.71L16 11l4 5H8l3-4Zm-9 8V6h2v14h14v2H4c-1.1 0-2-.9-2-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function A2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8Zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12ZM8 6.5C8 7.33 8.67 8 9.5 8S11 7.33 11 6.5 10.33 5 9.5 5 8 5.67 8 6.5ZM14.5 8c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8Zm1.5 2.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S18.33 9 17.5 9s-1.5.67-1.5 1.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function M2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m20.71 5.63-2.34-2.34a.996.996 0 0 0-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42ZM6.92 19 5 17.08l8.06-8.06 1.92 1.92L6.92 19Z"
        }
      )
    }
  );
}
function H2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5Zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 16H7V3h14v14Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M12.778 6.283 14 5l1.222 1.283.004.004.008.008.025.027a13.827 13.827 0 0 1 .386.43c.243.282.57.676.899 1.128.326.447.674.976.945 1.523.26.523.511 1.182.511 1.857 0 1.942-1.668 3.74-4 3.74s-4-1.798-4-3.74c0-.675.25-1.334.51-1.857.272-.547.62-1.076.947-1.523a17.709 17.709 0 0 1 1.284-1.558l.025-.027.008-.008.004-.004Z"
          }
        )
      ]
    }
  );
}
function V2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z"
        }
      )
    }
  );
}
function B2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15 21h2v-2h-2v2Zm4-12h2V7h-2v2ZM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2Zm16-2v2h2c0-1.1-.9-2-2-2Zm-8 20h2V1h-2v22Zm8-6h2v-2h-2v2ZM15 5h2V3h-2v2Zm4 8h2v-2h-2v2Zm0 8c1.1 0 2-.9 2-2h-2v2Z"
        }
      )
    }
  );
}
function I2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 17.5 14 14l3.5-7.5L10 10l-3.5 7.5ZM12 13a.965.965 0 0 1-.712-.288A.965.965 0 0 1 11 12c0-.283.096-.521.288-.713A.967.967 0 0 1 12 11a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 12c0 .283-.096.52-.287.712A.968.968 0 0 1 12 13Zm0 9a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function L2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2Zm3.132 6.39a.527.527 0 0 1 0-.745l1.49-1.49a.527.527 0 0 1 .746 0l1.491 1.49a.527.527 0 0 1 0 .746l-1.49 1.49a.527.527 0 0 1-.746 0l-1.491-1.49Zm-2.982 2.983a.527.527 0 0 1 0-.746l1.491-1.49a.527.527 0 0 1 .745 0l1.491 1.49a.527.527 0 0 1 0 .746l-1.49 1.49a.527.527 0 0 1-.746 0l-1.491-1.49Zm2.982 2.236a.527.527 0 0 0 0 .746l1.49 1.49c.207.207.54.207.746 0l1.491-1.49a.527.527 0 0 0 0-.746l-1.49-1.49a.527.527 0 0 0-.746 0l-1.491 1.49Zm2.982-2.236a.527.527 0 0 1 0-.746l1.49-1.49a.527.527 0 0 1 .746 0l1.491 1.49a.527.527 0 0 1 0 .746l-1.49 1.49a.527.527 0 0 1-.746 0l-1.491-1.49Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function R2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17.5 20.5a3.372 3.372 0 0 1-2.475-1.025A3.372 3.372 0 0 1 14 17c0-.967.342-1.792 1.025-2.475A3.372 3.372 0 0 1 17.5 13.5c.967 0 1.792.342 2.475 1.025A3.372 3.372 0 0 1 21 17c0 .967-.342 1.792-1.025 2.475A3.372 3.372 0 0 1 17.5 20.5Zm0-2c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0 0 17.5 15.5c-.417 0-.77.146-1.063.438A1.446 1.446 0 0 0 16 17c0 .417.146.77.438 1.063.291.291.645.437 1.062.437ZM3 18v-2h9v2H3Zm3.5-7.5a3.372 3.372 0 0 1-2.475-1.025A3.372 3.372 0 0 1 3 7c0-.967.342-1.792 1.025-2.475A3.372 3.372 0 0 1 6.5 3.5c.967 0 1.792.342 2.475 1.025A3.372 3.372 0 0 1 10 7c0 .967-.342 1.792-1.025 2.475A3.372 3.372 0 0 1 6.5 10.5Zm0-2c.417 0 .77-.146 1.063-.438C7.854 7.771 8 7.418 8 7c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0 0 6.5 5.5c-.417 0-.77.146-1.063.438A1.447 1.447 0 0 0 5 7c0 .417.146.77.438 1.063.291.291.645.437 1.062.437ZM12 8V6h9v2h-9Z"
        }
      )
    }
  );
}
function S2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 21c-2.217 0-4.104-.77-5.662-2.313C4.779 17.146 4 15.284 4 13.1c0-1.1.208-2.117.625-3.05a8.288 8.288 0 0 1 1.725-2.5L12 2l5.65 5.55a8.289 8.289 0 0 1 1.725 2.5c.417.933.625 1.95.625 3.05 0 2.183-.78 4.046-2.337 5.588C16.104 20.229 14.217 21 12 21Zm0-2V4.8L7.75 9a5.466 5.466 0 0 0-1.313 1.863A5.7 5.7 0 0 0 6 13.1c0 1.617.583 3.004 1.75 4.162C8.917 18.421 10.333 19 12 19Z"
        }
      )
    }
  );
}
function F2({
  size: l = "20px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.626 5.168A.5.5 0 0 1 8 5h8.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.395-.193l-3.5-4.5a.5.5 0 0 1 .021-.64l4-4.5ZM8.225 6 4.65 10.021 7.745 14H16V6H8.225Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9.146 7.146a.5.5 0 0 1 .708 0L12 9.293l2.146-2.147a.5.5 0 0 1 .708.708L12.707 10l2.147 2.146a.5.5 0 0 1-.708.708L12 10.707l-2.146 2.147a.5.5 0 0 1-.708-.708L11.293 10 9.146 7.854a.5.5 0 0 1 0-.708Z"
          }
        )
      ]
    }
  );
}
function T2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.5 5C5.675 5 5 5.672 5 6.5 5 7.312 5.76 8 6.5 8H8V6.5C8 5.675 7.328 5 6.5 5ZM9 8V6.5C9 5.125 7.881 4 6.5 4A2.503 2.503 0 0 0 4 6.5C4 7.897 5.24 9 6.5 9H8v2H6.5A2.506 2.506 0 0 0 4 13.5C4 14.876 5.124 16 6.5 16S9 14.876 9 13.5V12h2v1.5c0 1.376 1.124 2.5 2.5 2.5 1.375 0 2.5-1.118 2.5-2.5 0-1.381-1.125-2.5-2.5-2.5H12V9h1.5A2.5 2.5 0 1 0 11 6.5V8H9Zm0 1v2h2V9H9Zm3-1V6.5A1.5 1.5 0 1 1 13.5 8H12Zm0 4h1.5c.825 0 1.5.672 1.5 1.5s-.675 1.5-1.5 1.5c-.824 0-1.5-.676-1.5-1.5V12Zm-4 0H6.5c-.824 0-1.5.676-1.5 1.5S5.676 15 6.5 15 8 14.324 8 13.5V12Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function k2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m6.35 8.85-.7-.7 3.996-4.004a.5.5 0 0 1 .708 0L14.35 8.15l-.7.7L10 5.2 6.35 8.85Z"
        }
      )
    }
  );
}
function D2({
  size: l = "20px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.5 12.8V5.5a.5.5 0 0 1 1 0v7.3l3.15-3.15.7.7-3.997 4.004a.5.5 0 0 1-.707 0L5.65 10.35l.7-.7L9.5 12.8Z"
        }
      )
    }
  );
}
function O2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 5.5a.5.5 0 0 0 0 1h3a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5H6.33l3-2.624-.66-.752-4 3.5a.5.5 0 0 0 0 .752l4 3.5.66-.752-3-2.624H14a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 14 5.5h-3Z"
        }
      )
    }
  );
}
function b2({
  size: l = "20px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m9.4 14.1.7-.7-3.15-3.15h7.3a.5.5 0 0 0 0-1h-7.3L10.1 6.1l-.7-.7-4.004 3.996a.5.5 0 0 0 0 .707L9.4 14.1Z"
        }
      )
    }
  );
}
function P2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 6h3.812l4.238 8.719a.5.5 0 0 0 .45.281H17v-1h-4.187L8.575 5.281A.5.5 0 0 0 8.125 5H4v1ZM12 6h5V5h-5v1Z"
        }
      )
    }
  );
}
function U2({
  size: l = "20px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m10.6 5.15-.7.7L13.05 9h-7.3a.5.5 0 0 0 0 1h7.3L9.9 13.15l.7.7 4.004-3.996a.5.5 0 0 0 0-.708L10.6 5.15Z"
        }
      )
    }
  );
}
function E2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.662 4.131a.5.5 0 0 1 .676 0l6 5.5A.5.5 0 0 1 16 10.5h-3v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4H4a.5.5 0 0 1-.338-.869l6-5.5ZM5.285 9.5H7.5a.5.5 0 0 1 .5.5v4h4v-4a.5.5 0 0 1 .5-.5h2.215L10 5.178 5.285 9.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function G2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 13.5v-3h1V13h7v-2.5h1v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function W2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m5.65 9.15.7.7L9.5 6.7V14a.5.5 0 0 0 1 0V6.7l3.15 3.15.7-.7-3.996-4.004a.5.5 0 0 0-.708 0L5.65 9.15Z"
        }
      )
    }
  );
}
function N2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M15 12 9 8v8l6-4Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22.72 17.57c.03.28.02.57-.01.86l1.06.85c.1.08.12.21.06.32l-1.03 1.79c-.06.11-.19.16-.31.11l-1.28-.5c-.23.16-.48.31-.74.42l-.2 1.36c-.02.12-.13.21-.25.21h-2.07c-.13 0-.23-.09-.25-.21l-.2-1.36c-.27-.11-.52-.25-.75-.42l-1.27.5c-.12.04-.25 0-.31-.11l-1.03-1.79a.248.248 0 0 1 .06-.32l1.07-.85c-.03-.28-.02-.57.01-.86l-1.07-.86a.248.248 0 0 1-.06-.32l1.03-1.79c.06-.11.19-.16.31-.11l1.28.5c.23-.16.48-.31.74-.42l.2-1.36c.02-.12.13-.21.25-.21h2.07c.13 0 .23.09.25.22l.2 1.36c.27.11.52.25.75.42l1.28-.5c.12-.04.25 0 .31.11l1.03 1.79c.06.11.04.24-.06.32l-1.07.85ZM17.5 18c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function j2({ size: l = "20px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 20 20",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.714 10.286h-6a.286.286 0 0 0-.285.285v4.243a.286.286 0 0 0 .242.286l6 .9h.043a.286.286 0 0 0 .286-.286v-5.143a.285.285 0 0 0-.286-.285Zm-7.143 0H4.286A.286.286 0 0 0 4 10.57V14a.286.286 0 0 0 .243.286l4.286.643h.042a.286.286 0 0 0 .286-.286V10.57a.285.285 0 0 0-.286-.285ZM15.9 4.069a.286.286 0 0 0-.229-.066l-6 .9a.286.286 0 0 0-.242.286v4.24a.286.286 0 0 0 .285.285h6A.285.285 0 0 0 16 9.43V4.286a.285.285 0 0 0-.1-.217ZM8.529 5.074l-4.286.64A.286.286 0 0 0 4 6v3.429a.286.286 0 0 0 .286.285H8.57a.286.286 0 0 0 .286-.285V5.357a.286.286 0 0 0-.1-.214.286.286 0 0 0-.228-.069Z"
        }
      )
    }
  );
}
function X2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM6 9h12v2H6V9Zm8 5H6v-2h8v2Zm4-6H6V6h12v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function K2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22a9.749 9.749 0 0 1-3.9-.787 10.101 10.101 0 0 1-3.175-2.134 10.085 10.085 0 0 1-2.137-3.171A9.715 9.715 0 0 1 2 12.012c0-1.248.242-2.471.725-3.67A10.475 10.475 0 0 1 4.75 5.134 10.005 10.005 0 0 1 7.875 2.86c1.217-.574 2.55-.861 4-.861.35 0 .708.017 1.075.05s.742.091 1.125.175c-.15.749-.1 1.456.15 2.122.25.666.625 1.22 1.125 1.66.5.442 1.096.745 1.787.912.692.166 1.405.125 2.138-.125-.433.982-.37 1.923.188 2.821.558.9 1.387 1.365 2.487 1.399a9.797 9.797 0 0 1 .05 1.024c0 1.364-.262 2.65-.788 3.857a10.278 10.278 0 0 1-2.137 3.171 9.995 9.995 0 0 1-3.175 2.148A9.749 9.749 0 0 1 12 22Zm-1.5-11.985c.417 0 .77-.146 1.063-.437.291-.291.437-.645.437-1.061 0-.416-.146-.77-.438-1.061a1.447 1.447 0 0 0-1.062-.437c-.417 0-.77.145-1.063.437A1.444 1.444 0 0 0 9 8.516c0 .417.146.77.438 1.062.291.291.645.437 1.062.437Zm-2 4.994c.417 0 .77-.146 1.063-.437.291-.291.437-.645.437-1.061 0-.416-.146-.77-.438-1.062a1.447 1.447 0 0 0-1.062-.437c-.417 0-.77.146-1.063.437A1.444 1.444 0 0 0 7 13.511c0 .416.146.77.438 1.06.291.292.645.438 1.062.438Zm6.5.998c.283 0 .52-.095.713-.287A.966.966 0 0 0 16 15.01a.966.966 0 0 0-.287-.712.968.968 0 0 0-.713-.287.968.968 0 0 0-.713.287.966.966 0 0 0-.287.712c0 .283.096.52.287.711.192.192.43.287.713.287Zm-3 3.995c2.033 0 3.838-.699 5.413-2.097 1.575-1.398 2.437-3.18 2.587-5.343-.833-.366-1.488-.866-1.962-1.498a5.348 5.348 0 0 1-.963-2.123 5.69 5.69 0 0 1-3.3-1.648 5.951 5.951 0 0 1-1.7-3.296c-1.333-.033-2.504.209-3.512.725-1.009.516-1.85 1.177-2.526 1.985A8.66 8.66 0 0 0 4.513 9.34C4.17 10.29 4 11.18 4 12.012c0 2.214.78 4.1 2.338 5.656S9.783 20.003 12 20.003Z"
        }
      )
    }
  );
}
function Q2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2ZM8 21h11V7H8v14Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Y2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.08 10.86c.05-.33.16-.62.3-.87.14-.25.34-.46.59-.62.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53c.09.2.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29-.17-.39-.4-.73-.7-1.01-.3-.28-.66-.5-1.08-.66-.42-.16-.88-.23-1.39-.23-.65 0-1.22.11-1.7.34-.48.23-.88.53-1.2.92-.32.39-.56.84-.71 1.36-.15.52-.24 1.06-.24 1.64v.27c0 .58.08 1.12.23 1.64.15.52.39.97.71 1.35.32.38.72.69 1.2.91.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23.41-.15.77-.36 1.08-.63.31-.27.56-.58.74-.94.18-.36.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58-.09.18-.21.33-.36.46s-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23a1.75 1.75 0 0 1-.59-.62c-.14-.25-.25-.55-.3-.88a6.74 6.74 0 0 1-.08-1v-.27c0-.35.03-.68.08-1.01ZM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"
        }
      )
    }
  );
}
function J2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7 19h10v-9h-1V7h-3V4H7v15Zm-5-2h4V6H2v11Zm16 0v-7h2V7h2v10h-4Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M19 6v2.99s-1.99.01-2 0V6h-3V4h3V1h2v3h3v2h-3Z" })
      ]
    }
  );
}
function q2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2Zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2Z"
        }
      )
    }
  );
}
function _2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 1v16h16v2h-4v4h-2v-4H7c-1.1 0-2-.9-2-2V7H1V5h4V1h2Zm12 14h-2V7H9V5h8c1.1 0 2 .9 2 2v8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function $2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34ZM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11ZM16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6Zm-8 2V4H6v2H4v2h2v8a2 2 0 0 0 2 2h8v2h2v-2h2v-2H8Z"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "a", children: /* @__PURE__ */ t("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
      ]
    }
  );
}
function z2({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M19 19a2 2 0 0 0 2-2v-6h-2v6h-3V8h-1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14ZM8 7v10H5V7h3Zm2 10h4V7h-4v10Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M21 7v2.99s-1.99.01-2 0V7h-3V5h3V2h2v3h3v2h-3Z" })
      ]
    }
  );
}
function l0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h8v8H3V3Zm10 0h8v8h-8V3ZM3 13h8v8H3v-8Zm13 0h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Zm-1-8v4h4V5h-4ZM5 5v4h4V5H5Zm0 10v4h4v-4H5Z"
        }
      )
    }
  );
}
function t0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64ZM6 8a2 2 0 1 1-.001-3.999A2 2 0 0 1 6 8ZM4 18a2 2 0 1 0 3.999.001A2 2 0 0 0 4 18Zm8-5.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5ZM13 9l6-6h3v1l-7 7-2-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function e0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 3h1c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h1V1h2v2h10V1h2v2ZM4 21h16V8H4v13Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function r0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.5 4H19v2H5V4h3.5l1-1h5l1 1ZM8 21c-1.1 0-2-.9-2-2V7h12v12c0 1.1-.9 2-2 2H8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function i0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 9v10h8V9H8ZM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM15.5 4H19v2H5V4h3.5l1-1h5l1 1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function n0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 13h2v-2H3v2Zm4 8h2v-2H7v2Zm6-18h-2v2h2V3Zm6 0v2h2c0-1.1-.9-2-2-2ZM5 21v-2H3c0 1.1.9 2 2 2Zm-2-4h2v-2H3v2Zm8 4h2v-2h-2v2Zm8-8h2v-2h-2v2Zm0-4h2V7h-2v2Zm-4-4h2V3h-2v2ZM7.83 5 7 4.17V3h2v2H7.83Zm12 12-.83-.83V15h2v2h-1.17Zm1.36 4.19L2.81 2.81 1.39 4.22 4.17 7H3v2h2V7.83l2 2V17h7.17l2 2H15v2h2v-1.17l2.78 2.78 1.41-1.42ZM9 15v-3.17L12.17 15H9Zm6-2.83V9h-3.17l-2-2H17v7.17l-2-2Z"
        }
      )
    }
  );
}
function h0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2 20v-3h2V6c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 6 4h15v2H6v11h6v3H2Zm13 0a.968.968 0 0 1-.713-.288A.968.968 0 0 1 14 19V9c0-.283.096-.52.287-.713A.968.968 0 0 1 15 8h6c.283 0 .52.096.712.287.192.192.288.43.288.713v10c0 .283-.096.52-.288.712A.968.968 0 0 1 21 20h-6Zm1-3h4v-7h-4v7Z"
        }
      )
    }
  );
}
function c0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20ZM7.1 5.69 18.31 16.9A7.902 7.902 0 0 0 20 12c0-4.42-3.58-8-8-8-1.85 0-3.55.63-4.9 1.69Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function o0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8V2Z" })
    }
  );
}
function d0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 22H2V2h2v20ZM22 7H6v3h16V7Zm-6 7H6v3h10v-3Z" })
    }
  );
}
function v0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M20 2h2v20h-2V2ZM2 10h16V7H2v3Zm6 7h10v-3H8v3Z" })
    }
  );
}
function a0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 22H2V2h2v20ZM22 2h-2v20h2V2ZM14 18h-4V6h4v12Z" })
    }
  );
}
function u0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 22H2v-2h20v2ZM10 2H7v16h3V2Zm7 6h-3v10h3V8Z" })
    }
  );
}
function w0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 11h-5V6h-3v5h-4V3H7v8H1.84v2H7v8h3v-8h4v5h3v-5h5v-2Z"
        }
      )
    }
  );
}
function s0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 2v2H2V2h20ZM7 22h3V6H7v16Zm7-6h3V6h-3v10Z" })
    }
  );
}
function g0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 2v2H2V2h20ZM2 20v2h20v-2H2ZM18 14H6v-4h12v4Z" })
    }
  );
}
function p0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m8 7 4-4 4 4H8ZM8 17l4 4 4-4H8ZM22 11H2v2h20v-2Z" })
    }
  );
}
function f0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6Zm2 16H8v-2h8v2Zm0-4H8v-2h8v2Zm-3-5V3.5L18.5 9H13Z"
        }
      )
    }
  );
}
function m0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 13H4v-2h4v2ZM14 13h-4v-2h4v2ZM20 13h-4v-2h4v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Z0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2Zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5Z"
        }
      )
    }
  );
}
function x0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 15.17V15h2v2.17l-2-2Zm-2.59-2.58L17 11l-1.41-1.41L14 11.17l1.41 1.42ZM13 10.17V4h-2v4.17l2 2Zm8.19 11.02-1.78-1.78-16.6-16.6-1.42 1.41 6.19 6.19L7 11l5 5 .59-.59L15.17 18H6v-3H4v3c0 1.1.9 2 2 2h11.17l2.61 2.61 1.41-1.42Z"
        }
      )
    }
  );
}
function C0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm8-14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Zm-2 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function y0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5 3 7.887l4.5 2.844L12 7.887 7.5 5Zm9 0L12 7.887l4.5 2.844L21 7.887 16.5 5ZM3 13.618l4.5 2.886 4.5-2.886-4.5-2.887L3 13.618Zm13.5-2.887L12 13.618l4.5 2.886 4.5-2.886-4.5-2.887Zm-9 6.707 4.5 2.887 4.5-2.887-4.5-2.844-4.5 2.844Z"
        }
      )
    }
  );
}
function A0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5 3 7.887l4.5 2.844L12 7.887 7.5 5Zm9 0L12 7.887l4.5 2.844L21 7.887 16.5 5ZM3 13.618l4.5 2.886 4.5-2.886-4.5-2.887L3 13.618Zm13.5-2.887L12 13.618l4.5 2.886 4.5-2.886-4.5-2.887Zm-9 6.707 4.5 2.887 4.5-2.887-4.5-2.844-4.5 2.844Z"
        }
      )
    }
  );
}
function M0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#1F66FB",
          d: "M7.5 5 3 7.887l4.5 2.844L12 7.887 7.5 5Zm9 0L12 7.887l4.5 2.844L21 7.887 16.5 5ZM3 13.618l4.5 2.886 4.5-2.886-4.5-2.887L3 13.618Zm13.5-2.887L12 13.618l4.5 2.886 4.5-2.886-4.5-2.887Zm-9 6.707 4.5 2.887 4.5-2.887-4.5-2.844-4.5 2.844Z"
        }
      )
    }
  );
}
function H0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7Zm4.5 7H14V6.5l5.5 5.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function V0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.71 5.63c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM3 21v-3.75L14.06 6.19l3.75 3.75L6.75 21H3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function B0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 4V2h8v2H3Zm3 7V7H3V5h8v2H8v4H6Zm7.7 10.6-1.4-1.4 7.8-7.8 1.4 1.4-7.8 7.8Zm.8-5.6c-.433 0-.792-.142-1.075-.425-.283-.283-.425-.642-.425-1.075 0-.433.142-.792.425-1.075.283-.283.642-.425 1.075-.425.433 0 .792.142 1.075.425.283.283.425.642.425 1.075 0 .433-.142.792-.425 1.075-.283.283-.642.425-1.075.425Zm5 5c-.433 0-.792-.142-1.075-.425-.283-.283-.425-.642-.425-1.075 0-.433.142-.792.425-1.075.283-.283.642-.425 1.075-.425.433 0 .792.142 1.075.425.283.283.425.642.425 1.075 0 .433-.142.792-.425 1.075-.283.283-.642.425-1.075.425Zm-4-10c-.683 0-1.27-.246-1.762-.738A2.403 2.403 0 0 1 13 8.5c0-.683.246-1.28.738-1.788.491-.508 1.079-.762 1.762-.762a2.92 2.92 0 0 1 1 .15V3c0-.283.096-.521.288-.713A.967.967 0 0 1 17.5 2H21v2h-3v4.5c0 .683-.246 1.27-.737 1.762A2.406 2.406 0 0 1 15.5 11Zm-10 11c-.683 0-1.27-.254-1.762-.762C3.246 20.729 3 20.133 3 19.45c0-.3.063-.604.188-.912.125-.309.312-.588.562-.838l1.05-1.05-.35-.35a2.586 2.586 0 0 1-.562-.813 2.346 2.346 0 0 1-.188-.937c0-.683.246-1.271.738-1.763A2.405 2.405 0 0 1 6.2 12.05c.683 0 1.271.246 1.763.737.491.492.737 1.08.737 1.763 0 .333-.054.646-.162.937A2.27 2.27 0 0 1 8 16.3l-.35.35.7.7 1.4-1.4 1.4 1.45-1.4 1.4 1.4 1.4-1.4 1.4-1.4-1.4-1.05 1.05a2.51 2.51 0 0 1-1.8.75Zm.7-6.75.35-.35c.05-.05.087-.1.112-.15a.445.445 0 0 0 .038-.2c0-.15-.05-.27-.15-.362a.5.5 0 0 0-.35-.138.5.5 0 0 0-.35.138.467.467 0 0 0-.15.362c0 .05.013.108.038.175a.48.48 0 0 0 .112.175l.35.35ZM5.45 20a.73.73 0 0 0 .2-.038.462.462 0 0 0 .2-.112l1.1-1.05-.7-.7-1.1 1.05a.491.491 0 0 0-.113.175.645.645 0 0 0-.037.225.44.44 0 0 0 .125.325.44.44 0 0 0 .325.125Z"
        }
      )
    }
  );
}
function I0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M18 13h-6v6h6v-6Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 5v13H4V8h16Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function L0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 15v-2h2v2h-2Zm0-10v6h2V7h-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function R0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 4c-4.415 0-8 3.585-8 8s3.585 8 8 8 8-3.585 8-8-3.585-8-8-8ZM2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M13 15h-2v2h2v-2ZM13 7h-2v6h2V7Z" })
      ]
    }
  );
}
function S0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59ZM19 3H5a2 2 0 0 0-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z"
        }
      )
    }
  );
}
function F0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 8h3V5h2v5H5V8Zm3 8H5v-2h5v5H8v-3Zm6 3h2v-3h3v-2h-5v5Zm2-14v3h3v2h-5V5h2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function T0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 19c9 0 15-5 15-15h2c0 11-7 17-17 17v-2Z" })
    }
  );
}
function k0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m9.4 10.5 4.77-8.26a9.984 9.984 0 0 0-8.49 2.01l3.66 6.35.06-.1ZM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66Zm.26 1h-7.49l.29.5 4.76 8.25A9.91 9.91 0 0 0 22 12c0-.69-.07-1.35-.2-2ZM8.54 12l-3.9-6.75A9.958 9.958 0 0 0 2.2 14h7.49l-1.15-2Zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46Zm11.27 0-3.9 6.76a9.984 9.984 0 0 0 8.49-2.01l-3.66-6.35-.93 1.6Z"
        }
      )
    }
  );
}
function D0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 0 0 0-5Z"
        }
      )
    }
  );
}
function O0({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.8 21H5c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 19v-3.8c.8 0 1.5-.254 2.1-.762.6-.509.9-1.155.9-1.938 0-.783-.3-1.43-.9-1.938A3.15 3.15 0 0 0 3 9.8V6c0-.55.196-1.02.587-1.412A1.927 1.927 0 0 1 5 4h4c0-.7.242-1.292.725-1.775.483-.483 1.075-.725 1.775-.725s1.292.242 1.775.725C13.758 2.708 14 3.3 14 4h4c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v4c.7 0 1.292.242 1.775.725.483.483.725 1.075.725 1.775s-.242 1.292-.725 1.775C21.292 14.758 20.7 15 20 15v4c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 18 21h-3.8c0-.833-.262-1.542-.787-2.125S12.25 18 11.5 18s-1.387.292-1.912.875C9.063 19.458 8.8 20.167 8.8 21ZM5 19h2.125c.4-1.1 1.042-1.875 1.925-2.325.883-.45 1.7-.675 2.45-.675.75 0 1.567.225 2.45.675.883.45 1.525 1.225 1.925 2.325H18v-6h2a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7A.48.48 0 0 0 20 12h-2V6h-6V4a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0A.48.48 0 0 0 11 4v2H5v2.2c.9.333 1.625.892 2.175 1.675.55.783.825 1.658.825 2.625 0 .95-.275 1.817-.825 2.6A4.666 4.666 0 0 1 5 16.8V19Z"
        }
      )
    }
  );
}
function b0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm14 14v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4Zm4-14V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2Zm-8 4c-.85 0-1.563-.287-2.137-.863C9.288 10.563 9 9.85 9 9c0-.833.287-1.542.863-2.125C10.438 6.292 11.15 6 12 6c.833 0 1.542.292 2.125.875S15 8.167 15 9c0 .85-.292 1.563-.875 2.137-.583.575-1.292.863-2.125.863Zm-6 6v-1.9c0-.35.088-.68.263-.988.175-.308.412-.554.712-.737.767-.45 1.57-.792 2.412-1.025A9.735 9.735 0 0 1 12 13c.9 0 1.77.117 2.613.35.841.233 1.645.575 2.412 1.025.3.183.538.43.713.738.175.308.262.637.262.987V18H6Z"
        }
      )
    }
  );
}
function P0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21.106 12.053a9.053 9.053 0 1 0-10.468 8.943V14.67H8.34v-2.617h2.299v-1.995c0-2.268 1.351-3.522 3.419-3.522.99 0 2.026.177 2.026.177v2.228h-1.141c-1.125 0-1.475.698-1.475 1.414v1.698h2.51l-.401 2.617h-2.11v6.326c4.329-.679 7.64-4.424 7.64-8.943Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function U0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21.106 12.053a9.053 9.053 0 1 0-10.468 8.943V14.67H8.34v-2.617h2.299v-1.995c0-2.268 1.351-3.522 3.419-3.522.99 0 2.026.177 2.026.177v2.228h-1.141c-1.125 0-1.475.698-1.475 1.414v1.698h2.51l-.401 2.617h-2.11v6.326c4.329-.679 7.64-4.424 7.64-8.943Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function E0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#006BFA",
          fillRule: "evenodd",
          d: "M21.106 12.053a9.053 9.053 0 1 0-10.468 8.943V14.67H8.34v-2.617h2.299v-1.995c0-2.268 1.351-3.522 3.419-3.522.99 0 2.026.177 2.026.177v2.228h-1.141c-1.125 0-1.475.698-1.475 1.414v1.698h2.51l-.401 2.617h-2.11v6.326c4.329-.679 7.64-4.424 7.64-8.943Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function G0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M5 9v6h2V9H5Zm14-6h-2v18h2V3ZM9 7v10h2V7H9ZM13 19V5h2v14h-2Z"
        }
      )
    }
  );
}
function W0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 9v6h-2V9h2ZM5 3h2v18H5V3Zm10 4v10h-2V7h2ZM11 19V5H9v14h2Z"
        }
      )
    }
  );
}
function N0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6Z" })
    }
  );
}
function j0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 7.27C6 5.463 7.492 4 9.333 4h5.334C16.507 4 18 5.464 18 7.27c0 1.069-.524 2.018-1.333 2.615A3.244 3.244 0 0 1 18 12.5c0 1.806-1.492 3.27-3.333 3.27-.75 0-1.443-.244-2-.654v2.615c0 1.805-1.493 3.269-3.334 3.269C7.493 21 6 19.536 6 17.73c0-1.069.524-2.018 1.333-2.615A3.244 3.244 0 0 1 6 12.5c0-1.07.524-2.019 1.333-2.615A3.244 3.244 0 0 1 6 7.269Zm3.333 7.191h2V10.54h-2c-1.104 0-2 .878-2 1.961 0 1.083.896 1.961 2 1.961Zm2 1.308h-2c-1.104 0-2 .878-2 1.962 0 1.083.896 1.961 2 1.961 1.105 0 2-.878 2-1.961v-1.962Zm3.334-1.308c-1.105 0-2-.878-2-1.961 0-1.083.895-1.961 2-1.961 1.104 0 2 .878 2 1.961 0 1.083-.896 1.961-2 1.961Zm-3.334-5.23h-2c-1.104 0-2-.878-2-1.962 0-1.083.896-1.961 2-1.961h2V9.23Zm3.334 0c1.104 0 2-.878 2-1.962 0-1.083-.896-1.961-2-1.961h-2V9.23h2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function X0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "#1ABCFE", d: "M12 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" }),
        /* @__PURE__ */ t("path", { fill: "#0ACF83", d: "M6 18a3 3 0 0 1 3-3h3v3a3 3 0 1 1-6 0Z" }),
        /* @__PURE__ */ t("path", { fill: "#FF7262", d: "M12 3v6h3a3 3 0 1 0 0-6h-3Z" }),
        /* @__PURE__ */ t("path", { fill: "#F24E1E", d: "M6 6a3 3 0 0 0 3 3h3V3H9a3 3 0 0 0-3 3Z" }),
        /* @__PURE__ */ t("path", { fill: "#A259FF", d: "M6 12a3 3 0 0 0 3 3h3V9H9a3 3 0 0 0-3 3Z" })
      ]
    }
  );
}
function K0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6Zm7 7V3.5L18.5 9H13Z"
        }
      )
    }
  );
}
function Q0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-6 12v-3h-4v-4h4V8l5 5-5 5Z"
        }
      )
    }
  );
}
function Y0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6ZM6 20V4h7v5h5v11H6Z"
        }
      )
    }
  );
}
function J0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 10v9H4.98V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2Zm-2.02 0 .94-2.06L19.98 7l-2.06-.94L16.98 4l-.94 2.06-2.06.94 2.06.94.94 2.06Zm-3.75.75L11.98 8l-1.25 2.75L7.98 12l2.75 1.25L11.98 16l1.25-2.75L15.98 12l-2.75-1.25Z"
        }
      )
    }
  );
}
function q0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z" })
    }
  );
}
function _0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.54 7.46C13.63 6.56 12.38 6 11 6a5 5 0 0 0-4.9 4H4.08C4.57 6.61 7.47 4 11 4c1.93 0 3.68.78 4.95 2.05L18 4v6h-6l2.54-2.54ZM17.92 12a6.89 6.89 0 0 1-1.28 3.14L21.49 20 20 21.49l-4.86-4.85A6.984 6.984 0 0 1 11 18c-1.93 0-3.68-.78-4.95-2.05L4 18v-6h6l-2.54 2.54C8.37 15.44 9.62 16 11 16a5 5 0 0 0 4.9-4h2.02Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function $0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 14c0 .867.175 1.688.525 2.462.35.776.85 1.455 1.5 2.038A1.158 1.158 0 0 1 8 18.275v-.225c0-.533.1-1.033.3-1.5.2-.467.492-.892.875-1.275L12 12.5l2.825 2.775c.383.383.675.808.875 1.275.2.467.3.967.3 1.5v.225c0 .067-.008.142-.025.225a6.073 6.073 0 0 0 1.5-2.038c.35-.774.525-1.595.525-2.462 0-.833-.154-1.62-.462-2.363A6.102 6.102 0 0 0 16.2 9.65a3.951 3.951 0 0 1-2.175.65c-1.033 0-1.93-.342-2.688-1.025a3.908 3.908 0 0 1-1.312-2.525C9.375 7.3 8.8 7.87 8.3 8.463c-.5.591-.92 1.191-1.263 1.8-.341.608-.6 1.229-.774 1.862A7.017 7.017 0 0 0 6 14Zm6 1.3-1.425 1.4a1.981 1.981 0 0 0-.425.625c-.1.233-.15.475-.15.725 0 .533.196.992.588 1.375.391.383.862.575 1.412.575.55 0 1.02-.192 1.412-.575.392-.383.588-.842.588-1.375 0-.267-.05-.512-.15-.738-.1-.225-.242-.429-.425-.612L12 15.3ZM12 3v3.3c0 .567.196 1.042.588 1.425.391.383.87.575 1.437.575.3 0 .58-.063.838-.188s.487-.312.687-.562L16 7a7.704 7.704 0 0 1 2.925 2.925A8.052 8.052 0 0 1 20 14c0 2.233-.775 4.125-2.325 5.675C16.125 21.225 14.233 22 12 22c-2.233 0-4.125-.775-5.675-2.325C4.775 18.125 4 16.233 4 14c0-2.15.72-4.192 2.162-6.125C7.604 5.942 9.55 4.317 12 3Z"
        }
      )
    }
  );
}
function z0({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4ZM4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2Zm16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2ZM7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2ZM18 8H6v8h12V8Z"
        }
      )
    }
  );
}
function l3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M7 2v11h3v9l7-12h-4l4-8H7Z" })
    }
  );
}
function t3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3.27 3 2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3ZM17 10h-4l4-8H7v2.18l8.46 8.46L17 10Z"
        }
      )
    }
  );
}
function e3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M11 2v20H0L11 2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M24 22 13 2v20h11Zm-3.383-2L15 9.786V20h5.617Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function r3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 11H2V0l20 11Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m2 24 20-11H2v11Zm2-3.383L14.214 15H4v5.617Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function i3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 15v2h2v-2H3Zm12 4v2h2v-2h-2Zm4-16H5c-1.1 0-2 .9-2 2v4h2V5h14v4h2V5c0-1.1-.9-2-2-2Zm2 16h-2v2c1.1 0 2-.9 2-2ZM1 11v2h22v-2H1Zm6 8v2h2v-2H7Zm12-4v2h2v-2h-2Zm-8 4v2h2v-2h-2Zm-8 0c0 1.1.9 2 2 2v-2H3Z"
        }
      )
    }
  );
}
function n3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 21c-.65 0-1.233-.187-1.75-.562A2.912 2.912 0 0 1 16.175 19H11c-1.1 0-2.042-.392-2.825-1.175C7.392 17.042 7 16.1 7 15s.392-2.042 1.175-2.825C8.958 11.392 9.9 11 11 11h2c.55 0 1.021-.196 1.413-.588C14.804 10.021 15 9.55 15 9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 13 7H7.825a3.094 3.094 0 0 1-1.087 1.438A2.855 2.855 0 0 1 5 9a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 2 6c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 5 3c.65 0 1.23.187 1.738.562.508.375.87.855 1.087 1.438H13c1.1 0 2.042.392 2.825 1.175C16.608 6.958 17 7.9 17 9s-.392 2.042-1.175 2.825C15.042 12.608 14.1 13 13 13h-2c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 9 15c0 .55.196 1.021.588 1.413.391.391.862.587 1.412.587h5.175a3.092 3.092 0 0 1 1.088-1.438A2.85 2.85 0 0 1 19 15c.833 0 1.542.292 2.125.875S22 17.167 22 18s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 19 21ZM5 7a.97.97 0 0 0 .713-.287A.97.97 0 0 0 6 6a.97.97 0 0 0-.287-.713A.97.97 0 0 0 5 5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 6a.97.97 0 0 0 .287.713A.97.97 0 0 0 5 7Z"
        }
      )
    }
  );
}
function h3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 19h19v2h-19v-2Zm7.18-5.73 9.66 2.58c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l6.91 1.86Z"
        }
      )
    }
  );
}
function c3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 19h19v2h-19v-2Zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 14.97-4c.81-.23 1.28-1.05 1.07-1.85Z"
        }
      )
    }
  );
}
function o3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.175 14.825C9.958 15.608 10.9 16 12 16s2.042-.392 2.825-1.175C15.608 14.042 16 13.1 16 12s-.392-2.042-1.175-2.825C14.042 8.392 13.1 8 12 8s-2.042.392-2.825 1.175C8.392 9.958 8 10.9 8 12s.392 2.042 1.175 2.825ZM4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4Zm12 0v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm18 0V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2Z"
        }
      )
    }
  );
}
function d3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19v-4h2v4h4v2H5Zm10 0v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21h-4Zm-3-5c-1.1 0-2.042-.392-2.825-1.175C8.392 14.042 8 13.1 8 12s.392-2.042 1.175-2.825C9.958 8.392 10.9 8 12 8s2.042.392 2.825 1.175C15.608 9.958 16 10.9 16 12s-.392 2.042-1.175 2.825C14.042 15.608 13.1 16 12 16ZM3 9V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h4v2H5v4H3Zm16 0V5h-4V3h4c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v4h-2Z"
        }
      )
    }
  );
}
function v3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2Z"
        }
      )
    }
  );
}
function a3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h6.252A8 8 0 0 1 22 11.07V8c0-1.1-.9-2-2-2h-8l-2-2Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18 12a6 6 0 1 0 0 11.998A6 6 0 0 0 18 12Zm0 10a4 4 0 1 0-.72-7.935A5.977 5.977 0 0 1 18.75 18a5.977 5.977 0 0 1-1.47 3.935c.233.043.474.065.72.065Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function u3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm0 12H4V8h16v10Z"
        }
      )
    }
  );
}
function w3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M12 6h8c1.1 0 2 .9 2 2v3.07a7.954 7.954 0 0 0-2-.818V8H4v10h6c0 .69.088 1.36.252 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18 12a6 6 0 1 0 0 11.998A6 6 0 0 0 18 12Zm0 10a4 4 0 1 0-.72-7.935A5.977 5.977 0 0 1 18.75 18a5.977 5.977 0 0 1-1.47 3.935c.233.043.474.065.72.065Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function s3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2.5 7V4h13v3h-5v12h-3V7h-5Zm10 2h9v3h-3v7h-3v-7h-3V9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function g3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.667 4 4 20h2.667l1.808-4h7.05l1.808 4H20L13.333 4h-2.666Zm-1.35 9.333 2.676-6.666 2.677 6.666H9.316Z"
        }
      )
    }
  );
}
function p3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.238 8 8 17h1.524l.762-2.3h3.476l.762 2.3H16l-3.238-9h-1.524Zm2.048 5.4h-2.572l1.238-3.75h.096l1.238 3.75Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function f3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14.59 8.41 16 7l4 4-4 4-1.41-1.41L16.17 12c-1.51.33-3.73-.08-5.17-1.36v6.53l1.59-1.59L14 17l-4 4-4-4 1.41-1.41L9 17.17V3h2v4c.73 2.58 3.07 3.47 5.17 3l-1.58-1.59Z"
        }
      )
    }
  );
}
function m3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14.59 15.59 16 17l4-4-4-4-1.41 1.41L16.17 12c-1.51-.33-3.73.08-5.17 1.36V6.83l1.59 1.59L14 7l-4-4-4 4 1.41 1.41L9 6.83V21h2v-4c.73-2.58 3.07-3.47 5.17-3l-1.58 1.59Z"
        }
      )
    }
  );
}
function Z3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3Z"
        }
      )
    }
  );
}
function x3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14 9V5l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11Z"
        }
      )
    }
  );
}
function C3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "m16 5-4 4-1.4-1.45L12.15 6H12c-1.95 0-3.605.679-4.963 2.037C5.68 9.395 5 11.05 5 13c0 1.95.679 3.605 2.037 4.963C8.395 19.32 10.05 20 12 20c1.95 0 3.605-.679 4.963-2.037C18.32 16.605 19 14.95 19 13h2c0 1.25-.238 2.421-.713 3.513a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.924A8.708 8.708 0 0 1 12 22a8.708 8.708 0 0 1-3.513-.713 9.147 9.147 0 0 1-2.85-1.925 9.148 9.148 0 0 1-1.924-2.85A8.708 8.708 0 0 1 3 13c0-1.25.238-2.421.713-3.513a9.147 9.147 0 0 1 1.925-2.85 9.147 9.147 0 0 1 2.85-1.924A8.708 8.708 0 0 1 12 4h.15L10.6 2.45 12 1l4 4Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M10.5 16H9v-4.5H7.5V10h3v6Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M14.5 10c.283 0 .521.095.713.287.192.192.287.43.287.713v4a.968.968 0 0 1-.287.713.968.968 0 0 1-.713.287h-2a.968.968 0 0 1-.713-.287A.968.968 0 0 1 11.5 15v-4c0-.283.095-.521.287-.713A.968.968 0 0 1 12.5 10h2ZM13 14.5h1v-3h-1v3Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function y3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 16v-1.5H10v-1H8.5v-1H10v-1H7.5V10h3c.283 0 .52.096.713.287.191.192.287.43.287.713v4c0 .283-.096.52-.287.713A.968.968 0 0 1 10.5 16h-3Zm6 0a.968.968 0 0 1-.713-.287A.968.968 0 0 1 12.5 15v-4c0-.283.096-.52.287-.713A.968.968 0 0 1 13.5 10h2c.283 0 .52.096.712.287.192.192.288.43.288.713v4c0 .283-.096.52-.288.713A.968.968 0 0 1 15.5 16h-2Zm.5-1.5h1v-3h-1v3ZM12 22c-1.25 0-2.42-.238-3.512-.712a9.149 9.149 0 0 1-2.85-1.925 9.147 9.147 0 0 1-1.925-2.85A8.707 8.707 0 0 1 3 13c0-1.25.237-2.42.712-3.512a9.148 9.148 0 0 1 1.925-2.85 9.148 9.148 0 0 1 2.85-1.925A8.707 8.707 0 0 1 12 4h.15L10.6 2.45 12 1l4 4-4 4-1.4-1.45L12.15 6H12c-1.95 0-3.604.68-4.963 2.037C5.68 9.396 5 11.05 5 13c0 1.95.68 3.604 2.037 4.962C8.396 19.322 10.05 20 12 20c1.95 0 3.604-.68 4.962-2.038C18.322 16.604 19 14.95 19 13h2c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.926A8.707 8.707 0 0 1 12 22Z"
        }
      )
    }
  );
}
function A3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-1.25 0-2.42-.238-3.512-.712a9.149 9.149 0 0 1-2.85-1.925 9.147 9.147 0 0 1-1.925-2.85A8.707 8.707 0 0 1 3 13c0-1.25.237-2.42.712-3.513a9.148 9.148 0 0 1 1.925-2.85 9.148 9.148 0 0 1 2.85-1.925A8.707 8.707 0 0 1 12 4h.15L10.6 2.45 12 1l4 4-4 4-1.4-1.45L12.15 6H12c-1.95 0-3.604.68-4.963 2.037C5.68 9.396 5 11.05 5 13c0 1.95.68 3.604 2.037 4.962C8.396 19.322 10.05 20 12 20c1.95 0 3.604-.68 4.962-2.038C18.322 16.604 19 14.95 19 13h2c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.926A8.707 8.707 0 0 1 12 22Zm-2.5-6v-1.5h3v-1h-3V10H14v1.5h-3v1h2c.283 0 .52.096.713.287.191.192.287.43.287.713V15c0 .283-.096.52-.287.713A.968.968 0 0 1 13 16H9.5Z"
        }
      )
    }
  );
}
function M3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 18h24v2H0v-2Z" }),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M2 2h2v20H2V2ZM20 2h2v20h-2V2Z" }),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 4h24v2H0V4ZM7 9h10v2H7V9ZM7 13h10v2H7v-2Z" })
      ]
    }
  );
}
function H3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 0 8 4h8l-4-4ZM12 24l-4-4h8l-4 4Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20 6H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm0 10H4V8h16v8Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function V3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 10H5V5h5v2H7v3Zm-2 4h2v3h3v2H5v-5Zm12 3h-3v2h5v-5h-2v3ZM14 7V5h5v5h-2V7h-3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function B3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1ZM13 9h-1.5v6H13V9ZM19 9v1.5h-3v1h2V13h-2v2h-1.5V9H19Z"
        }
      )
    }
  );
}
function I3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M20.58 12.168c0-.737-.06-1.275-.19-1.833h-8.42v3.328h4.943c-.1.827-.638 2.073-1.834 2.91l-.017.111 2.663 2.063.184.019c1.695-1.565 2.671-3.867 2.671-6.598Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11.97 20.938c2.421 0 4.454-.797 5.94-2.172l-2.83-2.193c-.758.528-1.775.897-3.11.897-2.372 0-4.385-1.564-5.103-3.727l-.105.009-2.768 2.143-.036.1a8.963 8.963 0 0 0 8.012 4.943Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M6.867 13.743a5.522 5.522 0 0 1-.298-1.774c0-.618.11-1.216.289-1.774l-.005-.119L4.049 7.9l-.091.044A8.977 8.977 0 0 0 3 11.969c0 1.445.349 2.81.957 4.026l2.91-2.252Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11.97 6.468c1.684 0 2.82.728 3.468 1.335l2.531-2.471C16.415 3.887 14.392 3 11.97 3a8.963 8.963 0 0 0-8.012 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727Z"
          }
        )
      ]
    }
  );
}
function L3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M20.58 12.168c0-.737-.06-1.275-.19-1.833h-8.42v3.328h4.943c-.1.827-.638 2.073-1.834 2.91l-.017.111 2.663 2.063.184.019c1.695-1.565 2.671-3.867 2.671-6.598Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#68707D",
            d: "M11.97 20.938c2.422 0 4.455-.797 5.94-2.172l-2.83-2.193c-.758.528-1.775.897-3.11.897-2.372 0-4.385-1.564-5.102-3.727l-.106.009-2.768 2.143-.036.1a8.963 8.963 0 0 0 8.012 4.943Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#CDCFD4",
            d: "M6.868 13.743a5.522 5.522 0 0 1-.3-1.774c0-.618.11-1.216.29-1.774l-.005-.119L4.049 7.9l-.091.044A8.978 8.978 0 0 0 3 11.969c0 1.445.349 2.81.957 4.026l2.91-2.252Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#68707D",
            d: "M11.97 6.468c1.684 0 2.82.728 3.468 1.335l2.531-2.471C16.415 3.887 14.392 3 11.97 3a8.963 8.963 0 0 0-8.012 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727Z"
          }
        )
      ]
    }
  );
}
function R3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#4285F4",
            d: "M20.58 12.168c0-.737-.06-1.275-.19-1.833h-8.42v3.328h4.943c-.1.827-.638 2.073-1.834 2.91l-.017.111 2.663 2.063.184.019c1.695-1.565 2.671-3.867 2.671-6.598Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#34A853",
            d: "M11.97 20.938c2.421 0 4.454-.797 5.94-2.172l-2.83-2.193c-.758.528-1.775.897-3.11.897-2.372 0-4.385-1.564-5.103-3.727l-.105.009-2.768 2.143-.036.1a8.963 8.963 0 0 0 8.012 4.943Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#FBBC05",
            d: "M6.867 13.743a5.522 5.522 0 0 1-.298-1.774c0-.618.11-1.216.289-1.774l-.005-.119L4.049 7.9l-.091.044A8.977 8.977 0 0 0 3 11.969c0 1.445.349 2.81.957 4.026l2.91-2.252Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#EB4335",
            d: "M11.97 6.468c1.684 0 2.82.728 3.468 1.335l2.531-2.471C16.415 3.887 14.392 3 11.97 3a8.963 8.963 0 0 0-8.012 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727Z"
          }
        )
      ]
    }
  );
}
function S3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 9h2v2h-2V9Zm-2 2h2v2H9v-2Zm4 0h2v2h-2v-2Zm2-2h2v2h-2V9ZM7 9h2v2H7V9Zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM9 18H7v-2h2v2Zm4 0h-2v-2h2v2Zm4 0h-2v-2h2v2Zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6Z"
        }
      )
    }
  );
}
function F3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7 17h2v-7H7v7Zm4 0h2V7h-2v10Zm4 0h2v-4h-2v4ZM5 21c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 19V5c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 5 3h14c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v14c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 19 21H5Zm0-2h14V5H5v14Z"
        }
      )
    }
  );
}
function T3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86Zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93ZM13 7h5.24c.25.31.48.65.68 1H13V7Zm0 3h6.74c.08.33.15.66.19 1H13v-1Zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93ZM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1Zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1Z"
        }
      )
    }
  );
}
function k3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 11V3h8v8H3Zm0 10v-8h8v8H3Zm10-10V3h8v8h-8Zm0 10v-8h8v8h-8ZM5 9h4V5H5v4Zm10 0h4V5h-4v4Zm0 10h4v-4h-4v4ZM5 19h4v-4H5v4Z"
        }
      )
    }
  );
}
function D3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 14.001a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3.999ZM3 6.001a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6.001ZM13 14.001a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-3.999ZM13 6.001a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V10a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V6.001Z"
        }
      )
    }
  );
}
function O3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 9H3V5h4v4Zm0 5H3v-4h4v4Zm1 0h4v-4H8v4Zm9 0h-4v-4h4v4ZM8 9h4V5H8v4Zm5 0V5h4v4h-4Zm5 5h4v-4h-4v4ZM7 19H3v-4h4v4Zm1 0h4v-4H8v4Zm9 0h-4v-4h4v4Zm1 0h4v-4h-4v4Zm0-10V5h4v4h-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function b3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 21v-7.975a7.935 7.935 0 0 1-3.075-.613A7.95 7.95 0 0 1 3.6 8.075C3.2 7.092 3 6.067 3 5V3h2c1.05 0 2.067.204 3.05.612.983.409 1.85.988 2.6 1.738a7.632 7.632 0 0 1 1.288 1.7c.341.617.604 1.275.787 1.975.083-.117.175-.229.275-.337.1-.109.208-.221.325-.338a7.963 7.963 0 0 1 2.6-1.738A7.947 7.947 0 0 1 19 6h2v2a7.947 7.947 0 0 1-.612 3.075 7.964 7.964 0 0 1-1.738 2.6 7.826 7.826 0 0 1-2.588 1.725c-.975.4-1.995.6-3.062.6v5h-2Zm0-10c0-.8-.154-1.563-.462-2.288a6.097 6.097 0 0 0-1.313-1.937 6.08 6.08 0 0 0-1.938-1.312A5.776 5.776 0 0 0 5 5c0 .8.15 1.567.45 2.3.3.733.733 1.383 1.3 1.95.567.567 1.217 1 1.95 1.3.733.3 1.5.45 2.3.45Zm2 3a5.928 5.928 0 0 0 4.225-1.75 6.057 6.057 0 0 0 1.313-1.95C18.846 9.567 19 8.8 19 8c-.8 0-1.567.154-2.3.462a6.057 6.057 0 0 0-1.95 1.313A5.919 5.919 0 0 0 13 14Z"
        }
      )
    }
  );
}
function P3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 24a8.205 8.205 0 0 1-4.7-1.438 8.148 8.148 0 0 1-3.075-3.837L2.675 12.3a2.335 2.335 0 0 1-.137-.463 2.784 2.784 0 0 1-.038-.487c0-.5.192-.942.575-1.325.383-.383.825-.575 1.325-.575.117 0 .221.004.313.012.091.009.187.03.287.063l.775.2A2.949 2.949 0 0 1 7 10.4V4.5c0-.7.242-1.292.725-1.775C8.208 2.242 8.8 2 9.5 2a2.578 2.578 0 0 1 .55.05c.1-.633.388-1.133.863-1.5A2.533 2.533 0 0 1 12.5 0c.533 0 1.008.146 1.425.438.417.291.717.679.9 1.162a2.75 2.75 0 0 1 .338-.075c.108-.017.22-.025.337-.025.7 0 1.292.242 1.775.725C17.758 2.708 18 3.3 18 4v.55a2.696 2.696 0 0 1 .5-.05c.7 0 1.292.242 1.775.725C20.758 5.708 21 6.3 21 7v9c0 2.233-.775 4.125-2.325 5.675C17.125 23.225 15.233 24 13 24Zm0-2c1.667 0 3.083-.583 4.25-1.75C18.417 19.083 19 17.667 19 16V7a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0A.48.48 0 0 0 18 7v5h-2V4a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0A.48.48 0 0 0 15 4v8h-2V2.5a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0 .48.48 0 0 0-.15.35V12h-2V4.5a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0A.48.48 0 0 0 9 4.5V15H7l-.975-2.5c-.117-.283-.279-.492-.487-.625-.209-.133-.555-.275-1.038-.425L7.1 18a6.278 6.278 0 0 0 2.338 2.9A6.183 6.183 0 0 0 13 22Z"
        }
      )
    }
  );
}
function U3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.5 11c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 15.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 14 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm-7 0c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 8.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 7 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm3.5 6.5c1.133 0 2.163-.32 3.088-.962A5.489 5.489 0 0 0 17.1 14h-1.65a4.097 4.097 0 0 1-1.462 1.462A3.846 3.846 0 0 1 12 16c-.717 0-1.38-.18-1.988-.538A4.096 4.096 0 0 1 8.55 14H6.9a5.487 5.487 0 0 0 2.013 2.538A5.295 5.295 0 0 0 12 17.5Zm0 4.5a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function E3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M6 4h3v6h6V4h3v15h-3v-6H9v6H6V4Z" })
    }
  );
}
function G3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 17.65 8.25 21.4c-.383.383-.85.575-1.4.575-.55 0-1.017-.192-1.4-.575L2.6 18.55a1.905 1.905 0 0 1-.575-1.4c0-.55.192-1.017.575-1.4L6.35 12 2.6 8.25a1.905 1.905 0 0 1-.575-1.4c0-.55.192-1.017.575-1.4L5.45 2.6c.383-.383.85-.575 1.4-.575.55 0 1.017.192 1.4.575L12 6.35l3.75-3.75c.383-.383.85-.575 1.4-.575.55 0 1.017.192 1.4.575l2.85 2.85c.383.383.575.85.575 1.4 0 .55-.192 1.017-.575 1.4L17.65 12l3.75 3.75c.383.383.575.85.575 1.4 0 .55-.192 1.017-.575 1.4l-2.85 2.85c-.383.383-.85.575-1.4.575-.55 0-1.017-.192-1.4-.575L12 17.65ZM12 11c.283 0 .52-.096.713-.287A.967.967 0 0 0 13 10a.967.967 0 0 0-.287-.712A.967.967 0 0 0 12 9a.968.968 0 0 0-.713.288A.968.968 0 0 0 11 10c0 .283.096.52.287.713.192.191.43.287.713.287Zm-4.25-.4 2.85-2.85L6.85 4 4 6.85l3.75 3.75ZM10 13c.283 0 .52-.096.713-.287A.967.967 0 0 0 11 12a.968.968 0 0 0-.287-.713A.968.968 0 0 0 10 11a.968.968 0 0 0-.712.287A.968.968 0 0 0 9 12c0 .283.096.52.288.713.191.191.429.287.712.287Zm2 2c.283 0 .52-.096.713-.287A.967.967 0 0 0 13 14a.968.968 0 0 0-.287-.713A.968.968 0 0 0 12 13a.968.968 0 0 0-.713.287A.968.968 0 0 0 11 14c0 .283.096.52.287.713.192.191.43.287.713.287Zm2-2c.283 0 .52-.096.713-.287A.967.967 0 0 0 15 12a.968.968 0 0 0-.287-.713A.968.968 0 0 0 14 11a.968.968 0 0 0-.713.287A.968.968 0 0 0 13 12c0 .283.096.52.287.713.192.191.43.287.713.287Zm-.6 3.25L17.15 20 20 17.15l-3.75-3.75-2.85 2.85Z"
        }
      )
    }
  );
}
function W3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m12 21.35-1.45-1.3c-1.683-1.517-3.075-2.825-4.175-3.925-1.1-1.1-1.975-2.088-2.625-2.963-.65-.875-1.104-1.679-1.362-2.412A6.717 6.717 0 0 1 2 8.5c0-1.567.525-2.875 1.575-3.925C4.625 3.525 5.933 3 7.5 3c.867 0 1.692.183 2.475.55A5.93 5.93 0 0 1 12 5.1a5.93 5.93 0 0 1 2.025-1.55A5.769 5.769 0 0 1 16.5 3c1.567 0 2.875.525 3.925 1.575C21.475 5.625 22 6.933 22 8.5c0 .767-.129 1.517-.387 2.25-.259.733-.713 1.537-1.363 2.412s-1.525 1.863-2.625 2.963-2.492 2.408-4.175 3.925L12 21.35Zm0-2.7c1.6-1.433 2.917-2.663 3.95-3.688 1.033-1.025 1.85-1.916 2.45-2.674.6-.759 1.017-1.434 1.25-2.026.233-.591.35-1.179.35-1.762 0-1-.333-1.833-1-2.5s-1.5-1-2.5-1c-.783 0-1.508.22-2.175.662-.667.442-1.125 1.005-1.375 1.688h-1.9c-.25-.683-.708-1.246-1.375-1.688A3.862 3.862 0 0 0 7.5 5c-1 0-1.833.333-2.5 1S4 7.5 4 8.5c0 .583.117 1.17.35 1.762.233.592.65 1.267 1.25 2.026.6.758 1.417 1.65 2.45 2.674A108.992 108.992 0 0 0 12 18.65Z"
        }
      )
    }
  );
}
function N3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3V6.99Z" })
    }
  );
}
function j3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18Zm0-2H3v-5h18v5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function X3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18Zm0-2H3v-9h18v9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function K3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18Zm0-2H3V7h18v13Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Q3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18Zm0-2H3v-2h18v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Y3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 17h-2v-2h2v2Zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25Z"
        }
      )
    }
  );
}
function J3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 18h2v-2h-2v2Zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4Z"
        }
      )
    }
  );
}
function q3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m2.01 3.87 1.41-1.42L21.15 20.2l-1.41 1.41-3.43-3.43c-1.34.52-2.79.82-4.31.82-5 0-9.27-3.11-11-7.5.77-1.97 2.06-3.67 3.69-4.95L2.01 3.87ZM17 11.5c0-2.76-2.24-5-5-5-.51 0-1 .1-1.47.24L8.36 4.57C9.51 4.2 10.73 4 12 4c5 0 9.27 3.11 11 7.49-.69 1.76-1.79 3.3-3.18 4.53l-3.06-3.06c.14-.46.24-.95.24-1.46Zm-5 5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5Zm2.97-5.33a2.97 2.97 0 0 0-2.64-2.64l2.64 2.64Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function _3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M18.6 18.69 4.4 4.59l-1.3 1.3 2.5 2.5c-1.1 1-2 2.2-2.6 3.6 1.4 3.5 4.9 6 9 6 1 0 1.9-.2 2.8-.4l2.5 2.5 1.3-1.4Zm-6.6-2.7c-2.2 0-4-1.8-4-4 0-.4.1-.7.2-1l4.9 4.9c-.4.1-.7.1-1.1.1ZM13.9 12.59l-2.4-2.5c.2 0 .4-.1.5-.1 1.1 0 2 .9 2 2 0 .2 0 .4-.1.6Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M15.4 14.09c.4-.6.6-1.3.6-2.1 0-2.2-1.8-4-4-4-.8 0-1.5.2-2.1.6l-1.7-1.8c1.1-.5 2.4-.8 3.8-.8 4.1 0 7.6 2.5 9 6-.7 1.7-1.9 3.2-3.4 4.2l-2.2-2.1Z"
          }
        )
      ]
    }
  );
}
function $3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M3.789 21.132v-12l8-6 8 6v12h-6v-7h-4v7h-6Z" })
    }
  );
}
function z3({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 19h3v-6h6v6h3v-9l-6-4.5L6 10v9Zm-2 2V9l8-6 8 6v12h-7v-6h-2v6H4Z"
        }
      )
    }
  );
}
function l4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 4v16H2V4h2Zm18 0v16h-2V4h2Zm-7 9v3l4-4-4-4v3H9V8l-4 4 4 4v-3h6Z"
        }
      )
    }
  );
}
function t4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M5 8H3v8h2v-3h14v3h2V8h-2v3H5V8Z" })
    }
  );
}
function e4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7Zm7 0a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7ZM8 17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function r4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M19 3 5 5c-1.1 0-2 .9-2 2v2h2V7l14-2v4h2V5c0-1.1-.9-2-2-2ZM1 11v2h22v-2H1Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "m5 5 14-2c1.1 0 2 .9 2 2v4h-2V5L5 7v2H3V7c0-1.1.9-2 2-2ZM19 21 5 19c-1.1 0-2-.9-2-2v-2h2v2l14 2v-4h2v4c0 1.1-.9 2-2 2Z"
          }
        )
      ]
    }
  );
}
function i4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "m11.226 11.674.286.995H9.436l.286-.995c.133-.43.257-.872.373-1.323l.348-1.361h.05c.116.447.234.899.354 1.354.12.456.246.9.379 1.33Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm6.1 8.8h2.735l.634 2.2h1.516L11.338 7.87h-1.69L7 16h1.467l.634-2.2Zm5.544-5.196c.166.15.377.224.634.224a.912.912 0 0 0 .634-.224.749.749 0 0 0 .248-.584.768.768 0 0 0-.248-.59.897.897 0 0 0-.634-.23.897.897 0 0 0-.634.23.768.768 0 0 0-.249.59c0 .24.083.435.249.584Zm1.342 1.293h-1.429V16h1.43V9.897Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function n4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9.1 13.8h2.735l.634 2.2h1.516L11.338 7.87h-1.69L7 16h1.467l.634-2.2Zm2.126-2.126.286.995H9.436l.286-.995c.133-.43.257-.872.373-1.323l.348-1.361h.05c.116.447.234.899.354 1.354.12.456.246.9.379 1.33Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M14.644 8.604c.166.15.377.224.634.224a.912.912 0 0 0 .634-.224.749.749 0 0 0 .248-.584.768.768 0 0 0-.248-.59.897.897 0 0 0-.634-.23.897.897 0 0 0-.634.23.768.768 0 0 0-.249.59c0 .24.083.435.249.584ZM15.986 9.897h-1.429V16h1.43V9.897Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0h14v14H5V5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function h4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m11.356 13.077-.46-1.6a54.687 54.687 0 0 1-.61-2.14c-.193-.733-.383-1.46-.57-2.18h-.08c-.186.734-.373 1.463-.56 2.19a47.068 47.068 0 0 1-.6 2.13l-.46 1.6h3.34Zm.52 1.82h-4.4l-1.02 3.54h-2.36l4.26-13.08h2.72l4.26 13.08h-2.44l-1.02-3.54Zm5.54-8c-.413 0-.753-.12-1.02-.36s-.4-.553-.4-.94c0-.387.133-.703.4-.95s.607-.37 1.02-.37c.413 0 .753.123 1.02.37s.4.563.4.95-.133.7-.4.94-.607.36-1.02.36Zm-1.16 1.72h2.3v9.82h-2.3v-9.82Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function c4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14Zm-8 13.51L8.5 13.5 5 18h14l-4.5-6-3.5 4.51Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function o4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m15.96 10.29-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71ZM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5Zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 16H7V3h14v14Z"
        }
      )
    }
  );
}
function d4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M21 5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5.582A7.978 7.978 0 0 1 10 18H5l3.5-4.5 1.833 2.207A8.004 8.004 0 0 1 21 10.581V5Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18 12a6 6 0 1 0 0 11.998A6 6 0 0 0 18 12Zm0 10a4 4 0 1 0-.72-7.935A5.977 5.977 0 0 1 18.75 18a5.977 5.977 0 0 1-1.47 3.935c.233.043.474.065.72.065Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function v4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm14 14v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4Zm4-14V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2ZM18 16.667V7.333C18 6.6 17.4 6 16.667 6H7.333C6.6 6 6 6.6 6 7.333v9.334C6 17.4 6.6 18 7.333 18h9.334C17.4 18 18 17.4 18 16.667ZM10 13l2 2 2-3 2 4H8l2-3Z"
        }
      )
    }
  );
}
function a4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.3 8.89c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89ZM18 20v-7l2 2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h5.5c-.26.62-.43 1.29-.48 2H4v14h14Zm-1.5-2-3.54-4.71-2.75 3.54-1.96-2.36L5.5 18h11ZM13 6.5a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function u4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 16.667V7.333C18 6.6 17.4 6 16.667 6H7.333C6.6 6 6 6.6 6 7.333v9.334C6 17.4 6.6 18 7.333 18h9.334C17.4 18 18 17.4 18 16.667ZM10 13l2 2 2-3 2 4H8l2-3Z"
        }
      )
    }
  );
}
function w4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M12.467 14.477c-.232-.34-.349-.835-.349-1.49 0-.636.135-1.127.405-1.47.27-.343.6-.515.992-.515.205 0 .407.037.607.11.2.074.406.205.619.393v2.806c-.392.45-.813.675-1.262.675-.442 0-.779-.17-1.012-.509Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm6.422 2.987H8v8.016h1.422V7.987Zm1.452 3.69A3.845 3.845 0 0 0 10.66 13c0 .997.222 1.771.668 2.323.445.551 1.048.827 1.807.827.327 0 .638-.078.932-.233.294-.155.551-.343.772-.564h.049l.098.65h1.164V7.35h-1.409v2.182l.049.968a3.488 3.488 0 0 0-.71-.484c-.238-.119-.528-.178-.871-.178a2.17 2.17 0 0 0-.95.22 2.547 2.547 0 0 0-.815.626c-.237.27-.427.6-.57.992Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function s4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M9.422 7.987H8v8.016h1.422V7.987Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.874 11.676A3.845 3.845 0 0 0 10.66 13c0 .997.222 1.771.668 2.323.445.551 1.048.827 1.807.827.327 0 .638-.078.932-.233.294-.155.551-.343.772-.564h.049l.098.65h1.164V7.35h-1.409v2.182l.049.968a3.488 3.488 0 0 0-.71-.484c-.238-.119-.528-.178-.871-.178a2.17 2.17 0 0 0-.95.22 2.547 2.547 0 0 0-.815.626c-.237.27-.427.6-.57.992Zm1.593 2.801c-.232-.34-.349-.835-.349-1.49 0-.636.135-1.127.405-1.47.27-.343.6-.515.992-.515.205 0 .407.037.607.11.2.074.406.205.619.393v2.806c-.392.45-.813.675-1.262.675-.442 0-.779-.17-1.012-.509Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0h14v14H5V5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function g4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.99 3H19a2 2 0 0 1 2 2v14c0 1.1-.9 2-2 2H4.99C3.88 21 3 20.1 3 19l.01-14c0-1.11.87-2 1.98-2ZM15 15h4V5H5v10h4c0 1.66 1.35 3 3 3s3-1.34 3-3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function p4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.35 5.363h2.32v13.08H5.35V5.363Zm4.34 8.18c0-.8.117-1.52.35-2.16.233-.64.543-1.18.93-1.62.387-.44.83-.78 1.33-1.02.5-.24 1.017-.36 1.55-.36.56 0 1.033.096 1.42.29.387.193.773.456 1.16.79l-.08-1.58v-3.56h2.3v14.12h-1.9l-.16-1.06h-.08c-.36.36-.78.666-1.26.92a3.21 3.21 0 0 1-1.52.38c-1.24 0-2.223-.45-2.95-1.35-.727-.9-1.09-2.164-1.09-3.79Zm2.38-.02c0 1.066.19 1.876.57 2.43.38.553.93.83 1.65.83.733 0 1.42-.367 2.06-1.1v-4.58c-.347-.307-.683-.52-1.01-.64a2.852 2.852 0 0 0-.99-.18c-.64 0-1.18.28-1.62.84-.44.56-.66 1.36-.66 2.4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function f4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 15v-6h2v6h-2Zm0-10v2h2V7h-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function m4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 4c-4.415 0-8 3.585-8 8s3.585 8 8 8 8-3.585 8-8-3.585-8-8-8ZM2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M13 7h-2v2h2V7ZM13 11h-2v6h2v-6Z" })
      ]
    }
  );
}
function Z4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 20c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 1 18c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 3 16h.263a.64.64 0 0 1 .237.05l4.55-4.55a.641.641 0 0 1-.05-.238V11c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 10 9c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413 0 .033-.017.2-.05.5l2.55 2.55a.642.642 0 0 1 .238-.05h.524c.075 0 .155.017.238.05l3.55-3.55a.642.642 0 0 1-.05-.238V10c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 21 8c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.412A1.927 1.927 0 0 1 21 12h-.262a.642.642 0 0 1-.238-.05l-3.55 3.55c.033.083.05.163.05.238V16c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 15 18c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 13 16v-.262c0-.075.017-.155.05-.238l-2.55-2.55a.642.642 0 0 1-.238.05H10c-.033 0-.2-.017-.5-.05L4.95 17.5c.033.083.05.163.05.238V18c0 .55-.196 1.021-.588 1.413A1.925 1.925 0 0 1 3 20ZM4 9.975l-.625-1.35L2.025 8l1.35-.625L4 6.025l.625 1.35L5.975 8l-1.35.625L4 9.975ZM15 9l-.95-2.05L12 6l2.05-.95L15 3l.95 2.05L18 6l-2.05.95L15 9Z"
        }
      )
    }
  );
}
function x4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 3c-2.444 0-2.75.01-3.71.054-.958.044-1.613.196-2.185.419-.601.225-1.145.58-1.595 1.038-.457.45-.811.993-1.037 1.593-.223.573-.375 1.228-.419 2.186C3.011 9.25 3 9.555 3 12c0 2.445.01 2.75.054 3.71.044.959.196 1.613.419 2.185.225.601.58 1.145 1.038 1.595.5.5 1.002.808 1.593 1.038.573.222 1.228.375 2.186.418.96.043 1.266.054 3.71.054s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419.601-.226 1.145-.58 1.595-1.038.5-.5.808-1.002 1.038-1.594.222-.572.375-1.226.418-2.184.043-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.958-.196-1.613-.419-2.185A4.412 4.412 0 0 0 19.49 4.51a4.415 4.415 0 0 0-1.594-1.037c-.572-.223-1.226-.375-2.185-.419C14.75 3.011 14.445 3 12 3Zm0 1.622c2.403 0 2.688.009 3.637.052.878.04 1.354.186 1.671.31.42.163.72.359 1.035.673.315.315.51.615.673 1.035.124.317.27.793.31 1.671.043.949.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.788 2.788 0 0 1-.673 1.035c-.315.315-.615.51-1.035.673-.317.124-.793.27-1.671.31-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.788 2.788 0 0 1-1.035-.673 2.789 2.789 0 0 1-.673-1.035c-.123-.317-.27-.793-.31-1.671-.043-.949-.053-1.234-.053-3.637s.01-2.688.053-3.637c.04-.877.186-1.354.31-1.671.163-.42.359-.72.673-1.035.315-.315.615-.51 1.035-.673.317-.123.793-.27 1.671-.31.949-.043 1.234-.053 3.637-.053Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 15.003a3.003 3.003 0 1 1 0-6.006 3.003 3.003 0 0 1 0 6.006Zm0-7.629a4.626 4.626 0 1 0 0 9.252 4.626 4.626 0 0 0 0-9.252Zm5.972-.084a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function C4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#a)",
            fillRule: "evenodd",
            d: "M12 3c-2.444 0-2.75.01-3.71.054-.958.044-1.613.196-2.185.419-.601.225-1.145.58-1.595 1.038-.457.45-.811.993-1.037 1.593-.223.573-.375 1.228-.419 2.186C3.011 9.25 3 9.555 3 12c0 2.445.01 2.75.054 3.71.044.959.196 1.613.419 2.185.225.601.58 1.145 1.038 1.595.5.5 1.002.808 1.593 1.038.573.222 1.228.375 2.186.418.96.043 1.266.054 3.71.054s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419.601-.226 1.145-.58 1.595-1.038.5-.5.808-1.002 1.038-1.594.222-.572.375-1.226.418-2.184.043-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.958-.196-1.613-.419-2.185A4.412 4.412 0 0 0 19.49 4.51a4.415 4.415 0 0 0-1.594-1.037c-.572-.223-1.226-.375-2.185-.419C14.75 3.011 14.445 3 12 3Zm0 1.622c2.403 0 2.688.009 3.637.052.878.04 1.354.186 1.671.31.42.163.72.359 1.035.673.315.315.51.615.673 1.035.124.317.27.793.31 1.671.043.949.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.788 2.788 0 0 1-.673 1.035c-.315.315-.615.51-1.035.673-.317.124-.793.27-1.671.31-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.788 2.788 0 0 1-1.035-.673 2.789 2.789 0 0 1-.673-1.035c-.123-.317-.27-.793-.31-1.671-.043-.949-.053-1.234-.053-3.637s.01-2.688.053-3.637c.04-.877.186-1.354.31-1.671.163-.42.359-.72.673-1.035.315-.315.615-.51 1.035-.673.317-.123.793-.27 1.671-.31.949-.043 1.234-.053 3.637-.053Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#b)",
            fillRule: "evenodd",
            d: "M12 3c-2.444 0-2.75.01-3.71.054-.958.044-1.613.196-2.185.419-.601.225-1.145.58-1.595 1.038-.457.45-.811.993-1.037 1.593-.223.573-.375 1.228-.419 2.186C3.011 9.25 3 9.555 3 12c0 2.445.01 2.75.054 3.71.044.959.196 1.613.419 2.185.225.601.58 1.145 1.038 1.595.5.5 1.002.808 1.593 1.038.573.222 1.228.375 2.186.418.96.043 1.266.054 3.71.054s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419.601-.226 1.145-.58 1.595-1.038.5-.5.808-1.002 1.038-1.594.222-.572.375-1.226.418-2.184.043-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.958-.196-1.613-.419-2.185A4.412 4.412 0 0 0 19.49 4.51a4.415 4.415 0 0 0-1.594-1.037c-.572-.223-1.226-.375-2.185-.419C14.75 3.011 14.445 3 12 3Zm0 1.622c2.403 0 2.688.009 3.637.052.878.04 1.354.186 1.671.31.42.163.72.359 1.035.673.315.315.51.615.673 1.035.124.317.27.793.31 1.671.043.949.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.788 2.788 0 0 1-.673 1.035c-.315.315-.615.51-1.035.673-.317.124-.793.27-1.671.31-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.788 2.788 0 0 1-1.035-.673 2.789 2.789 0 0 1-.673-1.035c-.123-.317-.27-.793-.31-1.671-.043-.949-.053-1.234-.053-3.637s.01-2.688.053-3.637c.04-.877.186-1.354.31-1.671.163-.42.359-.72.673-1.035.315-.315.615-.51 1.035-.673.317-.123.793-.27 1.671-.31.949-.043 1.234-.053 3.637-.053Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#c)",
            fillRule: "evenodd",
            d: "M12 15.003a3.003 3.003 0 1 1 0-6.006 3.003 3.003 0 0 1 0 6.006Zm0-7.629a4.626 4.626 0 1 0 0 9.252 4.626 4.626 0 0 0 0-9.252Zm5.972-.084a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#d)",
            fillRule: "evenodd",
            d: "M12 15.003a3.003 3.003 0 1 1 0-6.006 3.003 3.003 0 0 1 0 6.006Zm0-7.629a4.626 4.626 0 1 0 0 9.252 4.626 4.626 0 0 0 0-9.252Zm5.972-.084a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ n("defs", { children: [
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "a",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(-10.67406 -22.10397 32.87711 -15.87643 18.21 23.43)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { offset: 0.244, stopColor: "#99A7AD" }),
                /* @__PURE__ */ t("stop", { offset: 0.688, stopColor: "#CCD3D6" }),
                /* @__PURE__ */ t("stop", { offset: 0.893, stopColor: "#334E5C" })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "b",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(5.72401 -8.96403 9.32383 5.95376 9.525 20.379)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { stopColor: "#CCD3D6" }),
                /* @__PURE__ */ t("stop", { offset: 0.484, stopColor: "#99A7AD" }),
                /* @__PURE__ */ t("stop", { offset: 0.734, stopColor: "#334E5C" }),
                /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#334E5C" })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "c",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(-10.67406 -22.10397 32.87711 -15.87643 18.21 23.43)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { offset: 0.244, stopColor: "#99A7AD" }),
                /* @__PURE__ */ t("stop", { offset: 0.688, stopColor: "#CCD3D6" }),
                /* @__PURE__ */ t("stop", { offset: 0.893, stopColor: "#334E5C" })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "d",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(5.72401 -8.96403 9.32383 5.95376 9.525 20.379)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { stopColor: "#CCD3D6" }),
                /* @__PURE__ */ t("stop", { offset: 0.484, stopColor: "#99A7AD" }),
                /* @__PURE__ */ t("stop", { offset: 0.734, stopColor: "#334E5C" }),
                /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#334E5C" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function y4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#a)",
            fillRule: "evenodd",
            d: "M12 3c-2.444 0-2.75.01-3.71.054-.958.044-1.613.196-2.185.419-.601.225-1.145.58-1.595 1.038-.457.45-.811.993-1.037 1.593-.223.573-.375 1.228-.419 2.186C3.011 9.25 3 9.555 3 12c0 2.445.01 2.75.054 3.71.044.959.196 1.613.419 2.185.225.601.58 1.145 1.038 1.595.5.5 1.002.808 1.593 1.038.573.222 1.228.375 2.186.418.96.043 1.266.054 3.71.054s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419.601-.226 1.145-.58 1.595-1.038.5-.5.808-1.002 1.038-1.594.222-.572.375-1.226.418-2.184.043-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.958-.196-1.613-.419-2.185A4.412 4.412 0 0 0 19.49 4.51a4.415 4.415 0 0 0-1.594-1.037c-.572-.223-1.226-.375-2.185-.419C14.75 3.011 14.445 3 12 3Zm0 1.622c2.403 0 2.688.009 3.637.052.878.04 1.354.186 1.671.31.42.163.72.359 1.035.673.315.315.51.615.673 1.035.124.317.27.793.31 1.671.043.949.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.788 2.788 0 0 1-.673 1.035c-.315.315-.615.51-1.035.673-.317.124-.793.27-1.671.31-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.788 2.788 0 0 1-1.035-.673 2.789 2.789 0 0 1-.673-1.035c-.123-.317-.27-.793-.31-1.671-.043-.949-.053-1.234-.053-3.637s.01-2.688.053-3.637c.04-.877.186-1.354.31-1.671.163-.42.359-.72.673-1.035.315-.315.615-.51 1.035-.673.317-.123.793-.27 1.671-.31.949-.043 1.234-.053 3.637-.053Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#b)",
            fillRule: "evenodd",
            d: "M12 3c-2.444 0-2.75.01-3.71.054-.958.044-1.613.196-2.185.419-.601.225-1.145.58-1.595 1.038-.457.45-.811.993-1.037 1.593-.223.573-.375 1.228-.419 2.186C3.011 9.25 3 9.555 3 12c0 2.445.01 2.75.054 3.71.044.959.196 1.613.419 2.185.225.601.58 1.145 1.038 1.595.5.5 1.002.808 1.593 1.038.573.222 1.228.375 2.186.418.96.043 1.266.054 3.71.054s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419.601-.226 1.145-.58 1.595-1.038.5-.5.808-1.002 1.038-1.594.222-.572.375-1.226.418-2.184.043-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.958-.196-1.613-.419-2.185A4.412 4.412 0 0 0 19.49 4.51a4.415 4.415 0 0 0-1.594-1.037c-.572-.223-1.226-.375-2.185-.419C14.75 3.011 14.445 3 12 3Zm0 1.622c2.403 0 2.688.009 3.637.052.878.04 1.354.186 1.671.31.42.163.72.359 1.035.673.315.315.51.615.673 1.035.124.317.27.793.31 1.671.043.949.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.788 2.788 0 0 1-.673 1.035c-.315.315-.615.51-1.035.673-.317.124-.793.27-1.671.31-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.788 2.788 0 0 1-1.035-.673 2.789 2.789 0 0 1-.673-1.035c-.123-.317-.27-.793-.31-1.671-.043-.949-.053-1.234-.053-3.637s.01-2.688.053-3.637c.04-.877.186-1.354.31-1.671.163-.42.359-.72.673-1.035.315-.315.615-.51 1.035-.673.317-.123.793-.27 1.671-.31.949-.043 1.234-.053 3.637-.053Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#c)",
            fillRule: "evenodd",
            d: "M12 15.003a3.003 3.003 0 1 1 0-6.006 3.003 3.003 0 0 1 0 6.006Zm0-7.629a4.626 4.626 0 1 0 0 9.252 4.626 4.626 0 0 0 0-9.252Zm5.972-.084a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "url(#d)",
            fillRule: "evenodd",
            d: "M12 15.003a3.003 3.003 0 1 1 0-6.006 3.003 3.003 0 0 1 0 6.006Zm0-7.629a4.626 4.626 0 1 0 0 9.252 4.626 4.626 0 0 0 0-9.252Zm5.972-.084a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ n("defs", { children: [
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "a",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(-10.67406 -22.10397 32.87711 -15.87643 18.21 23.43)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { offset: 0.244, stopColor: "#FF1B90" }),
                /* @__PURE__ */ t("stop", { offset: 0.437, stopColor: "#F80261" }),
                /* @__PURE__ */ t("stop", { offset: 0.688, stopColor: "#ED00C0" }),
                /* @__PURE__ */ t("stop", { offset: 0.777, stopColor: "#C500E9" }),
                /* @__PURE__ */ t("stop", { offset: 0.893, stopColor: "#7017FF" })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "b",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(5.72401 -8.96403 9.32383 5.95376 9.525 20.379)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { stopColor: "#FFD600" }),
                /* @__PURE__ */ t("stop", { offset: 0.484, stopColor: "#FF6930" }),
                /* @__PURE__ */ t("stop", { offset: 0.734, stopColor: "#FE3B36" }),
                /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#FE3B36", stopOpacity: 0 })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "c",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(-10.67406 -22.10397 32.87711 -15.87643 18.21 23.43)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { offset: 0.244, stopColor: "#FF1B90" }),
                /* @__PURE__ */ t("stop", { offset: 0.437, stopColor: "#F80261" }),
                /* @__PURE__ */ t("stop", { offset: 0.688, stopColor: "#ED00C0" }),
                /* @__PURE__ */ t("stop", { offset: 0.777, stopColor: "#C500E9" }),
                /* @__PURE__ */ t("stop", { offset: 0.893, stopColor: "#7017FF" })
              ]
            }
          ),
          /* @__PURE__ */ n(
            "radialGradient",
            {
              id: "d",
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(5.72401 -8.96403 9.32383 5.95376 9.525 20.379)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ t("stop", { stopColor: "#FFD600" }),
                /* @__PURE__ */ t("stop", { offset: 0.484, stopColor: "#FF6930" }),
                /* @__PURE__ */ t("stop", { offset: 0.734, stopColor: "#FE3B36" }),
                /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#FE3B36", stopOpacity: 0 })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function A4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15 9H9v6h6V9Zm-2 4h-2v-2h2v2Zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2Zm-4 6H7V7h10v10Z"
        }
      )
    }
  );
}
function M4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8Z" })
    }
  );
}
function H4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 17.5c1.133 0 2.163-.32 3.088-.962A5.489 5.489 0 0 0 17.1 14H6.9a5.487 5.487 0 0 0 2.013 2.538A5.295 5.295 0 0 0 12 17.5ZM7.8 11l1.1-1.05L9.95 11 11 9.95 8.9 7.8 6.75 9.95 7.8 11Zm6.25 0 1.05-1.05L16.2 11l1.05-1.05L15.1 7.8 13 9.95 14.05 11ZM12 22a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function V4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12.65 10A5.99 5.99 0 0 0 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 0 0 5.65-4H17v4h4v-4h2v-4H12.65ZM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
        }
      )
    }
  );
}
function B4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-10c0-1.1.89-2 1.99-2Zm9 3h-2v2h2V8Zm-2 3h2v2h-2v-2Zm-1-3H8v2h2V8Zm-2 3h2v2H8v-2Zm-3 2h2v-2H5v2Zm2-3H5V8h2v2Zm1 7h8v-2H8v2Zm8-4h-2v-2h2v2Zm-2-3h2V8h-2v2Zm5 3h-2v-2h2v2Zm-2-3h2V8h-2v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function I4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 3 1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3Zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9ZM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72Z"
        }
      )
    }
  );
}
function L4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "m7.656 18 3.438-6.102L7.89 6.192h1.656l1.602 3.024c.156.264.3.528.432.792.144.264.306.57.486.918h.072c.168-.348.312-.654.432-.918.132-.264.27-.528.414-.792l1.566-3.024h1.584l-3.222 5.778L16.35 18h-1.656l-1.728-3.186a71.627 71.627 0 0 0-.486-.882c-.156-.312-.33-.648-.522-1.008h-.072c-.168.36-.33.696-.486 1.008-.156.3-.306.594-.45.882L9.24 18H7.656Z"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "a", children: /* @__PURE__ */ t("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
      ]
    }
  );
}
function R4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 4h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Zm0 14h18V6H3v12Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M17 11h2v5h-5v-2h3v-3ZM10 10H7v3H5V8h5v2Z" })
      ]
    }
  );
}
function S4({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3Zm4.793 9.036a1 1 0 1 1 1.414-1.415l1.414 1.415 4.243-4.243a1 1 0 1 1 1.414 1.414l-4.95 4.95a.997.997 0 0 1-1.414 0l-2.121-2.121Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function F4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm13.97-4h2.95a8.03 8.03 0 0 0-4.33-3.56c.6 1.11 1.06 2.31 1.38 3.56ZM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96ZM4 12c0 .69.1 1.36.26 2h3.38c-.08-.66-.14-1.32-.14-2 0-.68.06-1.34.14-2H4.26c-.16.64-.26 1.31-.26 2Zm1.08 4h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16Zm0-8h2.95c.32-1.25.78-2.45 1.38-3.56-1.84.63-3.37 1.9-4.33 3.56ZM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96ZM9.5 12c0 .68.07 1.34.16 2h4.68c.09-.66.16-1.32.16-2 0-.68-.07-1.35-.16-2H9.66c-.09.65-.16 1.32-.16 2Zm5.09 7.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56ZM16.5 12c0 .68-.06 1.34-.14 2h3.38c.16-.64.26-1.31.26-2s-.1-1.36-.26-2h-3.38c.08.66.14 1.32.14 2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function T4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 16c0 1.1-.9 2-2 2h3v2H1v-2h3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v10ZM20 6H4v10h16V6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function k4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74ZM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16Z"
        }
      )
    }
  );
}
function D4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 3H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2Zm0 18h-3V10h5v9c0 1.1-.9 2-2 2Zm-5-10.98h-5V21h5V10.02ZM5 21c-1.1 0-2-.9-2-2v-9h5v11H5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function O4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 20h-2V6.8l-1.05 1.05-1.4-1.4L18 3l3.5 3.45-1.45 1.4L19 6.8V20Zm-5-2.9L3 13v-2l11-4.1v1.9l-2.8.95v4.45l2.8 1v1.9Zm-4.4-3.45v-3.3l-4.55 1.6v.1l4.55 1.6Z"
        }
      )
    }
  );
}
function b4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 19v-2h13.2l-1.05-1.05 1.4-1.4L21 18l-3.45 3.45-1.4-1.4L17.2 19H4Zm2.9-5L11 3h2l4.1 11h-1.9l-.95-2.8H9.8l-1 2.8H6.9Zm3.45-4.4h3.3l-1.6-4.55h-.1l-1.6 4.55Z"
        }
      )
    }
  );
}
function P4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 19v-2H6.8l1.05-1.05-1.4-1.4L3 18l3.45 3.45 1.4-1.4L6.8 19H20ZM6.9 14 11 3h2l4.1 11h-1.9l-.95-2.8H9.8l-1 2.8H6.9Zm3.45-4.4h3.3l-1.6-4.55h-.1l-1.6 4.55Z"
        }
      )
    }
  );
}
function U4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m6 21-3.5-3.45 1.45-1.4L5 17.2V4h2v13.2l1.05-1.05 1.4 1.4L6 21Zm4-3.9v-1.9l2.8-.95V9.8l-2.8-1V6.9L21 11v2l-11 4.1Zm4.4-3.45 4.55-1.6v-.1l-4.55-1.6v3.3Z"
        }
      )
    }
  );
}
function E4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22H2V2h2v20ZM22 2h-2v20h2V2ZM11 6 6 18h2l1.356-3h5.288L16 18h2L13 6h-2Zm-1.013 7 2.008-5 2.007 5H9.987Z"
        }
      )
    }
  );
}
function G4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 20h4c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0 1 12 22Zm-4-3v-2h8v2H8Zm.25-3a7.662 7.662 0 0 1-2.737-2.75A7.278 7.278 0 0 1 4.5 9.5c0-2.083.73-3.854 2.188-5.313C8.146 2.73 9.916 2 12 2s3.854.73 5.313 2.188C18.77 5.646 19.5 7.417 19.5 9.5c0 1.35-.337 2.6-1.012 3.75A7.662 7.662 0 0 1 15.75 16h-7.5Zm.6-2h6.3a5.548 5.548 0 0 0 1.737-1.975A5.383 5.383 0 0 0 17.5 9.5c0-1.533-.533-2.833-1.6-3.9C14.833 4.533 13.533 4 12 4s-2.833.533-3.9 1.6C7.033 6.667 6.5 7.967 6.5 9.5c0 .9.204 1.742.612 2.525A5.549 5.549 0 0 0 8.85 14Z"
        }
      )
    }
  );
}
function W4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 2v2H2V2h20ZM2 20v2h20v-2H2ZM11 6 6 18h2l1.356-3h5.288L16 18h2L13 6h-2Zm-1.013 7 2.008-5 2.007 5H9.987Z"
        }
      )
    }
  );
}
function N4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m4.7 20.7-1.4-1.4 16-16 1.4 1.4-16 16Z" })
    }
  );
}
function j4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "mask",
          {
            id: "b",
            width: 18,
            height: 18,
            x: 3,
            y: 3,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ t("path", { fill: "url(#a)", d: "M3 3h18v18H3z" })
          }
        ),
        /* @__PURE__ */ t("g", { mask: "url(#b)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ n(
          "linearGradient",
          {
            id: "a",
            x1: 12,
            x2: 12,
            y1: 3,
            y2: 21,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", {}),
              /* @__PURE__ */ t("stop", { offset: 1, stopOpacity: 0 })
            ]
          }
        ) })
      ]
    }
  );
}
function X4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5ZM11 15H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M8 11h8v2H8v-2Z" })
      ]
    }
  );
}
function K4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M9 11h6v2H9v-2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11 8H8a4 4 0 1 0 0 8h3v-2H8a2 2 0 1 1 0-4h3V8ZM13 14h3a2 2 0 1 0 0-4h-3V8h3a4 4 0 0 1 0 8h-3v-2Z"
          }
        )
      ]
    }
  );
}
function Q4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14Zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79ZM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68Zm1.39 9.94v-8.37H5.5v8.37h2.77Z"
        }
      )
    }
  );
}
function Y4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14Zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79ZM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68Zm1.39 9.94v-8.37H5.5v8.37h2.77Z"
        }
      )
    }
  );
}
function J4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#0077B5",
          d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14Zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79ZM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68Zm1.39 9.94v-8.37H5.5v8.37h2.77Z"
        }
      )
    }
  );
}
function q4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 19v-2h12v2H9Zm0-6v-2h12v2H9Zm0-6V5h12v2H9ZM5 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 18c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 16c.55 0 1.02.196 1.412.587C6.804 16.98 7 17.45 7 18s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 5 20Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 3 12c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 10c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 5 14Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 3 6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4c.55 0 1.02.196 1.412.588C6.804 4.979 7 5.45 7 6c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 5 8Z"
        }
      )
    }
  );
}
function _4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 22v-1.5h2.5v-.75H4v-1.5h1.5v-.75H3V16h3c.283 0 .52.096.713.288.191.191.287.429.287.712v1c0 .283-.096.52-.287.712A.967.967 0 0 1 6 19c.283 0 .52.096.713.288.191.191.287.429.287.712v1c0 .283-.096.52-.287.712A.967.967 0 0 1 6 22H3Zm0-7v-2.75c0-.283.096-.52.288-.713A.967.967 0 0 1 4 11.25h1.5v-.75H3V9h3c.283 0 .52.096.713.287.191.192.287.43.287.713v1.75c0 .283-.096.52-.287.713A.967.967 0 0 1 6 12.75H4.5v.75H7V15H3Zm1.5-7V3.5H3V2h3v6H4.5ZM9 19v-2h12v2H9Zm0-6v-2h12v2H9Zm0-6V5h12v2H9Z"
        }
      )
    }
  );
}
function $4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 7V5h16v2H4Zm0 4h16V9H4v2Zm16 4H4v-2h16v2Zm0 4H4v-2h16v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function z4({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4.646 18.015a1.5 1.5 0 0 1 2.322-1.9A6.5 6.5 0 1 0 12 5.5a1.5 1.5 0 0 1 0-3.001 9.5 9.5 0 1 1-7.354 15.515Z"
        }
      )
    }
  );
}
function l5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 22.95v-2c-2.083-.233-3.87-1.096-5.362-2.587C4.146 16.871 3.283 15.083 3.05 13h-2v-2h2c.233-2.083 1.096-3.871 2.588-5.363C7.129 4.146 8.917 3.283 11 3.05v-2h2v2c2.083.233 3.871 1.096 5.363 2.587 1.491 1.492 2.354 3.28 2.587 5.363h2v2h-2c-.233 2.083-1.096 3.871-2.587 5.363-1.492 1.491-3.28 2.354-5.363 2.587v2h-2ZM12 19c1.933 0 3.583-.683 4.95-2.05C18.317 15.583 19 13.933 19 12c0-1.933-.683-3.583-2.05-4.95C15.583 5.683 13.933 5 12 5c-1.933 0-3.583.683-4.95 2.05C5.683 8.417 5 10.067 5 12c0 1.933.683 3.583 2.05 4.95C8.417 18.317 10.067 19 12 19Zm0-3c-1.1 0-2.042-.392-2.825-1.175C8.392 14.042 8 13.1 8 12s.392-2.042 1.175-2.825C9.958 8.392 10.9 8 12 8s2.042.392 2.825 1.175C15.608 9.958 16 10.9 16 12s-.392 2.042-1.175 2.825C14.042 15.608 13.1 16 12 16Zm0-2c.55 0 1.021-.196 1.413-.588.391-.391.587-.862.587-1.412 0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 12 10c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 10 12c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Z"
        }
      )
    }
  );
}
function t5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 9c0-3.87 3.13-7 7-7s7 3.13 7 7c0 5.25-7 13-7 13S5 14.25 5 9Zm4.5 0a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function e5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2Zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2ZM9 6v2h6V6c0-1.66-1.34-3-3-3S9 4.34 9 6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function r5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2ZM6 20V10h12v10H6Zm8-5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function i5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 7a4 4 0 1 1 8 0v2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h6V7a2 2 0 1 0-4 0H8Zm0 10v-6h8v6H8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function n5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 11a2 2 0 0 1 2-2V7a4 4 0 1 1 8 0v2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-6Zm6-6a2 2 0 0 0-2 2v2h4V7a2 2 0 0 0-2-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function h5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M20 5C12 5 5 12 5 20H3c0-9 8-17 17-17v2Z" })
    }
  );
}
function c5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5ZM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5Z"
        }
      )
    }
  );
}
function o5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.27 16.305v-4.032c0-.302-.055-.562-.165-.78a1.149 1.149 0 0 0-.5-.509c-.218-.12-.495-.18-.828-.18-.307 0-.573.053-.797.157a1.288 1.288 0 0 0-.523.422 1.018 1.018 0 0 0-.188.601H4.394c0-.333.081-.656.243-.968a2.59 2.59 0 0 1 .703-.836 3.512 3.512 0 0 1 1.101-.578c.427-.141.906-.211 1.438-.211.635 0 1.198.106 1.687.32.495.213.883.536 1.164.969.287.427.43.963.43 1.61v3.757c0 .385.026.732.078 1.039.057.302.138.565.242.789V18H9.55a3.334 3.334 0 0 1-.21-.773 6.317 6.317 0 0 1-.07-.922Zm.273-3.446.015 1.164H8.207c-.35 0-.656.034-.922.102a1.893 1.893 0 0 0-.664.281c-.177.125-.31.276-.399.453a1.327 1.327 0 0 0-.132.602c0 .224.052.43.156.617.104.182.255.326.453.43.203.104.448.156.734.156.386 0 .722-.078 1.008-.234.292-.162.521-.357.688-.586.166-.235.255-.456.265-.664l.61.836c-.063.213-.17.442-.32.687-.152.245-.35.48-.594.703a2.955 2.955 0 0 1-2.023.75c-.553 0-1.045-.11-1.477-.328a2.625 2.625 0 0 1-1.016-.898 2.33 2.33 0 0 1-.367-1.29c0-.447.083-.843.25-1.187.172-.349.422-.64.75-.875.333-.234.74-.411 1.219-.531a6.52 6.52 0 0 1 1.64-.188h1.477ZM17.574 16.305v-4.032c0-.302-.054-.562-.164-.78a1.149 1.149 0 0 0-.5-.509c-.218-.12-.494-.18-.828-.18-.307 0-.573.053-.797.157a1.288 1.288 0 0 0-.523.422 1.018 1.018 0 0 0-.188.601H12.7c0-.333.081-.656.242-.968a2.59 2.59 0 0 1 .704-.836 3.511 3.511 0 0 1 1.101-.578c.427-.141.906-.211 1.438-.211.635 0 1.198.106 1.687.32.495.213.883.536 1.164.969.287.427.43.963.43 1.61v3.757c0 .385.026.732.078 1.039.057.302.138.565.242.789V18h-1.93a3.332 3.332 0 0 1-.21-.773 6.313 6.313 0 0 1-.07-.922Zm.274-3.446.015 1.164h-1.351c-.35 0-.656.034-.922.102a1.893 1.893 0 0 0-.664.281 1.22 1.22 0 0 0-.399.453 1.326 1.326 0 0 0-.132.602c0 .224.052.43.156.617.104.182.255.326.453.43.203.104.448.156.734.156.386 0 .722-.078 1.008-.234.292-.162.521-.357.688-.586.166-.235.255-.456.265-.664l.61.836c-.063.213-.17.442-.32.687-.152.245-.35.48-.594.703a2.956 2.956 0 0 1-2.024.75c-.552 0-1.044-.11-1.476-.328a2.625 2.625 0 0 1-1.016-.898 2.33 2.33 0 0 1-.367-1.29c0-.447.083-.843.25-1.187.172-.349.422-.64.75-.875.333-.234.74-.411 1.219-.531a6.52 6.52 0 0 1 1.64-.188h1.477Z"
        }
      )
    }
  );
}
function d5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m20 7-.95-2.05L17 4l2.05-.95L20 1l.95 2.05L23 4l-2.05.95L20 7ZM8.5 7l-.95-2.05L5.5 4l2.05-.95L8.5 1l.95 2.05L11.5 4l-2.05.95L8.5 7ZM20 18.5l-.95-2.05L17 15.5l2.05-.95.95-2.05.95 2.05 2.05.95-2.05.95L20 18.5ZM5.1 21.7l-2.8-2.8c-.2-.2-.3-.442-.3-.725s.1-.525.3-.725L13.45 6.3c.2-.2.442-.3.725-.3s.525.1.725.3l2.8 2.8c.2.2.3.442.3.725s-.1.525-.3.725L6.55 21.7c-.2.2-.442.3-.725.3a.988.988 0 0 1-.725-.3Zm.75-2.1L13 12.4 11.6 11l-7.2 7.15 1.45 1.45Z"
        }
      )
    }
  );
}
function v5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 4-8 5-8-5V6l8 5 8-5v2Z"
        }
      )
    }
  );
}
function a5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7a2.5 2.5 0 0 0 0 5ZM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3Zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75ZM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13Z"
        }
      )
    }
  );
}
function u5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm14 14v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4Zm4-14V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2Z"
        }
      )
    }
  );
}
function w5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2 24v-4h20v4H2Zm12.6-12L12 9.4l-4 4 2.575 2.6 4.025-4Zm-1.175-4L16 10.575 20 6.6 17.4 4l-3.975 4Zm-2.1-.725 5.4 5.4L12 17.425c-.4.4-.87.6-1.412.6-.542 0-1.013-.2-1.413-.6L8.5 18h-5l3.15-3.125c-.4-.4-.608-.88-.625-1.438A1.876 1.876 0 0 1 6.6 12l4.725-4.725Zm0 0L16 2.6c.4-.4.87-.6 1.413-.6.541 0 1.012.2 1.412.6l2.6 2.575c.4.4.6.87.6 1.413 0 .541-.2 1.012-.6 1.412l-4.7 4.675-5.4-5.4Z"
        }
      )
    }
  );
}
function s5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12Zm8.25 7.807A9.982 9.982 0 0 0 14 12a9.981 9.981 0 0 0-3.75-7.807A7.993 7.993 0 0 1 12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8a7.996 7.996 0 0 1-1.75-.193Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function g5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 3h18c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm9 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function p5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7 1v2h10V1h6v6h-2v10h2v6h-6v-2H7v2H1v-6h2V7H1V1h6ZM3 3h2v2H3V3Zm4 4V5h10v2h2v10h-2v2H7v-2H5V7h2Zm14-2h-2V3h2v2Zm0 16h-2v-2h2v2ZM5 19v2H3v-2h2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function f5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7 1v2h10V1h6v6h-2v3.582a7.946 7.946 0 0 0-2-.52V7h-2V5H7v2H5v10h2v2h3.062c.087.699.264 1.37.52 2H7v2H1v-6h2V7H1V1h6ZM3 3h2v2H3V3Zm18 2h-2V3h2v2ZM5 19v2H3v-2h2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18 12a6 6 0 1 0 0 11.998A6 6 0 0 0 18 12Zm0 10a4 4 0 1 0-.72-7.935A5.977 5.977 0 0 1 18.75 18a5.977 5.977 0 0 1-1.47 3.935c.233.043.474.065.72.065Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function m5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M13.95 8.293a1 1 0 0 1 1.414 1.414l-2.121 2.121 2.121 2.122a1 1 0 0 1-1.414 1.414l-2.122-2.121-2.12 2.121a1 1 0 0 1-1.415-1.414l2.121-2.122-2.121-2.12a1 1 0 0 1 1.414-1.415l2.121 2.121 2.122-2.121Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM3 5h18v14H3V5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function Z5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 3h18c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm18 2H3v14h18V5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function x5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.5 4.804A8 8 0 1 1 4 12a8 8 0 0 1 4.5-7.196ZM18 12a6 6 0 0 1-7.501 5.81A7.977 7.977 0 0 0 13 12c0-2.288-.96-4.353-2.501-5.81A6 6 0 0 1 18 12Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function C5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 13H3V3h8v10Zm0 8H3v-6h8v6Zm2 0h8V11h-8v10Zm0-12V3h8v6h-8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function y5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10Zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3Z"
        }
      )
    }
  );
}
function A5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 8V6h18v2H3Zm0 5h18v-2H3v2Zm0 5h18v-2H3v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function M5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M21 18H8v-2h13v2Zm0-5H11v-2h10v2Zm0-7v2H8V6h13ZM3 15.59 6.58 12 3 8.41 4.41 7l5 5-5 5L3 15.59Z"
        }
      )
    }
  );
}
function H5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 18h13v-2H3v2Zm0-5h10v-2H3v2Zm0-7v2h13V6H3Zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59Z"
        }
      )
    }
  );
}
function V5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-2H5V5h6V3H5ZM13 3v2h6v14h-6v2h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-6Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M6.121 14.121 8.243 12 6.12 9.879l1.415-1.415L11.07 12l-3.535 3.536L6.12 14.12ZM15.828 12l2.122-2.121-1.415-1.415L13 12l3.535 3.536 1.415-1.415L15.828 12Z"
          }
        )
      ]
    }
  );
}
function B5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 14a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 11V5c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 12 2c.833 0 1.542.292 2.125.875S15 4.167 15 5v6c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 12 14Zm-1 7v-3.075c-1.733-.233-3.167-1.008-4.3-2.325C5.567 14.283 5 12.75 5 11h2c0 1.383.487 2.563 1.463 3.537C9.438 15.512 10.617 16 12 16s2.563-.488 3.537-1.463C16.512 13.563 17 12.383 17 11h2c0 1.75-.567 3.283-1.7 4.6-1.133 1.317-2.567 2.092-4.3 2.325V21h-2Zm1-9c.283 0 .52-.096.713-.287A.968.968 0 0 0 13 11V5a.967.967 0 0 0-.287-.713A.968.968 0 0 0 12 4a.968.968 0 0 0-.713.287A.967.967 0 0 0 11 5v6c0 .283.096.52.287.713.192.191.43.287.713.287Z"
        }
      )
    }
  );
}
function I5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m7 21-5-5 5-5 1.425 1.4-2.6 2.6H21v2H5.825l2.6 2.6L7 21Zm10-8-1.425-1.4 2.6-2.6H3V7h15.175l-2.6-2.6L17 3l5 5-5 5Z"
        }
      )
    }
  );
}
function L5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M19 13H5v-2h14v2Z" })
    }
  );
}
function R5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5.588 22.413C5.979 22.803 6.45 23 7 23h10c.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413V3c0-.55-.196-1.02-.587-1.413A1.926 1.926 0 0 0 17 1H7c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0 0 5 3v18c0 .55.196 1.02.588 1.413ZM17 3v18H7V3h10Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function S5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
        }
      )
    }
  );
}
function F5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
        }
      )
    }
  );
}
function T5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 10 20v-8c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 12 10h8c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v8c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 20 22h-8Zm0-2h8v-8h-8v8Zm-6-2V8c0-.55.196-1.02.588-1.412A1.923 1.923 0 0 1 8 6h10v2H8v10H6Zm-4-4V4c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 4 2h10v2H4v10H2Z"
        }
      )
    }
  );
}
function k5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10 9h4V6h3l-5-5-5 5h3v3Zm-1 1H6V7l-5 5 5 5v-3h3v-4Zm14 2-5-5v3h-3v4h3v3l5-5Zm-9 3h-4v3H7l5 5 5-5h-3v-3Z"
        }
      )
    }
  );
}
function D5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6Zm10 6H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22 0-.88-.39-1.67-1-2.22V12Zm-3.5 4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5ZM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1Zm-5 10h4v-8h-4v8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function O5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m12.7 14.05 5.65-5.65-1.4-1.45-4.25 4.25-2.15-2.1-1.4 1.4 3.55 3.55ZM8 18c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 6 16V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 8 2h12c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 18H8Zm0-2h12V4H8v12Zm-4 6c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20V6h2v14h14v2H4Z"
        }
      )
    }
  );
}
function b5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 8V7c0-.55.196-1.02.587-1.412A1.927 1.927 0 0 1 21 5c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v1h-4ZM1 8V7c0-.55.196-1.02.588-1.412A1.923 1.923 0 0 1 3 5c.55 0 1.02.196 1.412.588C4.804 5.979 5 6.45 5 7v1H1Zm0 13V9h4v12H1Zm5 0V8l6-5 6 5v13h-4v-5c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 12 14c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 10 16v5H6Zm13 0V9h4v12h-4Zm-7-9.5c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 12 8.5c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 10.5 10c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Z"
        }
      )
    }
  );
}
function P5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-2 5h-3v5.5a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2ZM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Z"
        }
      )
    }
  );
}
function U5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M7 9v6h4l5 5V4l-5 5H7Z" })
    }
  );
}
function E5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5Zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 16H7V3h14v14Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M15 5h-2v4H9v2h4v4h2v-4h4V9h-4V5Z" })
      ]
    }
  );
}
function G5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M20 12a7.949 7.949 0 0 1-.9 3.685l1.472 1.473A9.964 9.964 0 0 0 22 12c0-5.53-4.47-10-10-10a9.965 9.965 0 0 0-5.158 1.428l7.042 7.041a9.991 9.991 0 0 0-3.634-6.276A7.993 7.993 0 0 1 12 4c4.41 0 8 3.59 8 8Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3.984 6.015A9.962 9.962 0 0 0 2 12c0 5.53 4.47 10 10 10a9.962 9.962 0 0 0 5.985-1.984l1.562 1.562 1.312-1.312L3.497 2.903 2.184 4.216l1.8 1.799Zm12.563 12.563-3.15-3.15a10.023 10.023 0 0 1-3.147 4.379 7.996 7.996 0 0 0 6.297-1.229Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function W5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2.828 2.828 1.414 4.243 11 13.828V16h2v-.172L15.171 18H6v-3H4v3c0 1.1.9 2 2 2h11.172l2.627 2.627 1.414-1.414L2.828 2.828ZM13 10.172V7.83l2.59 2.58L17 9l-5-5-2.586 2.586L10.83 8 11 7.83v.342l2 2ZM20 17.172V15h-2v.172l2 2Z"
        }
      )
    }
  );
}
function N5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M21.334 18v-1.594h-5.578l2.615-2.88c.365-.376.7-.747 1.004-1.112.304-.371.567-.74.789-1.104.226-.371.4-.742.522-1.113a3.57 3.57 0 0 0 .183-1.12c0-.681-.15-1.27-.448-1.768-.293-.498-.722-.883-1.287-1.154-.564-.271-1.25-.407-2.058-.407-.858 0-1.591.174-2.2.523a3.522 3.522 0 0 0-1.395 1.395A3.917 3.917 0 0 0 13 9.59h2c0-.437.078-.824.233-1.162.155-.343.384-.611.689-.805.304-.194.68-.29 1.129-.29.387 0 .716.085.988.257.27.166.476.395.614.689.144.288.216.622.216 1.004 0 .271-.053.55-.158.839-.1.282-.274.6-.523.954s-.59.775-1.021 1.262l-3.935 4.291V18h8.102Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1 18 6 6h2l5 12h-2l-1.356-3H4.356L3 18H1ZM6.995 8l-2.008 5h4.015L6.995 8Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function j5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 11v5l2 2v1H4v-1l2-2v-5c0-3.08 1.63-5.64 4.5-6.32V4c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.68C16.36 5.36 18 7.93 18 11Zm-4 9a2 2 0 1 1-4 0h4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function X5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.414 21.799 2 20.385l3.432-3.432A8 8 0 0 1 16.569 5.817L20.384 2l1.414 1.414-3.743 3.743A8 8 0 0 1 6.772 18.44L3.414 21.8Zm4.778-4.777a6 6 0 0 0 8.445-8.445L8.192 17.02Zm6.932-9.761a6 6 0 0 0-8.247 8.247l8.247-8.247Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function K5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 21c-2.217 0-4.104-.767-5.662-2.3C4.779 17.167 4 15.3 4 13.1c0-1.05.204-2.054.612-3.012A7.784 7.784 0 0 1 6.35 7.55L12 2l5.65 5.55c.75.733 1.33 1.58 1.738 2.538.408.958.612 1.962.612 3.012 0 2.2-.78 4.067-2.337 5.6C16.104 20.233 14.217 21 12 21Zm-6-7.9h12c0-.783-.15-1.53-.45-2.237A5.453 5.453 0 0 0 16.25 9L12 4.8 7.75 9c-.567.533-1 1.154-1.3 1.863-.3.708-.45 1.454-.45 2.237Z"
        }
      )
    }
  );
}
function Q5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 5v14h14v-7h2v7c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7v2H5Zm9 0V3h7v7h-2V6.41l-9.83 9.83-1.41-1.41L17.59 5H14Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Y5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4.25 18.3A9.718 9.718 0 0 1 2 13h2.05c.1.717.283 1.404.55 2.063.267.658.617 1.27 1.05 1.837l-1.4 1.4ZM2 11a11.58 11.58 0 0 1 .75-2.825c.367-.9.867-1.725 1.5-2.475l1.4 1.4A7.886 7.886 0 0 0 4.6 8.937 8.658 8.658 0 0 0 4.05 11H2Zm8.95 10.95a9.76 9.76 0 0 1-2.813-.712A10.36 10.36 0 0 1 5.65 19.75l1.4-1.45c.583.433 1.2.792 1.85 1.075.65.283 1.333.475 2.05.575v2ZM7.1 5.7 5.65 4.25a10.754 10.754 0 0 1 2.525-1.488A9.912 9.912 0 0 1 11 2.05v2c-.717.1-1.404.292-2.063.575A8.628 8.628 0 0 0 7.1 5.7ZM12 15a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 12c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 12 9c.833 0 1.542.292 2.125.875S15 11.167 15 12s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 12 15Zm.95 6.95v-2a8.3 8.3 0 0 0 2.088-.563A8.241 8.241 0 0 0 16.9 18.3l1.45 1.45a9.936 9.936 0 0 1-2.538 1.5c-.908.367-1.862.6-2.862.7Zm4-16.25a9.105 9.105 0 0 0-1.875-1.075A8.168 8.168 0 0 0 13 4.05v-2c.983.1 1.93.337 2.838.712.908.375 1.745.871 2.512 1.488l-1.4 1.45Zm2.8 12.6-1.4-1.4a7.89 7.89 0 0 0 1.05-1.837c.267-.659.45-1.346.55-2.063H22a11.577 11.577 0 0 1-.75 2.825 9.189 9.189 0 0 1-1.5 2.475Zm.2-7.3a8.657 8.657 0 0 0-.55-2.063A7.888 7.888 0 0 0 18.35 7.1l1.4-1.4A9.718 9.718 0 0 1 22 11h-2.05Z"
        }
      )
    }
  );
}
function J5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 15h1.4v-2.4h1.4c.397 0 .73-.115.997-.345.269-.23.403-.515.403-.855v-1.2c0-.34-.134-.625-.402-.855C8.028 9.115 7.696 9 7.3 9H4.5v6Zm1.4-3.6v-1.2h1.4v1.2H5.9Zm4.2 3.6h2.8c.397 0 .73-.115.998-.345.268-.23.402-.515.402-.855v-3.6c0-.34-.134-.625-.402-.855-.269-.23-.601-.345-.998-.345h-2.8v6Zm1.4-1.2v-3.6h1.4v3.6h-1.4Zm4.2 1.2h1.4v-2.4h1.4v-1.2h-1.4v-1.2h2.4V9h-3.8v6Z"
        }
      )
    }
  );
}
function q5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M2 7V4c0-.55.196-1.02.588-1.412A1.923 1.923 0 0 1 4 2h3v2H4v3H2ZM20 7V4h-3V2h3c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v3h-2ZM17 20v2h3c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413v-3h-2v3h-3ZM4 22c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 2 20v-3h2v3h3v2H4Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9 17c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 7 15V9c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 9 7h6c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v6c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 15 17H9Zm6-8H9v6h6V9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function _5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.588 16.413C7.979 16.804 8.45 17 9 17h6c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413V9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 15 7H9c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 7 9v6c0 .55.196 1.021.588 1.413ZM9 9h6v6H9V9Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M2 22v-2h20v2H2Z" })
      ]
    }
  );
}
function $5({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 2H2v20h2V2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.588 16.413C7.979 16.804 8.45 17 9 17h6c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413V9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 15 7H9c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 7 9v6c0 .55.196 1.021.588 1.413ZM9 9h6v6H9V9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function z5({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 2H2v20h2V2ZM22 22h-2V2h2v20Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.588 16.413C7.979 16.804 8.45 17 9 17h6c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413V9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 15 7H9c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 7 9v6c0 .55.196 1.021.588 1.413ZM9 9h6v6H9V9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function ll({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 2h-2v20h2V2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.588 16.413C7.979 16.804 8.45 17 9 17h6c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413V9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 15 7H9c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 7 9v6c0 .55.196 1.021.588 1.413ZM9 9h6v6H9V9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function tl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 4V2H2v2h20Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.588 16.413C7.979 16.804 8.45 17 9 17h6c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413V9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 15 7H9c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 7 9v6c0 .55.196 1.021.588 1.413ZM9 9h6v6H9V9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function el({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M22 4V2H2v2h20ZM2 22v-2h20v2H2Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.588 16.413C7.979 16.804 8.45 17 9 17h6c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413V9c0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 15 7H9c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 7 9v6c0 .55.196 1.021.588 1.413ZM9 9h6v6H9V9Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function rl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m19 1-5 5v11l5-4.5V1ZM1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5V6c-1.45-1.1-3.55-1.5-5.5-1.5-1.95 0-4.05.4-5.5 1.5Zm22 13.5V6c-.6-.45-1.25-.75-2-1v13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v2c1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5v-1.1Z"
        }
      )
    }
  );
}
function il({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 21v-6h2v2.6l3.1-3.1 1.4 1.4L6.4 19H9v2H3ZM15.9 9.5l-1.4-1.4L17.6 5H15V3h6v6h-2V6.4l-3.1 3.1Z"
        }
      )
    }
  );
}
function nl({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 2v2H2V2h20ZM2 20v2h20v-2H2ZM2 16h20v2H2v-2ZM11 11V5h2v6h3l-4 4-4-4h3Z"
        }
      )
    }
  );
}
function hl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18A2.996 2.996 0 0 0 18 21c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82ZM6 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm12 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z"
        }
      )
    }
  );
}
function cl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 5h4v14h-4V5Zm-4 0v14H6V5h4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ol({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4Zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8Z"
        }
      )
    }
  );
}
function dl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M9.423 11.916H8.398V9.135h.977c.586 0 1.028.097 1.326.292.305.187.458.533.458 1.037 0 .968-.579 1.452-1.736 1.452Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm2 5v7.979h1.398V13.05h1.133c.426 0 .82-.05 1.182-.147.37-.105.687-.264.952-.476a2.27 2.27 0 0 0 .639-.817c.153-.325.229-.708.229-1.147 0-.463-.076-.85-.23-1.159a1.982 1.982 0 0 0-.638-.768 2.6 2.6 0 0 0-.976-.415A5.608 5.608 0 0 0 9.483 8H7Zm6.98 7.893c.402.155.808.232 1.218.232.37 0 .699-.049.988-.146.29-.098.53-.228.723-.39a1.734 1.734 0 0 0 .59-1.318 1.48 1.48 0 0 0-.156-.708 1.462 1.462 0 0 0-.398-.512 2.192 2.192 0 0 0-.542-.342 6.372 6.372 0 0 0-.603-.256 30.52 30.52 0 0 1-.47-.17 2.868 2.868 0 0 1-.386-.184 1.114 1.114 0 0 1-.277-.22.53.53 0 0 1-.096-.317c0-.187.068-.341.205-.463.144-.13.365-.196.663-.196.233 0 .454.05.663.147.217.09.43.211.639.366l.639-.854a4.12 4.12 0 0 0-.856-.5c-.33-.147-.7-.22-1.11-.22-.666 0-1.193.167-1.579.5-.385.334-.578.765-.578 1.293 0 .253.048.472.145.66.104.178.233.337.385.475.161.138.342.256.543.354.2.098.397.183.59.256l.458.195c.153.057.29.122.41.196a1 1 0 0 1 .29.256c.072.09.108.195.108.317a.677.677 0 0 1-.229.524c-.153.13-.39.196-.711.196-.306 0-.59-.057-.856-.171a4.052 4.052 0 0 1-.784-.5l-.65.902c.289.236.63.435 1.024.598Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function vl({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M7 15.979V8h2.483c.434 0 .836.04 1.206.122a2.6 2.6 0 0 1 .976.415c.273.195.486.451.639.768.153.31.229.696.229 1.16 0 .438-.076.82-.23 1.146a2.27 2.27 0 0 1-.638.817c-.265.212-.583.37-.952.476a4.523 4.523 0 0 1-1.182.147H8.398v2.928H7Zm1.398-4.063h1.025c1.157 0 1.736-.484 1.736-1.452 0-.504-.153-.85-.458-1.037-.298-.195-.74-.292-1.326-.292h-.977v2.781ZM15.198 16.125c-.41 0-.816-.077-1.218-.232a4.066 4.066 0 0 1-1.024-.598l.65-.902c.266.211.527.378.784.5.265.114.55.17.856.17.321 0 .558-.064.711-.195a.677.677 0 0 0 .23-.524.489.489 0 0 0-.11-.317 1 1 0 0 0-.289-.256 2.411 2.411 0 0 0-.41-.196l-.458-.195a7.197 7.197 0 0 1-.59-.256 2.508 2.508 0 0 1-.543-.354 1.997 1.997 0 0 1-.386-.476 1.42 1.42 0 0 1-.144-.659c0-.528.193-.96.579-1.293.385-.333.912-.5 1.579-.5.41 0 .78.073 1.109.22.33.146.614.313.855.5l-.638.854a3.002 3.002 0 0 0-.64-.366 1.548 1.548 0 0 0-.662-.147c-.298 0-.519.066-.663.196a.595.595 0 0 0-.205.463.53.53 0 0 0 .096.318c.073.08.165.154.277.22.113.064.242.125.386.182.153.057.31.114.47.17.201.074.402.16.603.257.201.09.382.203.543.342.168.138.3.309.397.512.105.195.157.431.157.708a1.734 1.734 0 0 1-.59 1.317 2.197 2.197 0 0 1-.724.39c-.29.098-.619.147-.988.147Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M19 5H5v14h14V5ZM5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function al({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.15 5.34h4.4c.72 0 1.383.067 1.99.2s1.13.36 1.57.68c.44.32.787.737 1.04 1.25s.38 1.15.38 1.91c0 .72-.127 1.347-.38 1.88a3.684 3.684 0 0 1-1.05 1.33 4.387 4.387 0 0 1-1.58.78 7.413 7.413 0 0 1-1.97.25H5.47v4.8H3.15V5.34Zm4.22 6.42c1.92 0 2.88-.793 2.88-2.38 0-.827-.24-1.397-.72-1.71-.48-.313-1.2-.47-2.16-.47h-1.9v4.56h1.9Zm7.02 4.06c.44.347.877.617 1.31.81.433.193.903.29 1.41.29.533 0 .927-.11 1.18-.33.253-.22.38-.503.38-.85 0-.2-.06-.377-.18-.53a1.73 1.73 0 0 0-.48-.41 4.61 4.61 0 0 0-.68-.33c-.253-.1-.507-.203-.76-.31-.32-.12-.647-.26-.98-.42a3.94 3.94 0 0 1-.89-.58 2.927 2.927 0 0 1-.64-.79c-.167-.3-.25-.657-.25-1.07 0-.867.32-1.573.96-2.12.64-.547 1.513-.82 2.62-.82.68 0 1.293.12 1.84.36.547.24 1.02.513 1.42.82l-1.06 1.4a5.481 5.481 0 0 0-1.05-.61 2.76 2.76 0 0 0-1.11-.23c-.493 0-.857.103-1.09.31a.987.987 0 0 0-.35.77c0 .2.057.37.17.51.113.14.263.263.45.37.187.107.403.207.65.3s.503.187.77.28c.333.12.667.257 1 .41.333.153.637.343.91.57.273.227.493.503.66.83.167.327.25.717.25 1.17a2.747 2.747 0 0 1-.98 2.15c-.32.273-.72.49-1.2.65-.48.16-1.027.24-1.64.24-.68 0-1.35-.13-2.01-.39a6.503 6.503 0 0 1-1.71-.97l1.08-1.48Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ul({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 11h-8v6h8v-6Zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2Zm-2 .02H3V4.97h18v14.05Z"
        }
      )
    }
  );
}
function wl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "m16 12 2 2v2h-5v6l-1 1-1-1v-6H6v-2l2-2V5H7V3h10v2h-1v7Z" })
    }
  );
}
function sl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19.51 3.08 3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41ZM11.88 3 3 11.88v2.83L14.71 3h-2.83ZM5 3c-1.1 0-2 .9-2 2v2l4-4H5Zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2Zm-9.71 0h2.83L21 12.12V9.29L9.29 21Z"
        }
      )
    }
  );
}
function gl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M8 5v14l11-7L8 5Z" })
    }
  );
}
function pl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-2 14.5v-9l6 4.5-6 4.5Z"
        }
      )
    }
  );
}
function fl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14 10H3v2h11v-2Zm0-4H3v2h11V6Zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4ZM3 16h7v-2H3v2Z"
        }
      )
    }
  );
}
function ml({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11.25 13.5c.633 0 1.167-.217 1.6-.65.433-.433.65-.967.65-1.6 0-.633-.217-1.167-.65-1.6-.433-.433-.967-.65-1.6-.65-.633 0-1.167.217-1.6.65-.433.433-.65.967-.65 1.6 0 .633.217 1.167.65 1.6.433.433.967.65 1.6.65Zm4.825 4-2.625-2.625a3.677 3.677 0 0 1-1.063.475c-.375.1-.754.15-1.137.15-1.183 0-2.188-.412-3.012-1.238C7.413 13.438 7 12.433 7 11.25s.412-2.188 1.238-3.012C9.063 7.413 10.067 7 11.25 7s2.188.412 3.012 1.238c.825.825 1.238 1.829 1.238 3.012 0 .383-.054.762-.162 1.137-.109.375-.271.73-.488 1.063l2.65 2.65-1.425 1.4ZM4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4Zm12 0v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm18 0V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2Z"
        }
      )
    }
  );
}
function Zl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.45 19h9.1l3.075-9.225L12 4.45 4.375 9.775 7.45 19ZM6 21 2 9l10-7 10 7-4 12H6Z"
        }
      )
    }
  );
}
function xl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6 1h12c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2Zm0 20h12V3H6v18Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M14 14h2v5h-5v-2h3v-3ZM13 7h-3v3H8V5h5v2Z" })
      ]
    }
  );
}
function Cl({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H6Zm1.793 12.036a1 1 0 1 1 1.414-1.415l1.414 1.415 4.243-4.243a1 1 0 1 1 1.414 1.414l-4.95 4.95a.997.997 0 0 1-1.414 0l-2.121-2.121Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function yl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m6 20 1-4H3l.5-2h4l1-4h-4L5 8h4l1-4h2l-1 4h4l1-4h2l-1 4h4l-.5 2h-4l-1 4h4l-.5 2h-4l-1 4h-2l1-4H9l-1 4H6Zm3.5-6h4l1-4h-4l-1 4Z"
        }
      )
    }
  );
}
function Al({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11.342 10.47c0 .971-.587 1.457-1.761 1.457H8.419v-2.79h1.162c.587 0 1.028.096 1.321.288.294.192.44.54.44 1.046Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm6.691 3H7v8h1.419v-2.936h1.272c.432 0 .834-.05 1.205-.153.371-.102.693-.26.966-.477.274-.216.488-.487.643-.813.154-.326.232-.71.232-1.15 0-.465-.078-.854-.232-1.168a2.049 2.049 0 0 0-.637-.765 2.537 2.537 0 0 0-.96-.416A5.673 5.673 0 0 0 9.691 8Zm5.285 1.994h-1.163V16h1.407v-3.67c.188-.456.412-.777.673-.96.26-.183.51-.275.746-.275a1.886 1.886 0 0 1 .624.098l.245-1.224c-.172-.081-.4-.122-.685-.122-.318 0-.628.104-.93.312-.302.208-.559.508-.77.9h-.05l-.097-1.065Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function Ml({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9.691 8H7v8h1.419v-2.936h1.272c.432 0 .834-.05 1.205-.153.371-.102.693-.26.966-.477.274-.216.488-.487.643-.813.154-.326.232-.71.232-1.15 0-.465-.078-.854-.232-1.168a2.049 2.049 0 0 0-.637-.765 2.537 2.537 0 0 0-.96-.416A5.673 5.673 0 0 0 9.691 8Zm1.651 2.47c0 .971-.587 1.457-1.761 1.457H8.419v-2.79h1.162c.587 0 1.028.096 1.321.288.294.192.44.54.44 1.046Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M14.976 9.994h-1.163V16h1.407v-3.67c.188-.456.412-.777.673-.96.26-.183.51-.275.746-.275a1.886 1.886 0 0 1 .624.098l.245-1.224c-.172-.081-.4-.122-.685-.122-.318 0-.628.104-.93.312-.302.208-.559.508-.77.9h-.05l-.097-1.065Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0h14v14H5V5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function Hl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.41 5.355h4.4c.72 0 1.383.067 1.99.2.607.134 1.13.36 1.57.68.44.32.787.737 1.04 1.25.254.514.38 1.15.38 1.91 0 .72-.126 1.347-.38 1.88a3.685 3.685 0 0 1-1.05 1.33 4.385 4.385 0 0 1-1.58.78 7.413 7.413 0 0 1-1.97.25H5.73v4.8H3.41V5.355Zm4.22 6.42c1.92 0 2.88-.793 2.88-2.38 0-.826-.24-1.396-.72-1.71-.48-.313-1.2-.47-2.16-.47h-1.9v4.56h1.9Zm6.92-3.16h1.9l.16 1.74h.08c.347-.64.767-1.13 1.26-1.47.494-.34 1-.51 1.52-.51.467 0 .84.067 1.12.2l-.4 2a4.22 4.22 0 0 0-.48-.12 3.09 3.09 0 0 0-.54-.04c-.387 0-.793.15-1.22.45-.427.3-.793.824-1.1 1.57v6h-2.3v-9.82Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Vl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 21 2 9l3-6h14l3 6-10 12ZM9.625 8h4.75l-1.5-3h-1.75l-1.5 3ZM11 16.675V10H5.45L11 16.675Zm2 0L18.55 10H13v6.675ZM16.6 8h2.65l-1.5-3H15.1l1.5 3ZM4.75 8H7.4l1.5-3H6.25l-1.5 3Z"
        }
      )
    }
  );
}
function Bl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m20.528 4.73 1.43 5c.18.63-.3 1.27-.96 1.27H13v7h3v2H8v-2h3v-7H2.998c-.66 0-1.14-.64-.96-1.27l1.43-5c.12-.43.51-.73.96-.73h15.14c.45 0 .84.3.96.73Z"
        }
      )
    }
  );
}
function Il({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16 8V5H8v3H6V3h12v5h-2Zm2 4.5c.283 0 .52-.096.712-.287A.968.968 0 0 0 19 11.5a.968.968 0 0 0-.288-.713A.968.968 0 0 0 18 10.5a.968.968 0 0 0-.712.287.968.968 0 0 0-.288.713c0 .283.096.52.288.713.191.191.429.287.712.287ZM16 19v-4H8v4h8Zm2 2H6v-4H2v-6c0-.85.292-1.563.875-2.137C3.458 8.288 4.167 8 5 8h14c.85 0 1.563.287 2.137.863.575.575.863 1.287.863 2.137v6h-4v4Zm2-6v-4a.968.968 0 0 0-.288-.713A.968.968 0 0 0 19 10H5a.967.967 0 0 0-.713.287A.968.968 0 0 0 4 11v4h2v-2h12v2h2Z"
        }
      )
    }
  );
}
function Ll({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-8-8v8h8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Rl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.071 19.071A9.97 9.97 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.97 9.97 0 0 1-2.929 7.071Zm-1.414-1.414A8 8 0 1 1 12 4v8l5.657 5.657Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Sl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-10 8V4a8 8 0 1 0 0 16Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Fl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 12c0 5.523-4.477 10-10 10a9.969 9.969 0 0 1-7.071-2.929A9.969 9.969 0 0 1 2 12C2 6.477 6.477 2 12 2c.345 0 .686.017 1.022.052C18.065 2.564 22 6.822 22 12ZM6.343 17.657 12 12V4a8 8 0 0 0-5.657 13.657Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Tl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2c5.523 0 10 4.477 10 10v.065C21.965 17.558 17.5 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2ZM4 12h8V4a8 8 0 0 0-8 8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function kl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11.71 17.99A5.993 5.993 0 0 1 6 12c0-3.31 2.69-6 6-6 3.22 0 5.84 2.53 5.99 5.71l-2.1-.63a3.999 3.999 0 1 0-4.81 4.81l.63 2.1ZM22 12c0 .3-.01.6-.04.9l-1.97-.59c.01-.1.01-.21.01-.31 0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c.1 0 .21 0 .31-.01l.59 1.97c-.3.03-.6.04-.9.04-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10Zm-3.77 4.26L22 15l-10-3 3 10 1.26-3.77 4.27 4.27 1.98-1.98-4.28-4.26Z"
        }
      )
    }
  );
}
function Dl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93ZM16 16c.9 0 1.64.58 1.9 1.39C19.2 15.97 20 14.08 20 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h6c.55 0 1 .45 1 1v3h1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Ol({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 4v-.5a2.5 2.5 0 0 0-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1Zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4Zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03ZM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93Z"
        }
      )
    }
  );
}
function bl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11 8.17 6.49 3.66A9.91 9.91 0 0 1 12 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.842 7.842 0 0 0 20 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2v1.17Zm10.19 13.02-1.41 1.41-2.27-2.27A9.839 9.839 0 0 1 12 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.39 18.38ZM11 18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.08 3.05 7.44 7 7.93V18Z"
        }
      )
    }
  );
}
function Pl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 6V4h14v2H5Zm4 8H5l7-7 7 7h-4v6H9v-6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Ul({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.026 3h6.538v6.52H3.026V3Zm16.307 16.357H21V21h-1.667v-1.643Zm-3.204-.003h1.667v1.565H14.462v-3.2h1.615v-1.623h1.642V12.86h1.667v1.59h1.588v1.643h-1.588v1.643H16.129v1.617Zm-4.95-3.285h1.615v-1.643h-1.562v-1.643h1.562V11.14h-1.588v1.643H9.538V11.14h1.64V6.261h1.667v4.878h1.614v1.643h1.588v-1.643h1.667v1.643H16.13v1.643h-1.667v3.235h-1.615v3.26H11.18v-4.85Zm8.126-4.93h1.667v1.643h-1.667v-1.643Zm-13.022 0H7.95v1.643H6.283v-1.643Zm-3.257 0h1.667v1.643H3.026v-1.643ZM11.18 3h1.667v1.643H11.18V3ZM3 14.451h6.538v6.521H3v-6.52Zm1.588 1.585H7.95v3.353H4.588v-3.353ZM14.435 3h6.537v6.52h-6.537V3Zm1.589 1.584h3.362v3.354h-3.362V4.584Zm-11.41 0h3.362v3.354H4.614V4.584Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function El({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M11.07 11.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 5.96C7.25 3.83 9.18 2 11.99 2c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15ZM14 19c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z"
        }
      )
    }
  );
}
function Gl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M6 17h3l2-4V7H5v6h3l-2 4Zm8 0h3l2-4V7h-6v6h3l-2 4Z" })
    }
  );
}
function Wl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2a7.843 7.843 0 0 0 4.9-1.675L15.475 16.9c-.483.35-1.02.62-1.612.812A6 6 0 0 1 12 18c-1.667 0-3.083-.583-4.25-1.75C6.583 15.083 6 13.667 6 12c0-1.667.583-3.083 1.75-4.25C8.917 6.583 10.333 6 12 6c1.667 0 3.083.583 4.25 1.75C17.417 8.917 18 10.333 18 12c0 .65-.1 1.275-.3 1.875-.2.6-.475 1.142-.825 1.625l1.425 1.425a8.169 8.169 0 0 0 1.25-2.275c.3-.833.45-1.717.45-2.65 0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Zm0-4c.367 0 .72-.046 1.062-.137.342-.092.663-.23.963-.413L12.5 13.925a.933.933 0 0 1-.25.063A2.615 2.615 0 0 1 12 14c-.55 0-1.02-.196-1.412-.588A1.923 1.923 0 0 1 10 12c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 12 10c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413 0 .1-.004.196-.012.287a.944.944 0 0 1-.063.263l1.5 1.5A3.848 3.848 0 0 0 16 12c0-1.1-.392-2.042-1.175-2.825C14.042 8.392 13.1 8 12 8s-2.042.392-2.825 1.175C8.392 9.958 8 10.9 8 12s.392 2.042 1.175 2.825C9.958 15.608 10.9 16 12 16Z"
        }
      )
    }
  );
}
function Nl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "mask",
          {
            id: "b",
            width: 18,
            height: 18,
            x: 3,
            y: 3,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ t("path", { fill: "url(#a)", d: "M3 3h18v18H3z" })
          }
        ),
        /* @__PURE__ */ t("g", { mask: "url(#b)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ n(
          "radialGradient",
          {
            id: "a",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(0 9 -9 0 12 12)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", {}),
              /* @__PURE__ */ t("stop", { offset: 1, stopOpacity: 0 })
            ]
          }
        ) })
      ]
    }
  );
}
function jl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm0 16h14V5H5v14Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Xl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 4h6L7.71 6.29l5.29 5.3V20h-2v-7.59l-4.71-4.7L4 10V4Zm12.29 2.29L14 4h6v6l-2.29-2.29-2.88 2.88-1.42-1.42 2.88-2.88Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Kl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 0 1 7.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6Z"
        }
      )
    }
  );
}
function Ql({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35Z"
        }
      )
    }
  );
}
function Yl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm5 1h10v-2H7v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Jl({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 5h2V3c-1.1 0-2 .9-2 2Zm0 8h2v-2H3v2Zm4 8h2v-2H7v2ZM3 9h2V7H3v2Zm10-6h-2v2h2V3Zm6 0v2h2c0-1.1-.9-2-2-2ZM5 21v-2H3c0 1.1.9 2 2 2Zm-2-4h2v-2H3v2ZM9 3H7v2h2V3Zm2 18h2v-2h-2v2Zm8-8h2v-2h-2v2Zm0 8c1.1 0 2-.9 2-2h-2v2Zm0-12h2V7h-2v2Zm0 8h2v-2h-2v2Zm-4 4h2v-2h-2v2Zm0-16h2V3h-2v2ZM7 17h10V7H7v10Zm2-8h6v6H9V9Z"
        }
      )
    }
  );
}
function ql({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 9.65V7.525L7.525 3H9.65L3 9.65Zm0-4.9V3h1.75L3 4.75Zm13.175 1.675a8.355 8.355 0 0 0-.537-.538 4.983 4.983 0 0 0-.588-.462L17.475 3H19.6l-3.425 3.425ZM5.5 14.975l1.925-1.925c.117.183.238.35.363.5.125.15.262.292.412.425-.467.117-.938.262-1.413.437-.475.175-.904.363-1.287.563Zm12-4.925V10c0-.317-.025-.625-.075-.925-.05-.3-.125-.592-.225-.875L21 4.4v2.15l-3.5 3.5ZM10.9 4.6 12.525 3h2.125l-1.6 1.6a6.626 6.626 0 0 0-.525-.075A6.07 6.07 0 0 0 10.9 4.6ZM3 14.625V12.5l3.6-3.6a6.225 6.225 0 0 0-.1 1.1 5.28 5.28 0 0 0 .1 1.025l-3.6 3.6ZM20.725 16.7a4.251 4.251 0 0 0-.462-.575 4.584 4.584 0 0 0-.563-.5l1.3-1.3v2.125l-.275.25Zm-2.9-2.05a5.91 5.91 0 0 0-.7-.25c-.15-.05-.296-.1-.437-.15a3.792 3.792 0 0 0-.438-.125L21 9.35v2.15l-3.175 3.15ZM12 14c-1.1 0-2.042-.392-2.825-1.175C8.392 12.042 8 11.1 8 10s.392-2.042 1.175-2.825C9.958 6.392 10.9 6 12 6s2.042.392 2.825 1.175C15.608 7.958 16 8.9 16 10s-.392 2.042-1.175 2.825C14.042 13.608 13.1 14 12 14Zm0-2c.55 0 1.021-.196 1.413-.588.391-.391.587-.862.587-1.412 0-.55-.196-1.021-.587-1.413A1.928 1.928 0 0 0 12 8c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 10 10c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Zm-8 9v-1.775c0-.567.142-1.092.425-1.575.283-.483.675-.85 1.175-1.1.85-.433 1.813-.8 2.888-1.1C9.563 15.15 10.733 15 12 15s2.437.15 3.512.45c1.075.3 2.038.667 2.888 1.1.5.25.892.617 1.175 1.1A3.06 3.06 0 0 1 20 19.225V21H4Zm2.025-2h11.95a.976.976 0 0 0-.175-.388.926.926 0 0 0-.325-.262c-.6-.3-1.362-.6-2.287-.9C14.263 17.15 13.2 17 12 17c-1.2 0-2.263.15-3.188.45-.925.3-1.687.6-2.287.9a.87.87 0 0 0-.325.275 1.1 1.1 0 0 0-.175.375Z"
        }
      )
    }
  );
}
function _l({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20.71 5.63c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM3 21v-3.75L14.06 6.19l3.75 3.75L6.75 21H3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "m11 21 4-4h6v4H11Z" })
      ]
    }
  );
}
function $l({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 13c0-2.45 1.76-4.47 4.08-4.91l-1.49 1.5L7 11l4-4.01L7 3 5.59 4.41l1.58 1.58v.06A7.007 7.007 0 0 0 1 13c0 3.87 3.13 7 7 7h3v-2H8c-2.76 0-5-2.24-5-5Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13 13v7h9v-7h-9Zm7 5h-5v-3h5v3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M13 4h9v7h-9V4Z" })
      ]
    }
  );
}
function zl({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3ZM9 3 5 6.99h3V14h2V6.99h3L9 3Z"
        }
      )
    }
  );
}
function lt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 7H7v4H5V5h12V2l4 4-4 4V7ZM7 17h10v-4h2v6H7v3l-4-4 4-4v3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function tt({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2Zm0 15H5l5-6v6Zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z"
        }
      )
    }
  );
}
function et({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8Z"
        }
      )
    }
  );
}
function rt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-1.25 0-2.42-.238-3.512-.712a9.149 9.149 0 0 1-2.85-1.925 9.147 9.147 0 0 1-1.925-2.85A8.707 8.707 0 0 1 3 13h2c0 1.95.68 3.604 2.037 4.962C8.396 19.322 10.05 20 12 20c1.95 0 3.604-.68 4.962-2.038C18.322 16.604 19 14.95 19 13c0-1.95-.68-3.604-2.038-4.963C15.604 6.68 13.95 6 12 6h-.15l1.55 1.55L12 9 8 5l4-4 1.4 1.45L11.85 4H12c1.25 0 2.42.237 3.512.713a9.147 9.147 0 0 1 2.85 1.925 9.149 9.149 0 0 1 1.926 2.85A8.707 8.707 0 0 1 21 13c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.926A8.707 8.707 0 0 1 12 22Zm-3-6v-4.5H7.5V10h3v6H9Zm3.5 0a.968.968 0 0 1-.713-.287A.968.968 0 0 1 11.5 15v-4c0-.283.096-.52.287-.713A.968.968 0 0 1 12.5 10h2c.283 0 .52.096.713.287.191.192.287.43.287.713v4c0 .283-.096.52-.287.713A.968.968 0 0 1 14.5 16h-2Zm.5-1.5h1v-3h-1v3Z"
        }
      )
    }
  );
}
function it({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M13.4 2.45 11.85 4H12c1.25 0 2.421.238 3.513.713a9.148 9.148 0 0 1 2.85 1.925 9.147 9.147 0 0 1 1.924 2.85A8.708 8.708 0 0 1 21 13c0 1.25-.238 2.421-.713 3.513a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.924A8.708 8.708 0 0 1 12 22a8.708 8.708 0 0 1-3.513-.713 9.147 9.147 0 0 1-2.85-1.925 9.148 9.148 0 0 1-1.924-2.85A8.708 8.708 0 0 1 3 13h2c0 1.95.679 3.605 2.037 4.963C8.395 19.32 10.05 20 12 20c1.95 0 3.605-.679 4.963-2.037C18.32 16.605 19 14.95 19 13c0-1.95-.679-3.605-2.037-4.963C15.605 6.68 13.95 6 12 6h-.15l1.55 1.55L12 9 8 5l4-4 1.4 1.45Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M10.5 10c.283 0 .521.095.713.287.192.192.287.43.287.713v4a.968.968 0 0 1-.287.713.968.968 0 0 1-.713.287h-3v-1.5H10v-1H8.5v-1H10v-1H7.5V10h3Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.5 10c.283 0 .521.095.713.287.192.192.287.43.287.713v4a.968.968 0 0 1-.287.713.968.968 0 0 1-.713.287h-2a.968.968 0 0 1-.713-.287A.968.968 0 0 1 12.5 15v-4c0-.283.095-.521.287-.713A.968.968 0 0 1 13.5 10h2ZM14 14.5h1v-3h-1v3Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function nt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-1.25 0-2.42-.238-3.512-.712a9.149 9.149 0 0 1-2.85-1.925 9.147 9.147 0 0 1-1.925-2.85A8.707 8.707 0 0 1 3 13h2c0 1.95.68 3.604 2.037 4.962C8.396 19.322 10.05 20 12 20c1.95 0 3.604-.68 4.962-2.038C18.322 16.604 19 14.95 19 13c0-1.95-.68-3.604-2.038-4.963C15.604 6.68 13.95 6 12 6h-.15l1.55 1.55L12 9 8 5l4-4 1.4 1.45L11.85 4H12c1.25 0 2.42.237 3.512.712a9.147 9.147 0 0 1 2.85 1.925 9.149 9.149 0 0 1 1.926 2.85A8.707 8.707 0 0 1 21 13c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.926A8.707 8.707 0 0 1 12 22Zm-2.5-6v-1.5h3v-1h-3V10H14v1.5h-3v1h2c.283 0 .52.096.713.287.191.192.287.43.287.713V15c0 .283-.096.52-.287.713A.968.968 0 0 1 13 16H9.5Z"
        }
      )
    }
  );
}
function ht({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11Z"
        }
      )
    }
  );
}
function ct({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 3a2 2 0 0 0-2 2v4h13a3 3 0 0 1 3 3v9h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M1 11h8v10H3a2 2 0 0 1-2-2v-8ZM14 11h-3v10h4v-9a1 1 0 0 0-1-1Z"
          }
        )
      ]
    }
  );
}
function ot({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 3h18c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm0 8v8.01h6V11H3Zm8 8.01h4.01L15 19v-7a1 1 0 0 0-1-1h-3v8.01Zm6 0V12a3 3 0 0 0-3-3H3V4.99h18v14.02h-4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function dt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 3a9 9 0 0 0-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18Zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8H12Z"
        }
      )
    }
  );
}
function vt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.25 21 3 15.75v-7.5L8.25 3h7.5L21 8.25v7.5L15.75 21h-7.5Zm.85-2h5.8l4.1-4.1V9.1L14.9 5H9.1L5 9.1v5.8L9.1 19Zm.05-2.75L12 13.4l2.85 2.85 1.4-1.4L13.4 12l2.85-2.85-1.4-1.4L12 10.6 9.15 7.75l-1.4 1.4L10.6 12l-2.85 2.85 1.4 1.4Z"
        }
      )
    }
  );
}
function at({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m9.675 12.7.875-2.85L8.25 8h2.85l.9-2.8.9 2.8h2.85l-2.325 1.85.875 2.85-2.3-1.775L9.675 12.7ZM6 22v-7.725a7.707 7.707 0 0 1-1.475-2.4A7.862 7.862 0 0 1 4 9c0-2.233.775-4.125 2.325-5.675C7.875 1.775 9.767 1 12 1c2.233 0 4.125.775 5.675 2.325C19.225 4.875 20 6.767 20 9a7.862 7.862 0 0 1-.525 2.875c-.35.9-.842 1.7-1.475 2.4V22l-6-2-6 2Zm6-7c1.667 0 3.083-.583 4.25-1.75C17.417 12.083 18 10.667 18 9c0-1.667-.583-3.083-1.75-4.25C15.083 3.583 13.667 3 12 3c-1.667 0-3.083.583-4.25 1.75C6.583 5.917 6 7.333 6 9c0 1.667.583 3.083 1.75 4.25C8.917 14.417 10.333 15 12 15Zm-4 4.025L12 18l4 1.025v-3.1a8.412 8.412 0 0 1-1.887.787A7.69 7.69 0 0 1 12 17a7.69 7.69 0 0 1-2.113-.288A8.413 8.413 0 0 1 8 15.925v3.1Z"
        }
      )
    }
  );
}
function ut({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m5.6 9.996 1.95.825c.233-.467.475-.917.725-1.35.25-.434.525-.867.825-1.3l-1.4-.275-2.1 2.1Zm3.55 2.075L12 14.896c.7-.267 1.45-.675 2.25-1.225s1.55-1.175 2.25-1.875a13.467 13.467 0 0 0 2.738-3.887c.658-1.426.945-2.738.862-3.938-1.2-.084-2.517.204-3.95.862a13.408 13.408 0 0 0-3.9 2.738c-.7.7-1.325 1.45-1.875 2.25s-.958 1.55-1.225 2.25Zm4.45-1.625a1.921 1.921 0 0 1-.575-1.413c0-.558.192-1.03.575-1.412.383-.384.858-.575 1.425-.575.567 0 1.042.191 1.425.575.383.383.575.854.575 1.412 0 .558-.192 1.03-.575 1.413-.383.383-.858.575-1.425.575-.567 0-1.042-.192-1.425-.575Zm.475 8.025 2.1-2.1-.275-1.4c-.433.3-.867.57-1.3.812-.433.242-.883.48-1.35.713l.825 1.975ZM21.9 2.146a11.516 11.516 0 0 1-.587 5.887c-.709 1.908-1.93 3.73-3.663 5.463l.5 2.475c.067.333.05.658-.05.975-.1.316-.267.591-.5.825l-4.2 4.2-2.1-4.925-4.275-4.275-4.925-2.1 4.175-4.2c.233-.234.513-.4.838-.5.325-.1.654-.117.987-.05l2.475.5c1.733-1.734 3.55-2.959 5.45-3.675 1.9-.717 3.858-.917 5.875-.6Zm-18.025 13.8c.583-.584 1.296-.88 2.137-.888.842-.008 1.555.28 2.138.863s.87 1.295.862 2.137c-.008.842-.304 1.554-.887 2.138-.417.416-1.112.775-2.087 1.075-.975.3-2.321.566-4.038.8.233-1.717.5-3.063.8-4.038.3-.975.658-1.67 1.075-2.087Zm1.425 1.4c-.167.166-.333.47-.5.913a6.453 6.453 0 0 0-.35 1.337 7.03 7.03 0 0 0 1.338-.337c.441-.16.745-.322.912-.488.2-.2.308-.442.325-.725a.907.907 0 0 0-.275-.725.947.947 0 0 0-.725-.288 1.035 1.035 0 0 0-.725.313Z"
        }
      )
    }
  );
}
function wt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7.34 6.41.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49ZM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66Zm15.67-6.26A8.95 8.95 0 0 0 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 0 1 0 9.9 6.973 6.973 0 0 1-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 0 0 0-12.72Z"
        }
      )
    }
  );
}
function st({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.52 6.41 22 12.9l-6.49 6.48-6.49-6.48 6.5-6.49Zm3.65 6.49-3.66-3.66-3.65 3.66 3.66 3.66 3.65-3.66ZM3.5 6.64A8.95 8.95 0 0 1 9.86 4V.76L14.1 5 9.86 9.24V6c-1.79 0-3.58.68-4.95 2.05a7.007 7.007 0 0 0 0 9.9 6.973 6.973 0 0 0 7.79 1.44l1.49 1.49A9.013 9.013 0 0 1 9.86 22c-2.3 0-4.61-.88-6.36-2.64a8.98 8.98 0 0 1 0-12.72Z"
        }
      )
    }
  );
}
function gt({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2ZM7 3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function pt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 19s4.443-.429 6.5-3c2-2.5 1-6 3.5-9.5S20 3 20 3v2c-1 0-4 1-5 3.5s-1 6.583-3.5 9.5C9.357 20.5 4 21 4 21v-2Z"
        }
      )
    }
  );
}
function ft({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.5 11c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 15.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 14 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm-7 0c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 8.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 7 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm3.5 2.5c-1.133 0-2.162.32-3.087.962A5.487 5.487 0 0 0 6.9 17h1.65a4.105 4.105 0 0 1 1.462-1.463A3.852 3.852 0 0 1 12 15c.717 0 1.38.179 1.988.537A4.105 4.105 0 0 1 15.45 17h1.65a5.489 5.489 0 0 0-2.012-2.538A5.299 5.299 0 0 0 12 13.5Zm0 8.5a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function mt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 21v-6h2v2.6l3.1-3.1 1.4 1.4L6.4 19H9v2H3Zm12 0v-2h2.6l-3.1-3.1 1.4-1.4 3.1 3.1V15h2v6h-6ZM8.1 9.5 5 6.4V9H3V3h6v2H6.4l3.1 3.1-1.4 1.4Zm7.8 0-1.4-1.4L17.6 5H15V3h6v6h-2V6.4l-3.1 3.1Z"
        }
      )
    }
  );
}
function Zt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m3.9 21.5-1.4-1.4L5.6 17H3v-2h6v6H7v-2.6l-3.1 3.1Zm16.2 0L17 18.4V21h-2v-6h6v2h-2.6l3.1 3.1-1.4 1.4ZM3 9V7h2.6L2.5 3.9l1.4-1.4L7 5.6V3h2v6H3Zm12 0V3h2v2.6l3.1-3.1 1.4 1.4L18.4 7H21v2h-6Z"
        }
      )
    }
  );
}
function xt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 6h2V4H9v2Zm4 0V4h2v2h-2Zm-4 8v-2h2v2H9Zm8-4V8h2v2h-2Zm0 4v-2h2v2h-2Zm-4 0v-2h2v2h-2Zm4-8V4h2v2h-2Zm-6 2V6h2v2h-2ZM5 20V4h2v2h2v2H7v2h2v2H7v8H5Zm10-8v-2h2v2h-2Zm-4 0v-2h2v2h-2Zm-2-2V8h2v2H9Zm4 0V8h2v2h-2Zm2-2V6h2v2h-2Z"
        }
      )
    }
  );
}
function Ct({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
        }
      )
    }
  );
}
function yt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M21 3 3 10v1l6.923 3.314L13 21h1l7-18Z" })
    }
  );
}
function At({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2 .01 7Z" })
    }
  );
}
function Mt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M5 21c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 19V7h2v12h12v2H5Zm4-4c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 7 15h2v2Zm-2-4v-2h2v2H7Zm0-4V7h2v2H7Zm0-4c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 9 3v2H7Zm4 12v-2h2v2h-2Zm0-12V3h2v2h-2Zm4 12v-2h2v2h-2Zm0-12V3h2v2h-2Zm4 12v-2h2c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 19 17Zm0-4v-2h2v2h-2Zm0-4V7h2v2h-2Zm0-4V3c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413h-2Z"
        }
      )
    }
  );
}
function Ht({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1ZM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2ZM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1ZM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
        }
      )
    }
  );
}
function Vt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm18 0V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22.72 17.57c.03.28.02.57-.01.86l1.06.85c.1.08.12.21.06.32l-1.03 1.79c-.06.11-.19.16-.31.11l-1.28-.5c-.23.16-.48.31-.74.42l-.2 1.36c-.02.12-.13.21-.25.21h-2.07c-.13 0-.23-.09-.25-.21l-.2-1.36c-.27-.11-.52-.25-.75-.42l-1.27.5c-.12.04-.25 0-.31-.11l-1.03-1.79a.248.248 0 0 1 .06-.32l1.07-.85c-.03-.28-.02-.57.01-.86l-1.07-.86a.248.248 0 0 1-.06-.32l1.03-1.79c.06-.11.19-.16.31-.11l1.28.5c.23-.16.48-.31.74-.42l.2-1.36c.02-.12.13-.21.25-.21h2.07c.13 0 .23.09.25.22l.2 1.36c.27.11.52.25.75.42l1.28-.5c.12-.04.25 0 .31.11l1.03 1.79c.06.11.04.24-.06.32l-1.07.85ZM17.5 18c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function Bt({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4Zm12 0v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm18 0V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2ZM13 11V7h-2v4H7v2h4v4h2v-4h4v-2h-4Z"
        }
      )
    }
  );
}
function It({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.5 12c0 .34-.03.66-.07.98l2.11 1.65c.19.15.24.42.12.64l-2 3.46c-.12.22-.38.31-.61.22l-2.49-1c-.52.39-1.08.73-1.69.98l-.38 2.65c-.03.24-.24.42-.49.42h-4c-.25 0-.46-.18-.49-.42l-.38-2.65c-.61-.25-1.17-.58-1.69-.98l-2.49 1c-.22.08-.49 0-.61-.22l-2-3.46a.505.505 0 0 1 .12-.64l2.11-1.65A7.93 7.93 0 0 1 4.5 12c0-.33.03-.66.07-.98L2.46 9.37a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.38-.31.61-.22l2.49 1c.52-.39 1.08-.73 1.69-.98l.38-2.65c.03-.24.24-.42.49-.42h4c.25 0 .46.18.49.42l.38 2.65c.61.25 1.17.58 1.69.98l2.49-1c.22-.08.49 0 .61.22l2 3.46c.12.22.07.49-.12.64l-2.11 1.65c.04.32.07.64.07.98Zm-11 0c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Lt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8 17.95A10.3 10.3 0 0 0 9 18a9.824 9.824 0 0 0 1-.05V20h10V10h-2.05A10.3 10.3 0 0 0 18 9a9.824 9.824 0 0 0-.05-1H20c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v10c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22H10c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 8 20v-2.05ZM9 16c-1.95 0-3.604-.68-4.963-2.037C2.68 12.604 2 10.95 2 9c0-1.95.68-3.604 2.037-4.963C5.396 2.68 7.05 2 9 2c1.95 0 3.604.68 4.963 2.037C15.32 5.396 16 7.05 16 9c0 1.95-.68 3.604-2.037 4.963C12.604 15.32 10.95 16 9 16Zm0-2c1.383 0 2.563-.488 3.537-1.463C13.512 11.563 14 10.383 14 9s-.488-2.563-1.463-3.537C11.563 4.487 10.383 4 9 4s-2.563.487-3.537 1.463C4.487 6.437 4 7.617 4 9s.487 2.563 1.463 3.537C6.437 13.512 7.617 14 9 14Z"
        }
      )
    }
  );
}
function Rt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92Z"
        }
      )
    }
  );
}
function St({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1Z"
        }
      )
    }
  );
}
function Ft({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.04 3.594a1.073 1.073 0 0 1 1.92 0l7.925 15.852a1.074 1.074 0 0 1-.96 1.554H4.075c-.798 0-1.317-.84-.96-1.554L11.04 3.594ZM12 18.852V6.475L5.812 18.852H12Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Tt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-2.317-.583-4.229-1.913-5.737-3.988C4.754 15.937 4 13.633 4 11.1V5l8-3 8 3v6.1c0 2.533-.754 4.837-2.262 6.912C16.229 20.087 14.317 21.417 12 22Zm0-2.1c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.375l-6-2.25-6 2.25V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z"
        }
      )
    }
  );
}
function kt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5ZM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm-3-5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Dt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 6c-4.09 0-7.585 2.488-9 6 1.415 3.512 4.91 6 9 6s7.584-2.488 9-6c-1.416-3.512-4.91-6-9-6Zm0 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })
      ]
    }
  );
}
function Ot({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3Zm18 2H10v12h11V6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 8h7v2h-7V8ZM12 11h7v2h-7v-2ZM12 14h7v2h-7v-2Z" })
      ]
    }
  );
}
function bt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3Zm11 2H3v12h11V6Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M5 8h7v2H5V8ZM5 11h7v2H5v-2ZM5 14h7v2H5v-2Z" })
      ]
    }
  );
}
function Pt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M6.18 20a2.18 2.18 0 1 0 0-4.36 2.18 2.18 0 0 0 0 4.36Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56Zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9Z"
          }
        )
      ]
    }
  );
}
function Ut({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m10.6 16.6 7.05-7.05-1.4-1.4-5.65 5.65-2.85-2.85-1.4 1.4 4.25 4.25ZM12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function Et({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("rect", { width: 18, height: 18, x: 3, y: 3, fill: "currentColor", rx: 2 })
    }
  );
}
function Gt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m17.63 3.692 3.87 5.539L12 21 2.5 9.23l3.805-5.538L12 3l5.63.692Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Wt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 18V6l-8.5 6 8.5 6ZM22 18V6l-8.5 6 8.5 6ZM2 6h2v12H2V6Z"
        }
      )
    }
  );
}
function Nt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M11 6v12l8.5-6L11 6ZM2 6v12l8.5-6L2 6ZM22 18h-2V6h2v12Z" })
    }
  );
}
function jt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.5 12 6 18V6l8.5 6Zm3.5 6h-2V6h2v12Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Xt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6H6v12h2V6Zm10 12-8.5-6L18 6v12Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Kt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#E01E5A",
            d: "M6.795 14.379a1.89 1.89 0 1 1-3.78 0 1.89 1.89 0 0 1 1.89-1.892h1.89v1.892Zm.945 0a1.89 1.89 0 1 1 3.78 0v4.73a1.89 1.89 0 1 1-3.78 0v-4.73Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#36C5F0",
            d: "M9.63 6.783a1.89 1.89 0 0 1-1.89-1.891 1.89 1.89 0 1 1 3.78 0v1.891H9.63Zm0 .96a1.89 1.89 0 0 1 1.89 1.892 1.89 1.89 0 0 1-1.89 1.892H4.89A1.89 1.89 0 0 1 3 9.635a1.89 1.89 0 0 1 1.89-1.891h4.74Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#2EB67D",
            d: "M17.205 9.635a1.89 1.89 0 1 1 3.78 0 1.89 1.89 0 0 1-1.89 1.892h-1.89V9.635Zm-.945 0a1.89 1.89 0 1 1-3.78 0V4.892a1.89 1.89 0 1 1 3.78 0v4.743Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "#ECB22E",
            d: "M14.37 17.216a1.89 1.89 0 0 1 1.89 1.892 1.89 1.89 0 1 1-3.78 0v-1.892h1.89Zm0-.945a1.89 1.89 0 0 1-1.89-1.892 1.89 1.89 0 0 1 1.89-1.892h4.74A1.89 1.89 0 0 1 21 14.38a1.89 1.89 0 0 1-1.89 1.892h-4.74Z"
          }
        )
      ]
    }
  );
}
function Qt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10 8v8l5-4-5-4Zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14Z"
        }
      )
    }
  );
}
function Yt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9Zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5ZM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15Z"
        }
      )
    }
  );
}
function Jt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z"
        }
      )
    }
  );
}
function qt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M20 13H4v-2h16v2Z" })
    }
  );
}
function _t({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 6v2h18V6H3Zm0 12h6v-2H3v2Zm12-5H3v-2h12v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function $t({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 18v-2h18v2H3ZM3 6h6v2H3V6Zm12 5H3v2h12v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function zt({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m10.22 4.66 2.36-2.36 2.36 2.36h-4.72Zm4.69 14.71-2.33 2.33-2.33-2.33h4.66ZM1.6 17.73 6.1 6.27h1.64l4.49 11.46h-1.84l-.92-2.45H4.36l-.92 2.45H1.6Zm3.37-4.09 1.94-5.18 1.94 5.18H4.97Zm16.88 2.5h-6.12l5.93-8.6V6.28h-8.3v1.6h5.88l-5.92 8.56v1.29h8.53v-1.59Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function l7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6Z"
        }
      )
    }
  );
}
function t7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4.27 3 3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4v-1.73L19.73 21 21 19.73 4.27 3ZM14 7h4V3h-6v5.18l2 2V7Z"
        }
      )
    }
  );
}
function e7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.45 15.5c.4.4.917.596 1.55.587.633-.008 1.1-.237 1.4-.687L19 7l-8.4 5.6c-.45.3-.688.758-.713 1.375-.024.617.163 1.125.563 1.525ZM12 4c.983 0 1.93.138 2.838.412A9.213 9.213 0 0 1 17.4 5.65l-1.9 1.2A7.651 7.651 0 0 0 12 6c-2.217 0-4.104.78-5.662 2.338C4.779 9.896 4 11.783 4 14c0 .7.096 1.392.287 2.075.192.683.463 1.325.813 1.925h13.8a7.299 7.299 0 0 0 .838-1.975A8.532 8.532 0 0 0 20 13.9c0-.6-.07-1.183-.212-1.75a7.263 7.263 0 0 0-.638-1.65l1.2-1.9c.5.783.896 1.617 1.188 2.5.291.883.445 1.8.462 2.75a9.773 9.773 0 0 1-.325 2.725 10.349 10.349 0 0 1-1.025 2.475c-.183.3-.433.533-.75.7-.317.167-.65.25-1 .25H5.1c-.35 0-.683-.083-1-.25a1.897 1.897 0 0 1-.75-.7A9.924 9.924 0 0 1 2 14c0-1.383.263-2.68.788-3.887a10.183 10.183 0 0 1 2.15-3.175 10.143 10.143 0 0 1 3.187-2.15A9.676 9.676 0 0 1 12 4Z"
        }
      )
    }
  );
}
function r7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m14.1 22-4.25-4.25 1.4-1.4 2.85 2.85 5.65-5.65 1.4 1.4L14.1 22ZM3 16 7.85 3h2.35l4.85 13h-2.3l-1.15-3.3H6.35L5.2 16H3Zm4.05-5.2h3.9l-1.9-5.4h-.1l-1.9 5.4Z"
        }
      )
    }
  );
}
function i7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 4a1.5 1.5 0 1 1 .03-3C18.096 1.044 23 5.952 23 12a1.5 1.5 0 0 1-3 0 8 8 0 0 0-8-8Z"
        }
      )
    }
  );
}
function n7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18.466 20.9A11 11 0 0 1 12 23a1.5 1.5 0 0 1 0-3v-.003a7.996 7.996 0 0 0 5.826-13.476c-.569-.604-.73-1.535-.243-2.205.488-.671 1.435-.827 2.034-.253A11 11 0 0 1 18.465 20.9Z"
        }
      )
    }
  );
}
function h7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 10.5A1.5 1.5 0 0 1 4 12h.003a7.997 7.997 0 0 0 15.994 0H20a1.5 1.5 0 0 1 3 0 11 11 0 1 1-22 0 1.5 1.5 0 0 1 1.5-1.5Z"
        }
      )
    }
  );
}
function c7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6.94 21.767A11 11 0 0 0 12 23a1.5 1.5 0 0 0 0-3v-.003a7.998 7.998 0 1 1 3.795-15.036c.73.393 1.67.31 2.194-.334.522-.643.429-1.6-.28-2.03A11.001 11.001 0 0 0 3.015 18.345a11 11 0 0 0 3.925 3.422Z"
        }
      )
    }
  );
}
function o7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 5V3h6c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H3v-2h6V5H3ZM15 3h6v2h-6v14h6v2h-6c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M7.95 9.879 5.828 12l2.122 2.121-1.414 1.415L3 12l3.536-3.536L7.95 9.88ZM18.243 12l-2.121 2.121 1.414 1.415L21.07 12l-3.535-3.536L16.12 9.88 18.244 12Z"
          }
        )
      ]
    }
  );
}
function d7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 3v18h18V3H3Zm8 16H5v-6h6v6Zm0-8H5V5h6v6Zm8 8h-6v-6h6v6Zm0-8h-6V5h6v6Z"
        }
      )
    }
  );
}
function v7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 11V5h16v6H4Zm16 8H4v-6h16v6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function a7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27Z"
        }
      )
    }
  );
}
function u7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24ZM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4Z"
        }
      )
    }
  );
}
function w7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24ZM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4Z"
        }
      )
    }
  );
}
function s7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33Z"
        }
      )
    }
  );
}
function g7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 10H6v6h6v-6Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 5v13H4V8h16Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function p7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z" })
    }
  );
}
function f7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" })
    }
  );
}
function m7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })
    }
  );
}
function Z7({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" })
    }
  );
}
function x7({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0 2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function C7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14 2H4a2 2 0 0 0-2 2v10h2V4h10V2Zm4 4H8a2 2 0 0 0-2 2v10h2V8h10V6Zm2 4h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2Z"
        }
      )
    }
  );
}
function y7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M18 18H6V6h12v12Z" })
    }
  );
}
function A7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m15.417 2.192-.096 2.159c-.003.12.137.195.234.12l.842-.637.715.557c.093.062.218 0 .224-.113l-.08-2.195 1.06-.08a.957.957 0 0 1 1.02.954v17.197a.955.955 0 0 1-1.005.955l-12.818-.572a.956.956 0 0 1-.914-.924L4.002 3.85A.953.953 0 0 1 4.9 2.839l10.508-.662.01.015Zm-2.444 7.215c0 .373 2.516.19 2.858-.065 0-2.548-1.368-3.894-3.868-3.894-2.507 0-3.9 1.371-3.9 3.418 0 3.542 4.777 3.604 4.777 5.538 0 .56-.255.877-.837.877-.765 0-1.076-.389-1.035-1.72 0-.285-2.905-.382-3.001 0-.214 3.21 1.776 4.14 4.058 4.14 2.224 0 3.959-1.185 3.959-3.328 0-3.797-4.857-3.695-4.857-5.572 0-.772.575-.875.898-.875.36 0 .995.057.949 1.487v-.006Z"
        }
      )
    }
  );
}
function M7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#FF4785",
          d: "m15.417 2.192-.096 2.159c-.003.12.137.195.234.12l.842-.637.715.557c.093.062.218 0 .224-.113l-.08-2.195 1.06-.08a.957.957 0 0 1 1.02.954v17.197a.955.955 0 0 1-1.005.955l-12.818-.572a.956.956 0 0 1-.914-.924L4.002 3.85A.953.953 0 0 1 4.9 2.839l10.508-.662.01.015Zm-2.444 7.215c0 .373 2.516.19 2.858-.065 0-2.548-1.368-3.894-3.868-3.894-2.507 0-3.9 1.371-3.9 3.418 0 3.542 4.777 3.604 4.777 5.538 0 .56-.255.877-.837.877-.765 0-1.076-.389-1.035-1.72 0-.285-2.905-.382-3.001 0-.214 3.21 1.776 4.14 4.058 4.14 2.224 0 3.959-1.185 3.959-3.328 0-3.797-4.857-3.695-4.857-5.572 0-.772.575-.875.898-.875.36 0 .995.057.949 1.487v-.006Z"
        }
      )
    }
  );
}
function H7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M19 3H5c-1.1 0-2 .9-2 2v4h2V5h14v4h2V5c0-1.1-.9-2-2-2ZM1 11v2h22v-2H1Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M5 3h14c1.1 0 2 .9 2 2v4h-2V5H5v4H3V5c0-1.1.9-2 2-2ZM19 21H5c-1.1 0-2-.9-2-2v-4h2v4h14v-4h2v4c0 1.1-.9 2-2 2Z"
          }
        )
      ]
    }
  );
}
function V7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.85 7.08c0 .64.13 1.19.39 1.67.032.063.076.132.117.198L7.39 9H12c-.64-.22-1.03-.45-1.41-.7-.49-.33-.74-.73-.74-1.21 0-.23.05-.45.15-.66.1-.21.25-.39.44-.55.19-.15.43-.27.72-.36.29-.09.64-.13 1.03-.13.4 0 .76.06 1.06.16.3.11.55.25.75.44.2.19.35.41.44.68.1.26.15.54.15.85h3.01c0-.66-.13-1.26-.38-1.81s-.61-1.03-1.08-1.43a4.94 4.94 0 0 0-1.69-.94c-.67-.23-1.4-.34-2.21-.34-.79 0-1.52.1-2.18.29-.65.2-1.22.48-1.7.83-.48.36-.85.79-1.11 1.29-.27.51-.4 1.06-.4 1.67ZM21 10v2.02h-3.87c.06.1.12.22.17.33.21.47.31 1.01.31 1.61 0 .64-.13 1.21-.38 1.71s-.61.93-1.07 1.27c-.46.34-1.02.6-1.67.79-.65.19-1.38.28-2.18.28-.48 0-.96-.05-1.44-.13-.48-.09-.94-.22-1.38-.39a5.69 5.69 0 0 1-1.22-.65c-.38-.26-.7-.57-.98-.92-.28-.36-.49-.76-.65-1.21-.16-.45-.24-1.03-.24-1.58h2.97c0 .45.11.9.25 1.21.14.31.34.56.59.75.25.19.56.33.91.42.35.09.75.13 1.18.13.38 0 .72-.05 1.01-.13.29-.09.52-.2.71-.35.19-.15.33-.33.42-.53.09-.21.14-.43.14-.66 0-.26-.04-.49-.11-.69-.08-.21-.22-.4-.43-.57-.21-.17-.5-.34-.87-.51a7.225 7.225 0 0 0-.269-.098c-.095-.033-.193-.068-.281-.102H3v-2h18Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function B7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6Z"
        }
      )
    }
  );
}
function I7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 6 4 18h2l1.356-3h5.288L14 18h2L11 6H9Zm-1.013 7 2.008-5 2.007 5H7.987ZM22 19v1h-5v-1l2.432-1.902c.218-.185.391-.355.519-.51.133-.16.228-.306.287-.436a.783.783 0 0 0 .095-.33.676.676 0 0 0-.223-.524c-.149-.14-.364-.21-.646-.21-.34 0-.595.09-.765.27a.905.905 0 0 0-.248.645H17c0-.366.096-.7.287-1.005.197-.305.473-.548.83-.728.36-.18.792-.27 1.291-.27.505 0 .933.072 1.284.217.356.146.628.353.814.623.191.27.287.595.287.975 0 .275-.064.53-.192.765-.127.23-.313.46-.558.69-.24.23-.537.483-.893.758L19.026 19H22Z"
        }
      )
    }
  );
}
function L7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 12h2v-2H6v2Zm0 4h8v-2H6v2Zm10 0h2v-2h-2v2Zm-6-4h8v-2h-8v2Zm-6 8c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 2 18V6c0-.55.196-1.02.588-1.412A1.923 1.923 0 0 1 4 4h16c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 20 20H4Zm0-2h16V6H4v12Z"
        }
      )
    }
  );
}
function R7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M4 18 9 6h2l5 12h-2l-1.356-3H7.356L6 18H4ZM9.995 8l-2.008 5h4.015L9.995 8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M20 12v-1h-2.974l1.124-.973c.356-.274.654-.527.893-.757.245-.23.43-.46.558-.69.128-.235.192-.49.192-.765 0-.38-.096-.705-.287-.975-.186-.27-.458-.478-.814-.622-.35-.146-.779-.218-1.284-.218-.5 0-.93.09-1.292.27-.356.18-.632.423-.829.728-.191.304-.287.64-.287 1.004h1.451c0-.255.083-.47.248-.645.17-.18.425-.27.765-.27.282 0 .497.07.646.21.149.136.223.31.223.526 0 .09-.032.2-.095.33-.059.13-.154.274-.287.434-.128.155-.3.325-.519.51L15 11v1h5Z"
          }
        )
      ]
    }
  );
}
function S7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.5 11c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 15.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 14 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm-7 0c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 8.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 7 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm3.5 2.5c-1.133 0-2.162.32-3.087.962A5.487 5.487 0 0 0 6.9 17h10.2a5.489 5.489 0 0 0-2.012-2.538A5.299 5.299 0 0 0 12 13.5Zm0 8.5a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function F7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm2 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm10 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm8 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm2 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm10 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function T7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        }
      )
    }
  );
}
function k7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function D7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("rect", { width: 2, height: 10, x: 11, y: 7, fill: "currentColor", rx: 1 })
    }
  );
}
function O7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8Zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3Z"
        }
      )
    }
  );
}
function b7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33Zm-7.14-.94 2.36 2.36a7.925 7.925 0 0 0 1.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 0 1 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41ZM20 4h-6v6l2.24-2.24A6.003 6.003 0 0 1 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 0 0-1.14-9.87L20 4Z"
        }
      )
    }
  );
}
function P7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 20v-2h2.75l-.4-.35c-.867-.767-1.475-1.642-1.825-2.625A8.816 8.816 0 0 1 3 12.05c0-1.85.554-3.496 1.662-4.938C5.771 5.671 7.217 4.717 9 4.25v2.1a5.928 5.928 0 0 0-2.9 2.213A5.918 5.918 0 0 0 5 12.05c0 .75.142 1.48.425 2.188.283.708.725 1.362 1.325 1.962l.25.25V14h2v6H3Zm17.925-9H18.9a5.252 5.252 0 0 0-.537-1.675A6.473 6.473 0 0 0 17.25 7.8L17 7.55V10h-2V4h6v2h-2.75l.4.35c.683.7 1.208 1.442 1.575 2.225.367.783.6 1.592.7 2.425ZM17 23l-.3-1.5c-.2-.083-.387-.17-.563-.262a4.358 4.358 0 0 1-.537-.338l-1.45.45-1-1.7 1.15-1a4.62 4.62 0 0 1-.05-.65c0-.2.017-.417.05-.65l-1.15-1 1-1.7 1.45.45c.183-.133.363-.246.537-.338.175-.091.363-.179.563-.262L17 13h2l.3 1.5c.2.083.387.175.563.275.175.1.354.225.537.375l1.45-.5 1 1.75-1.15 1c.033.2.05.408.05.625a3.8 3.8 0 0 1-.05.625l1.15 1-1 1.7-1.45-.45a4.358 4.358 0 0 1-.537.338c-.175.091-.363.179-.563.262L19 23h-2Zm1-3c.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413s-.196-1.02-.587-1.413A1.926 1.926 0 0 0 18 16c-.55 0-1.02.196-1.413.587A1.926 1.926 0 0 0 16 18c0 .55.196 1.02.587 1.413.392.391.863.587 1.413.587Z"
        }
      )
    }
  );
}
function U7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 9h2V7H3v2Zm2 4H3v-2h2v2Zm0 4H3v-2h2v2Zm16-4H7v-2h14v2ZM7 17h14v-2H7v2Zm0-8V7h14v2H7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function E7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m12.41 2.58 9 9c.36.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59-.55 0-1.05-.22-1.41-.58l-9-9C2.22 12.05 2 11.55 2 11V4c0-1.1.9-2 2-2h7c.55 0 1.05.22 1.41.58ZM4 5.5C4 6.33 4.67 7 5.5 7S7 6.33 7 5.5 6.33 4 5.5 4 4 4.67 4 5.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function G7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2h1v8.275c.3.183.542.42.725.712.183.292.275.63.275 1.013 0 .55-.196 1.02-.587 1.412A1.927 1.927 0 0 1 12 14c-.55 0-1.02-.196-1.412-.588A1.923 1.923 0 0 1 10 12c0-.383.092-.725.275-1.025.183-.3.425-.533.725-.7v-2.15a4.033 4.033 0 0 0-2.15 1.412C8.283 10.246 8 11.067 8 12c0 1.1.392 2.042 1.175 2.825C9.958 15.608 10.9 16 12 16s2.042-.392 2.825-1.175C15.608 14.042 16 13.1 16 12c0-.6-.121-1.154-.363-1.663A4.319 4.319 0 0 0 14.65 9l1.425-1.425a6.29 6.29 0 0 1 1.4 1.962c.35.759.525 1.58.525 2.463 0 1.667-.583 3.083-1.75 4.25C15.083 17.417 13.667 18 12 18c-1.667 0-3.083-.583-4.25-1.75C6.583 15.083 6 13.667 6 12c0-1.5.475-2.804 1.425-3.912.95-1.109 2.142-1.78 3.575-2.013V4.05c-1.983.25-3.646 1.125-4.987 2.625C4.671 8.175 4 9.95 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-1.15-.225-2.225-.675-3.225a8.044 8.044 0 0 0-1.85-2.6L18.9 4.75c.95.917 1.704 1.996 2.263 3.237.558 1.242.837 2.58.837 4.013a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Z"
        }
      )
    }
  );
}
function W7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7Z"
        }
      )
    }
  );
}
function N7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15 21v-3h-4V8H9v3H2V3h7v3h6V3h7v8h-7V8h-2v8h2v-3h7v8h-7Zm2-12h3V5h-3v4Zm0 10h3v-4h-3v4ZM4 9h3V5H4v4Z"
        }
      )
    }
  );
}
function j7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M14 17H4v2h10v-2Zm6-8H4v2h16V9ZM4 15h16v-2H4v2ZM4 5v2h16V5H4Z"
        }
      )
    }
  );
}
function X7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "m9.987 13 2.008-5 2.007 5H9.987Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM11 6 6 18h2l1.356-3h5.288L16 18h2L13 6h-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function K7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5V3h18v2H3Zm4 2v2h10V7H7Zm14 6H3v-2h18v2ZM7 15v2h10v-2H7Zm-4 6h18v-2H3v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Q7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 3 5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2ZM0 24v-4h24v4H0ZM12 5.67 9.62 12h4.76L12 5.67Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Y7({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.9 17 15 6h2l4.1 11h-1.9l-1-2.8h-4.4l-1 2.8h-1.9Zm3.45-4.4h3.3l-1.6-4.55h-.1l-1.6 4.55ZM6 3 2.5 6.5l1.4 1.4L5 6.85V20h2V6.85L8.1 7.9l1.4-1.4L6 3Z"
        }
      )
    }
  );
}
function J7({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.9 17 15 6h2l4.1 11h-1.9l-1-2.8h-4.4l-1 2.8h-1.9Zm3.45-4.4h3.3l-1.6-4.55h-.1l-1.6 4.55ZM6 21l-3.5-3.5 1.4-1.4L5 17.15V4h2v13.15l1.1-1.05 1.4 1.4L6 21Z"
        }
      )
    }
  );
}
function q7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M3 18h12v-2H3v2ZM3 6v2h18V6H3Zm0 7h18v-2H3v2Z" })
    }
  );
}
function _7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M20 6v3h2V6c0-.55-.196-1.02-.587-1.412A1.927 1.927 0 0 0 20 4h-3v2h3ZM2 6v3h2V6h3V4H4c-.55 0-1.02.196-1.412.588A1.923 1.923 0 0 0 2 6ZM17 18v2h3c.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413v-3h-2v3h-3ZM2.588 19.413C2.979 19.804 3.45 20 4 20h3v-2H4v-3H2v3c0 .55.196 1.021.588 1.413Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11.238 7 8 16h1.524l.762-2.3h3.476l.762 2.3H16l-3.238-9h-1.524Zm2.048 5.4h-2.572l1.238-3.75h.096l1.238 3.75Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function $7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5V3h18v2H3Zm0 4h18V7H3v2Zm18 4H3v-2h18v2ZM3 17h18v-2H3v2Zm0 4h18v-2H3v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function z7({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5V3h18v2H3Zm12 2H3v2h12V7Zm0 8H3v2h12v-2Zm6-2H3v-2h18v2ZM3 21h18v-2H3v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function le({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M2.5 7V4h13v3h-5v8.21a7.983 7.983 0 0 0-.438 3.79H7.5V7h-5Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M18 10c1.255 0 2.443.29 3.5.804V9h-9v3h.208A7.97 7.97 0 0 1 18 10Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.375 12.603a6 6 0 1 1 5.25 10.794 6 6 0 0 1-5.25-10.794ZM22 18a4 4 0 0 1-4.72 3.935A5.977 5.977 0 0 0 18.75 18a5.977 5.977 0 0 0-1.47-3.935A4 4 0 0 1 22 18Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function te({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.667 4h4.666L21 20h-6.29l-1.357-3h-2.706L9.29 20H3L9.667 4Zm4.977 11L16 18h2L13 6h-2L6 18h2l1.356-3h5.288Zm-.642-2H9.987l2.008-5 2.007 5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ee({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M4 5v2h5V5H4ZM4 19v-2h5v2H4ZM4 11v2h13.2l-1.05 1.05 1.4 1.4L21 12l-3.45-3.45-1.4 1.4L17.2 11H4Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M11 22h2V2h-2v20Z" })
      ]
    }
  );
}
function re({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20v-4h2v4h4v2H4ZM2 8V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h4v2H4v4H2Zm14 14v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22h-4Zm4-14V4h-4V2h4c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v4h-2ZM6 17h8v-2H6v2ZM6 7v2h12V7H6Zm0 6h12v-2H6v2Z"
        }
      )
    }
  );
}
function ie({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5V3h18v2H3Zm6 4h12V7H9v2Zm12 4H3v-2h18v2ZM9 17h12v-2H9v2Zm-6 4h18v-2H3v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ne({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5Zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 16H7V3h14v14Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M18.5 5h-9v3h3v7h3V8h3V5Z" })
      ]
    }
  );
}
function he({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M10.984 9.123 8.97 4H7.11L2 17h2.09l1.12-3h3.83a8.58 8.58 0 0 1 .486-2H5.97l2.07-5.52 1.79 4.773c.346-.777.764-1.51 1.154-2.13ZM14.472 7.71 16 5.9l1.528 1.808.005.007.01.01.031.039.11.134a24.743 24.743 0 0 1 1.496 2.063c.407.63.843 1.376 1.182 2.146.324.738.638 1.667.638 2.62C21 17.464 18.915 20 16 20s-5-2.535-5-5.273c0-.952.314-1.881.638-2.619.34-.77.775-1.516 1.183-2.147a24.743 24.743 0 0 1 1.605-2.196l.031-.038.01-.011.005-.007Z"
        }
      )
    }
  );
}
function ce({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M10.984 9.123 8.97 4H7.11L2 17h2.09l1.12-3h3.83a8.58 8.58 0 0 1 .486-2H5.97l2.07-5.52 1.79 4.773c.346-.777.764-1.51 1.154-2.13Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M17.528 7.71 16 9l-1.528-1.29L16 5.9l1.528 1.808Zm-.29 2.942A22.048 22.048 0 0 0 16 9l1.528-1.29.005.006.01.01.031.039.11.134a24.743 24.743 0 0 1 1.496 2.063c.407.63.843 1.376 1.182 2.146.324.738.638 1.667.638 2.62C21 17.464 18.915 20 16 20s-5-2.535-5-5.273c0-.952.314-1.881.638-2.619.34-.77.775-1.516 1.183-2.147a24.743 24.743 0 0 1 1.605-2.196l.031-.038.01-.011.005-.007L16 9s-.585.692-1.238 1.652C13.936 11.867 13 13.512 13 14.727c0 1.8 1.35 3.273 3 3.273s3-1.473 3-3.273c0-1.216-.936-2.86-1.762-4.075Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function oe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M6 3h11v13l-7 7-1.25-1.25a1.308 1.308 0 0 1-.287-.475 1.63 1.63 0 0 1-.113-.575v-.35L9.45 16H3c-.533 0-1-.2-1.4-.6-.4-.4-.6-.867-.6-1.4v-2c0-.117.017-.242.05-.375s.067-.258.1-.375l3-7.05c.15-.333.4-.617.75-.85C5.25 3.117 5.617 3 6 3Zm9 2H6l-3 7v2h9l-1.35 5.5L15 15.15V5Zm2 11v-2h3V5h-3V3h5v13h-5Z"
        }
      )
    }
  );
}
function de({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 21H7V8l7-7 1.25 1.25c.117.117.213.275.287.475.075.2.113.392.113.575v.35L14.55 8H21c.533 0 1 .2 1.4.6.4.4.6.867.6 1.4v2c0 .117-.017.242-.05.375s-.067.258-.1.375l-3 7.05c-.15.333-.4.617-.75.85-.35.233-.717.35-1.1.35Zm-9-2h9l3-7v-2h-9l1.35-5.5L9 8.85V19ZM7 8v2H4v9h3v2H2V8h5Z"
        }
      )
    }
  );
}
function ve({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19.987 7.313a4.352 4.352 0 0 1-3.24-1.403A4.165 4.165 0 0 1 15.62 3.4V3h-3.161v12.309c0 1.43-1.193 2.6-2.662 2.6-.866 0-1.627-.398-2.112-1.03v-.012a2.536 2.536 0 0 1-.537-1.57c0-1.443 1.193-2.602 2.662-2.602.275 0 .55.039.8.116V9.67a5.489 5.489 0 0 0-.918-.052C6.532 9.682 4 12.206 4 15.309c0 1.545.63 2.961 1.652 3.979A5.834 5.834 0 0 0 9.81 21c3.213 0 5.81-2.55 5.81-5.691V9.026A7.612 7.612 0 0 0 20 10.403v-3.09h-.013Z"
        }
      )
    }
  );
}
function ae({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19.987 7.313a4.352 4.352 0 0 1-3.24-1.403A4.165 4.165 0 0 1 15.62 3.4V3h-3.161v12.309c0 1.43-1.193 2.6-2.662 2.6-.866 0-1.627-.398-2.112-1.03v-.012a2.536 2.536 0 0 1-.537-1.57c0-1.443 1.193-2.602 2.662-2.602.275 0 .55.039.8.116V9.67a5.489 5.489 0 0 0-.918-.052C6.532 9.682 4 12.206 4 15.309c0 1.545.63 2.961 1.652 3.979A5.834 5.834 0 0 0 9.81 21c3.213 0 5.81-2.55 5.81-5.691V9.026A7.612 7.612 0 0 0 20 10.403v-3.09h-.013Z"
        }
      )
    }
  );
}
function ue({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#0E1318",
          d: "M19.987 7.313a4.352 4.352 0 0 1-3.24-1.403A4.165 4.165 0 0 1 15.62 3.4V3h-3.161v12.309c0 1.43-1.193 2.6-2.662 2.6-.866 0-1.627-.398-2.112-1.03v-.012a2.536 2.536 0 0 1-.537-1.57c0-1.443 1.193-2.602 2.662-2.602.275 0 .55.039.8.116V9.67a5.489 5.489 0 0 0-.918-.052C6.532 9.682 4 12.206 4 15.309c0 1.545.63 2.961 1.652 3.979A5.834 5.834 0 0 0 9.81 21c3.213 0 5.81-2.55 5.81-5.691V9.026A7.612 7.612 0 0 0 20 10.403v-3.09h-.013Z"
        }
      )
    }
  );
}
function we({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M11 7h1.5v5.25l4.5 2.67-.75 1.23L11 13V7Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm2 0c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8-8 3.58-8 8Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function se({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15 7H3v2h12V7Zm6 8H9v2h12v-2Zm0-2H3v-2h18v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ge({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 22c-1.25 0-2.42-.238-3.513-.712a9.149 9.149 0 0 1-2.85-1.925 9.147 9.147 0 0 1-1.925-2.85A8.707 8.707 0 0 1 3 13c0-1.25.237-2.42.712-3.512a9.148 9.148 0 0 1 1.925-2.85 9.148 9.148 0 0 1 2.85-1.925A8.707 8.707 0 0 1 12 4c1.25 0 2.42.237 3.512.713a9.15 9.15 0 0 1 2.85 1.925 9.149 9.149 0 0 1 1.926 2.85A8.707 8.707 0 0 1 21 13c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.15 9.15 0 0 1-2.85 1.926A8.707 8.707 0 0 1 12 22Zm2.8-4.8 1.4-1.4-3.2-3.2V8h-2v5.4l3.8 3.8ZM5.6 2.35 7 3.75 2.75 8l-1.4-1.4L5.6 2.35Zm12.8 0 4.25 4.25-1.4 1.4L17 3.75l1.4-1.4ZM12 20c1.95 0 3.604-.68 4.962-2.038C18.322 16.604 19 14.95 19 13c0-1.95-.68-3.604-2.038-4.963C15.604 6.68 13.95 6 12 6c-1.95 0-3.604.68-4.963 2.037C5.68 9.396 5 11.05 5 13c0 1.95.68 3.604 2.037 4.962C8.396 19.322 10.05 20 12 20Z"
        }
      )
    }
  );
}
function pe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 0 0-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6Zm10-.28-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72ZM2.92 2.29 1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8A8.964 8.964 0 0 0 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98Zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86ZM8.02 3.28 6.6 1.86l-.86.71 1.42 1.42.86-.71Z"
        }
      )
    }
  );
}
function fe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M5 4v3h5.5v12h3V7H19V4H5Z" })
    }
  );
}
function me({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 18 7 6h2l5 12h-2l-1.356-3H5.356L4 18H2ZM7.995 8l-2.008 5h4.015L7.995 8ZM19.636 17.166a2.95 2.95 0 0 1-1.108.78c-.334.14-.72.21-1.157.21-.552 0-1.044-.11-1.476-.328a2.625 2.625 0 0 1-1.016-.898 2.33 2.33 0 0 1-.367-1.29c0-.447.083-.843.25-1.187.172-.349.422-.64.75-.875.333-.234.74-.411 1.219-.531a6.52 6.52 0 0 1 1.64-.188h1.203v-.586c0-.302-.054-.562-.164-.78a1.148 1.148 0 0 0-.5-.509c-.218-.12-.494-.18-.828-.18-.307 0-.573.053-.797.157a1.289 1.289 0 0 0-.523.422 1.018 1.018 0 0 0-.188.601H14.7c0-.333.081-.656.243-.968.161-.313.395-.591.703-.836a3.512 3.512 0 0 1 1.101-.578c.427-.141.907-.211 1.438-.211.635 0 1.198.106 1.687.32.495.213.883.536 1.164.969.287.427.43.963.43 1.61v3.757c0 .385.026.732.078 1.039.057.302.138.565.242.789V18h-1.93a3.337 3.337 0 0 1-.219-.834Zm-.062-1.552a1.826 1.826 0 0 1-.14.23c-.167.229-.396.424-.688.586a2.073 2.073 0 0 1-1.008.234c-.286 0-.53-.052-.734-.156a1.095 1.095 0 0 1-.453-.43 1.25 1.25 0 0 1-.156-.617c0-.224.044-.425.133-.602.088-.177.22-.328.398-.453.177-.125.398-.219.664-.281.266-.068.573-.102.922-.102h1.062v1.59Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Ze({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M18 16a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 5v13H4V8h16Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function xe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18ZM3 18h18V9H3v9Zm16-2H5v-2h14v2ZM5 13h14v-2H5v2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Ce({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4ZM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2Z"
        }
      )
    }
  );
}
function ye({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m11.9 22 4.55-12h2.1l4.55 12H21l-1.05-3.05H15.1L14 22h-2.1Zm3.8-4.8h3.6l-1.75-4.95h-.1L15.7 17.2ZM4 19l-1.4-1.4 5.05-5.05a16.024 16.024 0 0 1-1.663-2.175A16.034 16.034 0 0 1 4.75 8h2.1c.3.6.62 1.142.963 1.625.341.483.754.992 1.237 1.525.733-.8 1.342-1.62 1.825-2.463A16.06 16.06 0 0 0 12.1 6H1V4h7V2h2v2h7v2h-2.9a18.153 18.153 0 0 1-1.425 3.45 16.134 16.134 0 0 1-2.225 3.15l2.4 2.45-.75 2.05L9 14l-5 5Z"
        }
      )
    }
  );
}
function Ae({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6Z"
        }
      )
    }
  );
}
function Me({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 7.77 18.39 18H5.61L12 7.77ZM12 4 2 20h20L12 4Z" })
    }
  );
}
function He({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.25 10.24V6.5a2.5 2.5 0 0 1 5 0v3.74c1.21-.81 2-2.18 2-3.74 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5c0 1.56.79 2.93 2 3.74Zm9.84 4.63-4.54-2.26c-.17-.07-.35-.11-.54-.11h-.76v-6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v10.74c-3.6-.76-3.54-.75-3.67-.75-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38Z"
        }
      )
    }
  );
}
function Ve({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0 0 11 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 0 0 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2ZM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8Zm7 6c-1.65 0-3-1.35-3-3V5h6v6c0 1.65-1.35 3-3 3Zm7-6c0 1.3-.84 2.4-2 2.82V7h2v1Z"
        }
      )
    }
  );
}
function Be({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.66 19.626c6.793 0 10.508-5.628 10.508-10.508 0-.16 0-.319-.01-.477A7.513 7.513 0 0 0 21 6.729a7.372 7.372 0 0 1-2.121.581 3.706 3.706 0 0 0 1.623-2.042 7.4 7.4 0 0 1-2.345.896 3.696 3.696 0 0 0-6.293 3.368 10.485 10.485 0 0 1-7.611-3.858 3.696 3.696 0 0 0 1.143 4.93 3.665 3.665 0 0 1-1.676-.463v.047a3.695 3.695 0 0 0 2.963 3.62 3.687 3.687 0 0 1-1.668.064 3.697 3.697 0 0 0 3.45 2.564A7.41 7.41 0 0 1 3 17.967a10.456 10.456 0 0 0 5.66 1.656"
        }
      )
    }
  );
}
function Ie({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.66 19.626c6.793 0 10.508-5.628 10.508-10.508 0-.16 0-.319-.01-.477A7.513 7.513 0 0 0 21 6.729a7.372 7.372 0 0 1-2.121.581 3.706 3.706 0 0 0 1.623-2.042 7.4 7.4 0 0 1-2.345.896 3.696 3.696 0 0 0-6.293 3.368 10.485 10.485 0 0 1-7.611-3.858 3.696 3.696 0 0 0 1.143 4.93 3.665 3.665 0 0 1-1.676-.463v.047a3.695 3.695 0 0 0 2.963 3.62 3.687 3.687 0 0 1-1.668.064 3.697 3.697 0 0 0 3.45 2.564A7.41 7.41 0 0 1 3 17.967a10.456 10.456 0 0 0 5.66 1.656"
        }
      )
    }
  );
}
function Le({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#1DA1F2",
          d: "M8.66 19.626c6.793 0 10.508-5.628 10.508-10.508 0-.16 0-.319-.01-.477A7.513 7.513 0 0 0 21 6.729a7.372 7.372 0 0 1-2.121.581 3.706 3.706 0 0 0 1.623-2.042 7.4 7.4 0 0 1-2.345.896 3.696 3.696 0 0 0-6.293 3.368 10.485 10.485 0 0 1-7.611-3.858 3.696 3.696 0 0 0 1.143 4.93 3.665 3.665 0 0 1-1.676-.463v.047a3.695 3.695 0 0 0 2.963 3.62 3.687 3.687 0 0 1-1.668.064 3.697 3.697 0 0 0 3.45 2.564A7.41 7.41 0 0 1 3 17.967a10.456 10.456 0 0 0 5.66 1.656"
        }
      )
    }
  );
}
function Re({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6 0h12c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2Zm0 22h12V2H6v20Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M14 15h2v5h-5v-2h3v-3ZM13 6h-3v3H8V4h5v2Z" })
      ]
    }
  );
}
function Se({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 4h20c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Zm0 14h20V6H2v12Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M18 11h2v5h-5v-2h3v-3ZM9 10H6v3H4V8h5v2Z" })
      ]
    }
  );
}
function Fe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M15.5 11c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 15.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 14 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm-7 0c.417 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 8.5 8c-.417 0-.77.146-1.062.438A1.444 1.444 0 0 0 7 9.5c0 .417.146.77.438 1.062.291.292.645.438 1.062.438Zm.5 4.5h6V14H9v1.5Zm3 6.5a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        }
      )
    }
  );
}
function Te({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m20.55 5.22-1.39-1.68A1.51 1.51 0 0 0 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28ZM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5ZM5.12 5l.82-1h12l.93 1H5.12Z"
        }
      )
    }
  );
}
function ke({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6V3h2.5v8c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5V3H18v8ZM5 21v-2h14v2H5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function De({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8Z"
        }
      )
    }
  );
}
function Oe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M14.192 4.96A5 5 0 0 0 20 12.27v3.73h-7l-.4-2H7v7H5V4h9l.192.96Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18.5 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm2 3h-4v1h4V7Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function be({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6h8c1.11 0 2 .89 2 2v10c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-12c0-1.11.88-2 1.99-2h6l2 2Zm7 6h-8v2h8v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Pe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4Zm6 9-4 5h12l-3-4-2.03 2.71L10 13Zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5ZM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2Zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7ZM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7Z"
        }
      )
    }
  );
}
function Ue({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.11 7.38 2 4.27l1.41-1.41L20.15 19.6l-1.41 1.41L14.73 17H13v-1.73L10.73 13H8v-2h.73L6.66 8.93A3.097 3.097 0 0 0 3.9 12c0 1.71 1.39 3.1 3.1 3.1h4V17H7c-2.76 0-5-2.24-5-5 0-2.09 1.29-3.88 3.11-4.62ZM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4A4.986 4.986 0 0 0 22 12c0-2.76-2.24-5-5-5Zm-2.61 4L16 12.61V11h-1.61Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Ee({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5ZM10 15H6c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H6c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2Z"
        }
      )
    }
  );
}
function Ge({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m16 12 2 2v2h-5v6l-1 1-1-1v-6H6v-2l2-2V5H7V3h10v2h-1v7Zm-7.15 2h6.3L14 12.85V5h-4v7.85L8.85 14Z"
        }
      )
    }
  );
}
function We({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19.8 22.6 17.15 20H6.5c-1.533 0-2.833-.533-3.9-1.6C1.533 17.333 1 16.033 1 14.5c0-1.283.396-2.425 1.188-3.425A5.287 5.287 0 0 1 5.25 9.15c.05-.133.1-.263.15-.388.05-.125.1-.262.15-.412L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4ZM6.5 18h8.65L7.1 9.95a6.627 6.627 0 0 0-.075.525A5.28 5.28 0 0 0 7 11h-.5c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 3 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0 0 6.5 18Zm15.1.75-1.45-1.4c.283-.233.496-.504.638-.813.141-.308.212-.654.212-1.037 0-.7-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-1.383-.488-2.563-1.463-3.538C14.563 6.487 13.383 6 12 6c-.45 0-.883.054-1.3.162-.417.109-.817.28-1.2.513l-1.45-1.45a7.029 7.029 0 0 1 1.862-.913A6.878 6.878 0 0 1 12 4c1.95 0 3.604.68 4.962 2.037C18.322 7.396 19 9.05 19 11c1.15.133 2.104.63 2.863 1.488A4.407 4.407 0 0 1 23 15.5a4.384 4.384 0 0 1-1.4 3.25Z"
        }
      )
    }
  );
}
function Ne({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2ZM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5-5 5Z"
        }
      )
    }
  );
}
function je({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M0 18 5 6h2l5 12h-2l-1.356-3H3.356L2 18H0ZM5.995 8l-2.008 5h4.015L5.995 8ZM12 18h2l1.356-3h5.288L22 18h2L19 6h-2l-5 12Zm5.995-10-2.008 5h4.015l-2.007-5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Xe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 21H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19v-8h10v10Zm-9-2h8l-2.6-3.5L7.5 18l-1.4-1.85L4 19ZM5 5H3c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3v2Zm2 0V3h2v2H7Zm4 0V3h2v2h-2Zm4 0V3h2v2h-2Zm0 16v-2h2v2h-2Zm4-16V3c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5h-2ZM3 9V7h2v2H3Zm16 10h2c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21v-2Zm0-2v-2h2v2h-2Zm0-4v-2h2v2h-2Zm0-4V7h2v2h-2Z"
        }
      )
    }
  );
}
function Ke({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4ZM4 18c0-2.66 5.33-4 8-4s8 1.34 8 4v2H4v-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Qe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.99 8c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3s1.34-3 3-3 2.99 1.34 2.99 3Zm8 0c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3s1.34-3 3-3 2.99 1.34 2.99 3ZM8 13c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5Zm7.03.05c.35-.03.68-.05.97-.05 2.33 0 7 1.17 7 3.5V19h-6v-2.5c0-1.48-.81-2.61-1.97-3.45Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Ye({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25Zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25Zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25ZM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12Zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5Zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Z"
        }
      )
    }
  );
}
function Je({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19.775 22.625 17.15 20H4v-2.8c0-.567.146-1.087.438-1.563.291-.475.679-.837 1.162-1.087.75-.383 1.513-.692 2.288-.925a16.395 16.395 0 0 1 2.362-.525L1.375 4.225 2.8 2.8l18.4 18.4-1.425 1.425ZM18.4 14.55c.483.233.867.587 1.15 1.063.283.474.433.987.45 1.537l-3.35-3.35c.3.117.596.233.888.35.291.117.579.25.862.4Zm-4.2-3.2L8.65 5.8a4.085 4.085 0 0 1 1.45-1.325A3.92 3.92 0 0 1 12 4c1.1 0 2.042.392 2.825 1.175C15.608 5.958 16 6.9 16 8c0 .683-.158 1.317-.475 1.9a4.085 4.085 0 0 1-1.325 1.45Z"
        }
      )
    }
  );
}
function qe({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2ZM3 3h2v2H3V3Zm2 18H3v-2h2v2Zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2Zm4 2h-2v-2h2v2ZM19 5V3h2v2h-2Zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2Zm-3.04-1.26h2.61L12 8.91l-1.31 3.83Z"
        }
      )
    }
  );
}
function _e({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16 23H8l-5-7 9-16 9 16-5 7Zm-6.97-2-3.663-5.128L11 5.857v5.314a3.001 3.001 0 1 0 2 0V5.857l5.633 10.015L14.971 21H9.029ZM13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function $e({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m8.6 22.5-1.9-3.2-3.6-.8.35-3.7L1 12l2.45-2.8-.35-3.7 3.6-.8 1.9-3.2L12 2.95l3.4-1.45 1.9 3.2 3.6.8-.35 3.7L23 12l-2.45 2.8.35 3.7-3.6.8-1.9 3.2-3.4-1.45-3.4 1.45Zm.85-2.55 2.55-1.1 2.6 1.1 1.4-2.4 2.75-.65-.25-2.8 1.85-2.1-1.85-2.15.25-2.8-2.75-.6-1.45-2.4L12 5.15l-2.6-1.1L8 6.45l-2.75.6.25 2.8L3.65 12l1.85 2.1-.25 2.85 2.75.6 1.45 2.4Zm1.5-4.4L16.6 9.9l-1.4-1.45-4.25 4.25-2.15-2.1L7.4 12l3.55 3.55Z"
        }
      )
    }
  );
}
function ze({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 20h16v2H4v-2ZM4 2h16v2H4V2Zm9 7h3l-4-4-4 4h3v6H8l4 4 4-4h-3V9Z"
        }
      )
    }
  );
}
function lr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M8 19v2h8v-2h-3V5h3V3H8v2h3v14H8Z" })
    }
  );
}
function tr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-7 2h2.5v12H13V6Zm-2 12H8.5V6H11v12ZM4 6h2.5v12H4V6Zm16 12h-2.5V6H20v12Z"
        }
      )
    }
  );
}
function er({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M5 5 3 19c0 1.1.9 2 2 2h4v-2H5L7 5h2V3H7c-1.1 0-2 .9-2 2Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 19 5 5c0-1.1.9-2 2-2h2v2H7L5 19h4v2H5c-1.1 0-2-.9-2-2ZM19 5l2 14c0 1.1-.9 2-2 2h-4v-2h4L17 5h-2V3h2c1.1 0 2 .9 2 2ZM13 23h-2V1h2v22Z"
          }
        )
      ]
    }
  );
}
function rr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 15h8v-2H3v2Zm0 4h8v-2H3v2Zm0-8h8V9H3v2Zm0-6v2h8V5H3Zm10 0h8v14h-8V5Z"
        }
      )
    }
  );
}
function ir({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "m18 4 2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4Z"
        }
      )
    }
  );
}
function nr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6ZM18.75 17.75 20 15l1.25 2.75L24 19l-2.75 1.25L20 23l-1.25-2.75L16 19l2.75-1.25Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M12.75 11.75 14 9l1.25 2.75L18 13l-2.75 1.25L14 17l-1.25-2.75L10 13l2.75-1.25Z"
          }
        )
      ]
    }
  );
}
function hr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "m10 8 6 4-6 4V8Z" }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3 20c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H3ZM21 6H3v12l18 .01V6Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function cr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-8 12.5v-9l6 4.5-6 4.5Z"
        }
      )
    }
  );
}
function or({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M17 8h3l-2-4h4v7.07A8 8 0 0 0 10.252 20H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18 12a6 6 0 1 0 0 11.998A6 6 0 0 0 18 12Zm0 10a4 4 0 1 0-.72-7.935A5.977 5.977 0 0 1 18.75 18a5.977 5.977 0 0 1-1.47 3.935c.233.043.474.065.72.065Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function dr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22.72 17.57c.03.28.02.57-.01.86l1.06.85c.1.08.12.21.06.32l-1.03 1.79c-.06.11-.19.16-.31.11l-1.28-.5c-.23.16-.48.31-.74.42l-.2 1.36c-.02.12-.13.21-.25.21h-2.07c-.13 0-.23-.09-.25-.21l-.2-1.36c-.27-.11-.52-.25-.75-.42l-1.27.5c-.12.04-.25 0-.31-.11l-1.03-1.79a.248.248 0 0 1 .06-.32l1.07-.85c-.03-.28-.02-.57.01-.86l-1.07-.86a.248.248 0 0 1-.06-.32l1.03-1.79c.06-.11.19-.16.31-.11l1.28.5c.23-.16.48-.31.74-.42l.2-1.36c.02-.12.13-.21.25-.21h2.07c.13 0 .23.09.25.22l.2 1.36c.27.11.52.25.75.42l1.28-.5c.12-.04.25 0 .31.11l1.03 1.79c.06.11.04.24-.06.32l-1.07.85ZM17.5 18c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function vr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4Z"
        }
      )
    }
  );
}
function ar({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6Z"
        }
      )
    }
  );
}
function ur({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M21 5v14H3V5h18Zm0-2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-9 5c3.25 0 6 1.83 6 4s-2.75 4-6 4-6-1.83-6-4 2.75-4 6-4Zm0-2c-4.42 0-8 2.69-8 6s3.58 6 8 6 8-2.69 8-6-3.58-6-8-6Z"
        }
      )
    }
  );
}
function wr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20.132 10.313c-1.875 4.007-6.402 9.461-9.264 9.461-2.82 0-3.228-6.014-4.768-10.017-.758-1.97-1.247-1.517-2.668-.523l-.866-1.117c2.072-1.822 4.146-3.938 5.42-4.055 1.434-.138 2.318.843 2.648 2.943.436 2.76 1.046 7.042 2.11 7.042.83 0 2.873-3.397 2.979-4.612.186-1.779-1.308-1.833-2.605-1.277 2.052-6.723 10.592-5.485 7.014 2.155Z"
        }
      )
    }
  );
}
function sr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20.132 10.313c-1.875 4.007-6.402 9.461-9.264 9.461-2.82 0-3.228-6.014-4.768-10.017-.758-1.97-1.247-1.517-2.668-.523l-.866-1.117c2.072-1.822 4.146-3.938 5.42-4.055 1.434-.138 2.318.843 2.648 2.943.436 2.76 1.046 7.042 2.11 7.042.83 0 2.873-3.397 2.979-4.612.186-1.779-1.308-1.833-2.605-1.277 2.052-6.723 10.592-5.485 7.014 2.155Z"
        }
      )
    }
  );
}
function gr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#1AB7EA",
          d: "M20.132 10.313c-1.875 4.007-6.402 9.461-9.264 9.461-2.82 0-3.228-6.014-4.768-10.017-.758-1.97-1.247-1.517-2.668-.523l-.866-1.117c2.072-1.822 4.146-3.938 5.42-4.055 1.434-.138 2.318.843 2.648 2.943.436 2.76 1.046 7.042 2.11 7.042.83 0 2.873-3.397 2.979-4.612.186-1.779-1.308-1.833-2.605-1.277 2.052-6.723 10.592-5.485 7.014 2.155Z"
        }
      )
    }
  );
}
function pr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02ZM5 9v6h4l5 5V4L9 9H5Z"
        }
      )
    }
  );
}
function fr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63Zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71ZM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73 4.27 3ZM12 4 9.91 6.09 12 8.18V4Z"
        }
      )
    }
  );
}
function mr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M3 9v6h4l5 5V4L7 9H3Zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02ZM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77Z"
        }
      )
    }
  );
}
function Zr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M23 20 12 1 1 20h22Zm-12-3v-2h2v2h-2Zm0-4h2V9h-2v4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function xr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 4.99 19.53 18H4.47L12 4.99ZM12 1 1 20h22L12 1Z" }),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M13 15h-2v2h2v-2ZM13 9h-2v5h2V9Z" })
      ]
    }
  );
}
function Cr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M19 12c0-2.328-1.041-4.41-2.66-5.747L15.5 1h-7l-.831 5.253C6.04 7.59 5 9.663 5 12c0 2.338 1.041 4.41 2.669 5.747L8.5 23h7l.84-5.253C17.959 16.41 19 14.328 19 12ZM6.75 12c0-3.034 2.354-5.5 5.25-5.5s5.25 2.466 5.25 5.5-2.354 5.5-5.25 5.5-5.25-2.466-5.25-5.5Z"
        }
      )
    }
  );
}
function yr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M17 12c0-2.76-2.24-5-5-5-.64 0-1.25.13-1.82.35L8.04 5.21 9 2h6l1.36 4.53a6.963 6.963 0 0 1 1.79 8.79l-1.5-1.5c.22-.57.35-1.18.35-1.82Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m1.39 4.22 1.42-1.41L21.19 21.2l-1.41 1.41-3.82-3.82L15 22H9l-1.36-4.53a6.963 6.963 0 0 1-1.79-8.79L1.39 4.22ZM7 12c0 2.76 2.24 5 5 5 .64 0 1.25-.13 1.82-.35l-6.47-6.47C7.13 10.75 7 11.36 7 12Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function Ar({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M7 21c-1.383 0-2.563-.488-3.538-1.462C2.487 18.562 2 17.383 2 16c0-1.217.38-2.28 1.138-3.188A4.9 4.9 0 0 1 6 11.1v2.075a2.91 2.91 0 0 0-1.438 1.075A2.906 2.906 0 0 0 4 16c0 .833.292 1.542.875 2.125A2.893 2.893 0 0 0 7 19c.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0 0 10 16v-1h5.875c.133-.15.296-.27.488-.363.191-.091.404-.137.637-.137.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 17 17.5c-.233 0-.446-.046-.637-.137a1.522 1.522 0 0 1-.488-.363H11.9a4.9 4.9 0 0 1-1.713 2.863C9.28 20.62 8.217 21 7 21Zm10 0c-.933 0-1.78-.23-2.537-.688a5.033 5.033 0 0 1-1.788-1.812h2.675c.233.167.492.292.775.375.283.083.575.125.875.125.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0 0 20 16c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 17 13c-.333 0-.642.046-.925.137-.283.092-.55.23-.8.413l-3.05-5.075a1.505 1.505 0 0 1-.875-.5A1.429 1.429 0 0 1 11 7c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 12.5 5.5c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v.213c0 .058-.017.129-.05.212l2.175 3.65c.133-.033.275-.054.425-.063.15-.008.3-.012.45-.012 1.383 0 2.563.488 3.538 1.463C21.512 13.438 22 14.617 22 16s-.488 2.563-1.462 3.538C19.562 20.512 18.383 21 17 21ZM7 17.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 5.5 16c0-.367.117-.683.35-.95.233-.267.517-.442.85-.525l2.35-3.9a4.838 4.838 0 0 1-1.138-1.613A4.941 4.941 0 0 1 7.5 7c0-1.383.487-2.563 1.463-3.538C9.938 2.487 11.117 2 12.5 2s2.563.487 3.538 1.462C17.012 4.438 17.5 5.617 17.5 7h-2c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12.5 4c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9.5 7c0 .717.217 1.346.65 1.887.433.542.983.888 1.65 1.038L8.425 15.55a.924.924 0 0 1 .063.225c.008.067.012.142.012.225 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 7 17.5Z"
        }
      )
    }
  );
}
function Mr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.735 3.707A8.74 8.74 0 0 1 12.167 3c1.172 0 2.345.25 3.433.707a8.706 8.706 0 0 1 2.805 1.87 8.64 8.64 0 0 1 1.883 2.786c.46 1.08.712 2.203.712 3.408a8.73 8.73 0 0 1-.712 3.41 8.64 8.64 0 0 1-1.883 2.784 8.705 8.705 0 0 1-2.805 1.871 8.74 8.74 0 0 1-3.433.707c-1.506 0-2.93-.374-4.27-1.081L3 21l1.59-4.698c-.837-1.371-1.255-2.868-1.255-4.53a8.73 8.73 0 0 1 .712-3.41A8.638 8.638 0 0 1 5.93 5.578c.754-.79 1.717-1.371 2.805-1.87Zm3.39 15.34c1.005 0 1.926-.209 2.847-.583s1.675-.914 2.344-1.538c.67-.623 1.172-1.413 1.55-2.328.376-.914.585-1.829.585-2.827 0-.997-.21-1.912-.586-2.826-.377-.915-.92-1.663-1.549-2.328-.628-.665-1.423-1.164-2.344-1.538-.92-.375-1.842-.582-2.846-.582-1.005 0-1.926.207-2.847.582-.92.374-1.674.914-2.344 1.538-.67.623-1.172 1.413-1.549 2.328-.377.914-.586 1.829-.586 2.826 0 1.58.46 2.993 1.381 4.282l-.92 2.702 2.846-.873c1.214.79 2.595 1.164 4.019 1.164Zm1.759-5.571c.293-.374.502-.582.628-.582.083 0 .46.166 1.13.499.67.332 1.005.54 1.046.623 0 .042.042.083.042.166 0 .25-.084.54-.21.873-.125.291-.418.54-.836.749a2.695 2.695 0 0 1-1.172.29c-.46 0-1.173-.249-2.219-.706a5.973 5.973 0 0 1-1.967-1.372 17.086 17.086 0 0 1-1.717-2.162c-.544-.83-.837-1.58-.837-2.244v-.083c.042-.707.293-1.33.88-1.83a.855.855 0 0 1 .627-.249h.419c.167 0 .25.042.293.083a.793.793 0 0 1 .167.333c.042.166.21.499.377 1.039.21.54.293.831.293.873 0 .166-.126.374-.419.665-.25.291-.418.457-.418.54 0 .042 0 .125.042.167.25.582.67 1.08 1.172 1.58.418.415 1.004.79 1.758 1.164.084.041.167.083.251.083.167.041.377-.125.67-.5Z"
        }
      )
    }
  );
}
function Hr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.735 3.707A8.74 8.74 0 0 1 12.167 3c1.172 0 2.345.25 3.433.707a8.706 8.706 0 0 1 2.805 1.87 8.64 8.64 0 0 1 1.883 2.786c.46 1.08.712 2.203.712 3.408a8.73 8.73 0 0 1-.712 3.41 8.64 8.64 0 0 1-1.883 2.784 8.705 8.705 0 0 1-2.805 1.871 8.74 8.74 0 0 1-3.433.707c-1.506 0-2.93-.374-4.27-1.081L3 21l1.59-4.698c-.837-1.371-1.255-2.868-1.255-4.53a8.73 8.73 0 0 1 .712-3.41A8.638 8.638 0 0 1 5.93 5.578c.754-.79 1.717-1.371 2.805-1.87Zm3.39 15.34c1.005 0 1.926-.209 2.847-.583s1.675-.914 2.344-1.538c.67-.623 1.172-1.413 1.55-2.328.376-.914.585-1.829.585-2.827 0-.997-.21-1.912-.586-2.826-.377-.915-.92-1.663-1.549-2.328-.628-.665-1.423-1.164-2.344-1.538-.92-.375-1.842-.582-2.846-.582-1.005 0-1.926.207-2.847.582-.92.374-1.674.914-2.344 1.538-.67.623-1.172 1.413-1.549 2.328-.377.914-.586 1.829-.586 2.826 0 1.58.46 2.993 1.381 4.282l-.92 2.702 2.846-.873c1.214.79 2.595 1.164 4.019 1.164Zm1.759-5.571c.293-.374.502-.582.628-.582.083 0 .46.166 1.13.499.67.332 1.005.54 1.046.623 0 .042.042.083.042.166 0 .25-.084.54-.21.873-.125.291-.418.54-.836.749a2.695 2.695 0 0 1-1.172.29c-.46 0-1.173-.249-2.219-.706a5.973 5.973 0 0 1-1.967-1.372 17.086 17.086 0 0 1-1.717-2.162c-.544-.83-.837-1.58-.837-2.244v-.083c.042-.707.293-1.33.88-1.83a.855.855 0 0 1 .627-.249h.419c.167 0 .25.042.293.083a.793.793 0 0 1 .167.333c.042.166.21.499.377 1.039.21.54.293.831.293.873 0 .166-.126.374-.419.665-.25.291-.418.457-.418.54 0 .042 0 .125.042.167.25.582.67 1.08 1.172 1.58.418.415 1.004.79 1.758 1.164.084.041.167.083.251.083.167.041.377-.125.67-.5Z"
        }
      )
    }
  );
}
function Vr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#25D366",
          d: "M8.735 3.707A8.74 8.74 0 0 1 12.167 3c1.172 0 2.345.25 3.433.707a8.706 8.706 0 0 1 2.805 1.87 8.64 8.64 0 0 1 1.883 2.786c.46 1.08.712 2.203.712 3.408a8.73 8.73 0 0 1-.712 3.41 8.64 8.64 0 0 1-1.883 2.784 8.705 8.705 0 0 1-2.805 1.871 8.74 8.74 0 0 1-3.433.707c-1.506 0-2.93-.374-4.27-1.081L3 21l1.59-4.698c-.837-1.371-1.255-2.868-1.255-4.53a8.73 8.73 0 0 1 .712-3.41A8.638 8.638 0 0 1 5.93 5.578c.754-.79 1.717-1.371 2.805-1.87Zm3.39 15.34c1.005 0 1.926-.209 2.847-.583s1.675-.914 2.344-1.538c.67-.623 1.172-1.413 1.55-2.328.376-.914.585-1.829.585-2.827 0-.997-.21-1.912-.586-2.826-.377-.915-.92-1.663-1.549-2.328-.628-.665-1.423-1.164-2.344-1.538-.92-.375-1.842-.582-2.846-.582-1.005 0-1.926.207-2.847.582-.92.374-1.674.914-2.344 1.538-.67.623-1.172 1.413-1.549 2.328-.377.914-.586 1.829-.586 2.826 0 1.58.46 2.993 1.381 4.282l-.92 2.702 2.846-.873c1.214.79 2.595 1.164 4.019 1.164Zm1.759-5.571c.293-.374.502-.582.628-.582.083 0 .46.166 1.13.499.67.332 1.005.54 1.046.623 0 .042.042.083.042.166 0 .25-.084.54-.21.873-.125.291-.418.54-.836.749a2.695 2.695 0 0 1-1.172.29c-.46 0-1.173-.249-2.219-.706a5.973 5.973 0 0 1-1.967-1.372 17.086 17.086 0 0 1-1.717-2.162c-.544-.83-.837-1.58-.837-2.244v-.083c.042-.707.293-1.33.88-1.83a.855.855 0 0 1 .627-.249h.419c.167 0 .25.042.293.083a.793.793 0 0 1 .167.333c.042.166.21.499.377 1.039.21.54.293.831.293.873 0 .166-.126.374-.419.665-.25.291-.418.457-.418.54 0 .042 0 .125.042.167.25.582.67 1.08 1.172 1.58.418.415 1.004.79 1.758 1.164.084.041.167.083.251.083.167.041.377-.125.67-.5Z"
        }
      )
    }
  );
}
function Br({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M13 13v8h8v-8h-8ZM3 21h8v-8H3v8ZM3 3v8h8V3H3Zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65Z"
        }
      )
    }
  );
}
function Ir({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17.01 13v3L21 12l-3.99-4v3H6.99V8L3 12l3.99 4v-3h10.02Z"
        }
      )
    }
  );
}
function Lr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12 20.5a2.184 2.184 0 0 1-1.627-.682c-.443-.455-.665-1.012-.665-1.67 0-.66.222-1.217.665-1.671A2.184 2.184 0 0 1 12 15.794c.642 0 1.184.228 1.627.683.443.454.665 1.011.665 1.67s-.222 1.216-.665 1.67A2.184 2.184 0 0 1 12 20.5Zm-5.18-5.318L4.897 13.16a10.15 10.15 0 0 1 3.174-2.2c1.214-.541 2.524-.812 3.93-.812 1.406 0 2.716.275 3.93.824a10.12 10.12 0 0 1 3.174 2.235l-1.925 1.976a7.431 7.431 0 0 0-2.337-1.623A6.944 6.944 0 0 0 12 12.97a6.943 6.943 0 0 0-2.842.588 7.43 7.43 0 0 0-2.337 1.623Zm-3.895-4L1 9.206a15.278 15.278 0 0 1 4.927-3.459C7.807 4.916 9.831 4.5 12 4.5c2.17 0 4.194.416 6.073 1.247A15.278 15.278 0 0 1 23 9.206l-1.925 1.976a12.92 12.92 0 0 0-4.09-2.835C15.433 7.665 13.771 7.324 12 7.324c-1.772 0-3.434.34-4.984 1.023a12.92 12.92 0 0 0-4.091 2.835Z"
        }
      )
    }
  );
}
function Rr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M21 6.5c0 1.93-1.57 3.5-3.5 3.5-.41 0-.8-.08-1.16-.21L4.96 21.16l-2.12-2.12 7.41-7.41-1.78-1.78-.71.71-1.41-1.41v2.83l-.71.71L2.1 9.15l.71-.71h2.82L4.22 7.03l3.54-3.54a3 3 0 0 1 4.24 0L9.88 5.61l1.41 1.41-.71.71 1.78 1.78 1.85-1.85A3.41 3.41 0 0 1 14 6.5C14 4.57 15.57 3 17.5 3c.58 0 1.12.16 1.6.41l-2.7 2.7 1.49 1.49 2.7-2.7c.25.48.41 1.02.41 1.6ZM13.783 15.172l2.121-2.121 5.996 5.996-2.121 2.121-5.996-5.996Z"
        }
      )
    }
  );
}
function Sr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M4 5v2h16V5H4ZM4 11h13a4 4 0 0 1 0 8h-2.15l1.25 1.25-1.4 1.45L11 18l3.7-3.7 1.4 1.45L14.85 17H17a2 2 0 1 0 0-4H4v-2Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M4 19v-2h5v2H4Z" })
      ]
    }
  );
}
function Fr({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 15v-5c-1.1 0-2.042-.392-2.825-1.175C5.392 8.042 5 7.1 5 6s.392-2.042 1.175-2.825C6.958 2.392 7.9 2 9 2h8v2h-2v11h-2V4h-2v11H9Zm0-7V4c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 7 6c0 .55.196 1.02.588 1.412C7.979 7.804 8.45 8 9 8Zm8 14-1.4-1.4 1.6-1.6H3v-2h14.2l-1.6-1.6L17 14l4 4-4 4Z"
        }
      )
    }
  );
}
function Tr({
  size: l = "24px",
  style: e = {},
  ...r
}) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9 15v-5c-1.1 0-2.042-.392-2.825-1.175C5.392 8.042 5 7.1 5 6s.392-2.042 1.175-2.825C6.958 2.392 7.9 2 9 2h8v2h-2v11h-2V4h-2v11H9Zm-2.2 4 1.6 1.6L7 22l-4-4 4-4 1.4 1.4L6.8 17H21v2H6.8ZM9 8V4c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 7 6c0 .55.196 1.02.588 1.412C7.979 7.804 8.45 8 9 8Z"
        }
      )
    }
  );
}
function kr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M17.801 2.97h3.066l-6.731 7.664L22 21.03h-6.171l-4.832-6.318-5.531 6.318H2.4l7.13-8.197L2 2.97h6.325L12.69 8.74 17.8 2.97ZM16.728 19.23h1.7L7.432 4.702H5.605l11.123 14.529Z"
        }
      )
    }
  );
}
function Dr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.624 7.98a2.261 2.261 0 0 0-1.591-1.601C17.628 6 12 6 12 6s-5.629 0-7.032.379A2.262 2.262 0 0 0 3.376 7.98C3 9.393 3 12.34 3 12.34s0 2.949.376 4.362c.207.779.817 1.393 1.592 1.601 1.403.379 7.032.379 7.032.379s5.629 0 7.032-.379a2.262 2.262 0 0 0 1.592-1.601C21 15.289 21 12.34 21 12.34s0-2.948-.376-4.36Zm-10.465 7.037 4.705-2.676-4.705-2.677v5.353Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Or({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.624 7.98a2.261 2.261 0 0 0-1.591-1.601C17.628 6 12 6 12 6s-5.629 0-7.032.379A2.262 2.262 0 0 0 3.376 7.98C3 9.393 3 12.34 3 12.34s0 2.949.376 4.362c.207.779.817 1.393 1.592 1.601 1.403.379 7.032.379 7.032.379s5.629 0 7.032-.379a2.262 2.262 0 0 0 1.592-1.601C21 15.289 21 12.34 21 12.34s0-2.948-.376-4.36Zm-10.465 7.037 4.705-2.676-4.705-2.677v5.353Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function br({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "#D9252A",
          fillRule: "evenodd",
          d: "M20.624 7.98a2.261 2.261 0 0 0-1.591-1.601C17.628 6 12 6 12 6s-5.629 0-7.032.379A2.262 2.262 0 0 0 3.376 7.98C3 9.393 3 12.34 3 12.34s0 2.949.376 4.362c.207.779.817 1.393 1.592 1.601 1.403.379 7.032.379 7.032.379s5.629 0 7.032-.379a2.262 2.262 0 0 0 1.592-1.601C21 15.289 21 12.34 21 12.34s0-2.948-.376-4.36Zm-10.465 7.037 4.705-2.676-4.705-2.677v5.353Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Pr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-2 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2Z"
        }
      )
    }
  );
}
function Ur({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1Z" })
      ]
    }
  );
}
function Er({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 5v4H7v2h4v4h2v-4h4v-2h-4V7h-2Zm-7 5c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Gr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
          }
        ),
        /* @__PURE__ */ t("path", { fill: "currentColor", d: "M12 10H7V9h5v1Z" })
      ]
    }
  );
}
function Wr({ size: l = "24px", style: e = {}, ...r }) {
  const i = {
    verticalAlign: "middle",
    ...e
  };
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 24 24",
      width: l,
      height: l,
      style: i,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2ZM4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Zm3-1v2h10v-2H7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
export {
  c as Icon11Square,
  o as Icon1Col,
  d as Icon1ColLeft,
  v as Icon1ColRight,
  a as Icon2Col,
  u as Icon360Image,
  w as Icon3Col,
  s as Icon3D,
  g as IconAIControlCenter,
  p as IconAction,
  f as IconAdd,
  m as IconAddCircle,
  Z as IconAddEmoji,
  x as IconAddImage,
  C as IconAddLink,
  y as IconAddPerson,
  A as IconAddToCollection,
  M as IconAdjust,
  H as IconAdwords,
  V as IconAdwords3tones,
  B as IconAdwordsColor,
  I as IconAlignBottom,
  L as IconAlignHorizontalCenter,
  R as IconAlignLeft,
  S as IconAlignRight,
  F as IconAlignTop,
  T as IconAlignVerticalCenter,
  k as IconAnalytics,
  D as IconAngle,
  O as IconAnimate,
  b as IconAnnotation,
  P as IconApproval,
  U as IconArchive,
  E as IconArrowBack,
  G as IconArrowBackIOS,
  W as IconArrowBottom,
  N as IconArrowBottomLeft,
  j as IconArrowBottomRight,
  X as IconArrowDown,
  K as IconArrowForward,
  Q as IconArrowForwardIOS,
  Y as IconArrowLeft,
  J as IconArrowRight,
  q as IconArrowTop,
  _ as IconArrowTopLeft,
  $ as IconArrowTopRight,
  z as IconArrowUp,
  l1 as IconArtificialIntelligence,
  t1 as IconAspectRatio,
  e1 as IconAspectRatioOutline,
  r1 as IconAttachment,
  i1 as IconAttention,
  n1 as IconAutomation,
  h1 as IconAutoplay,
  c1 as IconBackgroundFill,
  o1 as IconBackup,
  d1 as IconBarChart,
  v1 as IconBlendMode,
  a1 as IconBlur,
  u1 as IconBoard,
  w1 as IconBold,
  s1 as IconBookmark,
  g1 as IconBookmarkOutline,
  p1 as IconBorder,
  f1 as IconBorderBottom,
  m1 as IconBorderColor,
  Z1 as IconBorderLeft,
  x1 as IconBorderRadius,
  C1 as IconBorderRadiusBottomLeft,
  y1 as IconBorderRadiusBottomRight,
  A1 as IconBorderRadiusIndependent,
  M1 as IconBorderRadiusTopLeft,
  H1 as IconBorderRadiusTopRight,
  V1 as IconBorderRight,
  B1 as IconBorderTop,
  I1 as IconBorderWidth,
  L1 as IconBox,
  R1 as IconBox3tones,
  S1 as IconBoxColor,
  F1 as IconBrandGuidelines,
  T1 as IconBrightcove,
  k1 as IconBrightcove3tones,
  D1 as IconBrightcoveColor,
  O1 as IconBrightcoveColorNEW,
  b1 as IconBrightcoveNEW,
  P1 as IconBrightcoveNEW3tones,
  U1 as IconBringToFront,
  E1 as IconBrush,
  G1 as IconBrushAdd,
  W1 as IconBrushRemove,
  N1 as IconBuildShape,
  j1 as IconBuilding,
  X1 as IconButton,
  K1 as IconBynder,
  Q1 as IconBynder3tones,
  Y1 as IconBynderColor,
  J1 as IconCamera,
  q1 as IconCampaign,
  _1 as IconCancel,
  $1 as IconCard,
  z1 as IconCardOutline,
  l2 as IconCaretDown,
  t2 as IconCaretLeft,
  e2 as IconCaretRight,
  r2 as IconCaretUp,
  i2 as IconCarousel,
  n2 as IconCart,
  h2 as IconCellOrder,
  c2 as IconChat,
  o2 as IconCheck,
  d2 as IconCheckCircle,
  v2 as IconCheckbox,
  a2 as IconCircle,
  u2 as IconCleanCard,
  w2 as IconClear,
  s2 as IconClearFormatting,
  g2 as IconClearValue,
  p2 as IconClipboard,
  f2 as IconClosedCaption,
  m2 as IconCloud,
  Z2 as IconCloudDone,
  x2 as IconCode,
  C2 as IconCollage,
  y2 as IconCollection,
  A2 as IconColor,
  M2 as IconColorPicker,
  H2 as IconColorStyle,
  V2 as IconComment,
  B2 as IconCompare,
  I2 as IconCompass,
  L2 as IconComponentFolder,
  R2 as IconConfigure,
  S2 as IconContrast,
  F2 as IconControlBackspace,
  T2 as IconControlCommand,
  k2 as IconControlControl,
  D2 as IconControlDownSymbol,
  O2 as IconControlEnter,
  b2 as IconControlLeftSymbol,
  P2 as IconControlOption,
  U2 as IconControlRightSymbol,
  E2 as IconControlShift,
  G2 as IconControlSpacebar,
  W2 as IconControlUpSymbol,
  N2 as IconControlVideo,
  j2 as IconControlWindows,
  X2 as IconConversation,
  K2 as IconCookie,
  Q2 as IconCopy,
  Y2 as IconCopyright,
  J2 as IconCreateCarousel,
  q2 as IconCreateGroup,
  _2 as IconCrop,
  $2 as IconCropRotate,
  z2 as IconCustomCol,
  l0 as IconCustomisation,
  t0 as IconCut,
  e0 as IconDate,
  r0 as IconDelete,
  i0 as IconDeleteOutline,
  n0 as IconDeselect,
  h0 as IconDevice,
  c0 as IconDisabled,
  o0 as IconDistributeHorizontalCenter,
  d0 as IconDistributeHorizontalLeft,
  v0 as IconDistributeHorizontalRight,
  a0 as IconDistributeHorizontally,
  u0 as IconDistributeVerticalBottom,
  w0 as IconDistributeVerticalCenter,
  s0 as IconDistributeVerticalTop,
  g0 as IconDistributeVertically,
  p0 as IconDivider,
  f0 as IconDocument,
  m0 as IconDottedLine,
  Z0 as IconDownload,
  x0 as IconDownloadDisabled,
  C0 as IconDragIndicator,
  y0 as IconDropbox,
  A0 as IconDropbox3tones,
  M0 as IconDropboxColor,
  H0 as IconDuplicate,
  V0 as IconEdit,
  B0 as IconEmojiSymbols,
  I0 as IconEndDate,
  L0 as IconError,
  R0 as IconErrorOutline,
  S0 as IconExitApp,
  F0 as IconExitFullscreen,
  T0 as IconExponential,
  k0 as IconExposure,
  D0 as IconExtension,
  O0 as IconExtensionOutline,
  b0 as IconFaceRecognition,
  P0 as IconFacebook,
  U0 as IconFacebook3tones,
  E0 as IconFacebookColor,
  G0 as IconFadeInAudio,
  W0 as IconFadeOutAudio,
  N0 as IconFeatured,
  j0 as IconFigma,
  X0 as IconFigmaColor,
  K0 as IconFile,
  Q0 as IconFileMove,
  Y0 as IconFileOpen,
  J0 as IconFilter,
  q0 as IconFilterFunnel,
  _0 as IconFindReplace,
  $0 as IconFire,
  z0 as IconFitImage,
  l3 as IconFlash,
  t3 as IconFlashOff,
  e3 as IconFlipHorizontal,
  r3 as IconFlipVertical,
  i3 as IconFlipping,
  n3 as IconFlowPath,
  h3 as IconFlyIn,
  c3 as IconFlyOut,
  o3 as IconFocalPoint,
  d3 as IconFocusPoint,
  v3 as IconFolder,
  a3 as IconFolderMask,
  u3 as IconFolderOpen,
  w3 as IconFolderOpenMask,
  s3 as IconFont,
  g3 as IconFontLarge,
  p3 as IconFontSmall,
  f3 as IconForkBottomRight,
  m3 as IconForkTopRight,
  Z3 as IconFormatColor,
  x3 as IconForward,
  C3 as IconForward10,
  y3 as IconForward30,
  A3 as IconForward5,
  M3 as IconFrame,
  H3 as IconFullAspectRatio,
  V3 as IconFullscreen,
  B3 as IconGIF,
  I3 as IconGoogle,
  L3 as IconGoogle3tones,
  R3 as IconGoogleColor,
  S3 as IconGradient,
  F3 as IconGraphs,
  T3 as IconGrayscale,
  k3 as IconGrid,
  D3 as IconGridFill,
  O3 as IconGridView,
  b3 as IconGrowth,
  P3 as IconHandTool,
  U3 as IconHappy,
  E3 as IconHeading,
  G3 as IconHealing,
  W3 as IconHeart,
  N3 as IconHeight,
  j3 as IconHeightL,
  X3 as IconHeightM,
  K3 as IconHeightS,
  Q3 as IconHeightXL,
  Y3 as IconHelp,
  J3 as IconHelpOutline,
  q3 as IconHide,
  _3 as IconHideSmall,
  $3 as IconHome,
  z3 as IconHomeOutline,
  l4 as IconHorizontalConstraints,
  t4 as IconHorizontalDivider,
  e4 as IconHorizontalList,
  r4 as IconHorizontalPerspective,
  i4 as IconIllustrator,
  n4 as IconIllustratorOutline,
  h4 as IconIllustratorSymbol,
  c4 as IconImage,
  o4 as IconImageLayer,
  d4 as IconImageMask,
  v4 as IconImageRecognition,
  a4 as IconImageSearch,
  u4 as IconImageSmall,
  w4 as IconInDesign,
  s4 as IconInDesignOutline,
  g4 as IconInbox,
  p4 as IconIndesignSymbol,
  f4 as IconInfo,
  m4 as IconInfoOutline,
  Z4 as IconInsights,
  x4 as IconInstagram,
  C4 as IconInstagram3tones,
  y4 as IconInstagramColor,
  A4 as IconIntegration,
  M4 as IconItalic,
  H4 as IconJoy,
  V4 as IconKey,
  B4 as IconKeyboard,
  I4 as IconKnowledge,
  L4 as IconLabel,
  R4 as IconLandscape,
  S4 as IconLandscapeSelected,
  F4 as IconLanguage,
  T4 as IconLaptop,
  k4 as IconLayers,
  D4 as IconLayout,
  O4 as IconLetterOrderBTT,
  b4 as IconLetterOrderLTR,
  P4 as IconLetterOrderRTL,
  U4 as IconLetterOrderTTB,
  E4 as IconLetterSpacing,
  G4 as IconLightbulb,
  W4 as IconLineHeight,
  N4 as IconLinear,
  j4 as IconLinearGradient,
  X4 as IconLink,
  K4 as IconLinkSmall,
  Q4 as IconLinkedin,
  Y4 as IconLinkedin3tones,
  J4 as IconLinkedinColor,
  q4 as IconListBulleted,
  _4 as IconListNumbered,
  $4 as IconListView,
  z4 as IconLoading,
  l5 as IconLocate,
  t5 as IconLocation,
  e5 as IconLock,
  r5 as IconLockOpen,
  i5 as IconLockOpenSmall,
  n5 as IconLockSmall,
  h5 as IconLogarithmic,
  c5 as IconLogout,
  o5 as IconLowerCase,
  d5 as IconMagic,
  v5 as IconMail,
  a5 as IconManager,
  u5 as IconManualFocus,
  w5 as IconMarker,
  s5 as IconMask,
  g5 as IconMaskAlt,
  p5 as IconMaskAlt2,
  f5 as IconMaskAlt3,
  m5 as IconMaskDisabled,
  Z5 as IconMaskInversedAlt,
  x5 as IconMaskSmall,
  C5 as IconMasonry,
  y5 as IconMention,
  A5 as IconMenu,
  M5 as IconMenuClose,
  H5 as IconMenuOpen,
  V5 as IconMerge,
  B5 as IconMicrophone,
  I5 as IconMigrate,
  L5 as IconMin,
  R5 as IconMobile,
  S5 as IconMore,
  F5 as IconMoreVertical,
  T5 as IconMotionBlur,
  k5 as IconMove,
  D5 as IconMultiDevice,
  O5 as IconMultiSelect,
  b5 as IconMuseum,
  P5 as IconMusicLibrary,
  U5 as IconMute,
  E5 as IconNewStyle,
  G5 as IconNoMask,
  W5 as IconNoUpload,
  N5 as IconNormalScript,
  j5 as IconNotifications,
  X5 as IconNull,
  K5 as IconOpacity,
  Q5 as IconOpenInNew,
  Y5 as IconOverrideFocus,
  J5 as IconPDF,
  q5 as IconPadding,
  _5 as IconPaddingBottom,
  $5 as IconPaddingLeft,
  z5 as IconPaddingLeftAndRight,
  ll as IconPaddingRight,
  tl as IconPaddingTop,
  el as IconPaddingTopAndBottom,
  rl as IconPages,
  il as IconPanZoom,
  nl as IconParagraphSpacing,
  hl as IconPath,
  cl as IconPause,
  ol as IconPermission,
  dl as IconPhotoshop,
  vl as IconPhotoshopOutline,
  al as IconPhotoshopSymbol,
  ul as IconPictureInPicture,
  wl as IconPin,
  sl as IconPlaceholder,
  gl as IconPlay,
  pl as IconPlayCircle,
  fl as IconPlaylistAdd,
  ml as IconPointOfInterest,
  Zl as IconPolygon,
  xl as IconPortrait,
  Cl as IconPortraitSelected,
  yl as IconPoundSign,
  Al as IconPremiere,
  Ml as IconPremiereOutline,
  Hl as IconPremiereSymbol,
  Vl as IconPremium,
  Bl as IconPresentation,
  Il as IconPrint,
  Ll as IconProgress25,
  Rl as IconProgress33,
  Sl as IconProgress50,
  Fl as IconProgress66,
  Tl as IconProgress75,
  kl as IconPrototype,
  Dl as IconPublic,
  Ol as IconPublicLimited,
  bl as IconPublicOff,
  Pl as IconPublish,
  Ul as IconQRCode,
  El as IconQuestion,
  Gl as IconQuote,
  Wl as IconRadar,
  Nl as IconRadialGradient,
  jl as IconRectangle,
  Xl as IconRedirect,
  Kl as IconRedo,
  Ql as IconRefresh,
  Yl as IconRemove,
  Jl as IconRemoveBackground,
  ql as IconRemoveBackgroundSmart,
  _l as IconRename,
  $l as IconReorder,
  zl as IconReorderVertical,
  lt as IconReplace,
  tt as IconReplaceBackground,
  et as IconReplay,
  rt as IconReplay10,
  it as IconReplay30,
  nt as IconReplay5,
  ht as IconReply,
  ct as IconResolutions,
  ot as IconResolutionsOutline,
  dt as IconRestore,
  vt as IconRestricted,
  at as IconRibbon,
  ut as IconRocket,
  wt as IconRotate,
  st as IconRotateCW,
  gt as IconRoundedRectangle,
  pt as IconSCurve,
  ft as IconSad,
  mt as IconScale,
  Zt as IconScaleIn,
  xt as IconScore,
  Ct as IconSearch,
  yt as IconSelect,
  At as IconSend,
  Mt as IconSendToBack,
  Ht as IconServer,
  Vt as IconSetFocusPoint,
  Bt as IconSetFocusPointAlt,
  It as IconSettings,
  Lt as IconShape,
  Rt as IconShare,
  St as IconSharedFolder,
  Ft as IconSharpen,
  Tt as IconShield,
  kt as IconShow,
  Dt as IconShowSmall,
  Ot as IconSidebarLeft,
  bt as IconSidebarRight,
  Pt as IconSignal,
  Ut as IconSingleSelect,
  Et as IconSkeleton,
  Gt as IconSketch,
  Wt as IconSkipBeginning,
  Nt as IconSkipEnd,
  jt as IconSkipNext,
  Xt as IconSkipPrevious,
  Kt as IconSlack,
  Qt as IconSlideshow,
  Yt as IconSmart,
  Jt as IconSolid,
  qt as IconSolidLine,
  _t as IconSortOrder,
  $t as IconSortOrderReverse,
  zt as IconSorting,
  l7 as IconSound,
  t7 as IconSoundOff,
  e7 as IconSpeedMeter,
  r7 as IconSpellcheck,
  i7 as IconSpinner1,
  n7 as IconSpinner2,
  h7 as IconSpinner3,
  c7 as IconSpinner4,
  o7 as IconSplit,
  d7 as IconSpreadsheet,
  v7 as IconStacked,
  a7 as IconStar,
  u7 as IconStarHalf,
  w7 as IconStarOutline,
  s7 as IconStarredFolder,
  g7 as IconStartDate,
  p7 as IconStateIndicatorL,
  f7 as IconStateIndicatorM,
  m7 as IconStateIndicatorS,
  Z7 as IconStateIndicatorXL,
  x7 as IconStateIndicatorXLOutline,
  C7 as IconSteps,
  y7 as IconStop,
  A7 as IconStorybook,
  M7 as IconStorybookColor,
  H7 as IconStraighten,
  V7 as IconStrikeThrough,
  B7 as IconSubArrowRight,
  I7 as IconSubscript,
  L7 as IconSubtitles,
  R7 as IconSuperscript,
  S7 as IconSurprised,
  F7 as IconSwatchGrid,
  T7 as IconSwatchGridLarge,
  k7 as IconSwitchOff,
  D7 as IconSwitchOn,
  O7 as IconSync,
  b7 as IconSyncOff,
  P7 as IconSyncSettings,
  U7 as IconTOC,
  E7 as IconTag,
  G7 as IconTarget,
  W7 as IconTaxonomy,
  N7 as IconTaxonomyOutline,
  j7 as IconText,
  X7 as IconTextBackground,
  K7 as IconTextCenter,
  Q7 as IconTextColor,
  Y7 as IconTextDirectionBottomToTop,
  b4 as IconTextDirectionLeftToRight,
  P4 as IconTextDirectionRightToLeft,
  J7 as IconTextDirectionTopToBottom,
  q7 as IconTextField,
  _7 as IconTextFit,
  $7 as IconTextJustify,
  z7 as IconTextLeft,
  le as IconTextMask,
  te as IconTextOutline,
  ee as IconTextOverflow,
  re as IconTextRecognition,
  ie as IconTextRight,
  O4 as IconTextRotateBottomToTop,
  U4 as IconTextRotateTopToBottom,
  ne as IconTextStyle,
  he as IconTheming,
  ce as IconThemingOutline,
  oe as IconThumbDown,
  de as IconThumbUp,
  ve as IconTiktok,
  ae as IconTiktok3tones,
  ue as IconTiktokColor,
  we as IconTime,
  se as IconTimeline,
  ge as IconTimer,
  pe as IconTimerOff,
  fe as IconTitle,
  me as IconTitleCase,
  Ze as IconToday,
  xe as IconTopNavigation,
  Ce as IconTransform,
  ye as IconTranslate,
  Ae as IconTrendChart,
  Me as IconTriangle,
  He as IconTrigger,
  Ve as IconTrophy,
  Be as IconTwitter,
  Ie as IconTwitter3tones,
  Le as IconTwitterColor,
  Re as IconUltraTall,
  Se as IconUltraWide,
  Fe as IconUnamused,
  Te as IconUnarchive,
  ke as IconUnderline,
  De as IconUndo,
  Oe as IconUnfeatured,
  be as IconUngroup,
  Pe as IconUnknownFile,
  Ue as IconUnlink,
  Ee as IconUnlinked,
  Ge as IconUnpin,
  We as IconUnpublish,
  Ne as IconUpload,
  je as IconUpperCase,
  Xe as IconUpscale,
  Ke as IconUser,
  Qe as IconUserGroup,
  Ye as IconUserGroupOutline,
  Je as IconUserRemoved,
  qe as IconVector,
  _e as IconVectorPen,
  $e as IconVerified,
  ze as IconVerticalConstraints,
  lr as IconVerticalDivider,
  tr as IconVerticalGrid,
  er as IconVerticalPerspective,
  rr as IconVerticalSplit,
  ir as IconVideo,
  nr as IconVideoComponent,
  hr as IconVideoFrame,
  cr as IconVideoLibrary,
  or as IconVideoMask,
  dr as IconVideoTemplate,
  vr as IconVideocam,
  ar as IconVignette,
  ur as IconVignetteOutline,
  wr as IconVimeo,
  sr as IconVimeo3tones,
  gr as IconVimeoColor,
  pr as IconVolumeDown,
  fr as IconVolumeOff,
  mr as IconVolumeUp,
  Zr as IconWarning,
  xr as IconWarningOutline,
  Cr as IconWatch,
  yr as IconWatchOff,
  Ar as IconWebhook,
  Mr as IconWhatsapp,
  Hr as IconWhatsapp3tones,
  Vr as IconWhatsappColor,
  Br as IconWidgets,
  Ir as IconWidth,
  Lr as IconWifi,
  Rr as IconWorkInProgress,
  Sr as IconWrapText,
  Fr as IconWritingDirectionLTR,
  Tr as IconWritingDirectionRTL,
  kr as IconX,
  Dr as IconYoutube,
  Or as IconYoutube3tones,
  br as IconYoutubeColor,
  Pr as IconZip,
  Ur as IconZoom,
  Er as IconZoomInCircle,
  Gr as IconZoomOut,
  Wr as IconZoomOutCircle
};
